/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { createRef, Fragment, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Divider, ExpandCollapse, Modal, Notification, Spacer, Typography } from '@telus-uds/components-web';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import request, {
  isAdmin,
  isOrderFulfillmentTeam,
  isProposalHouse,
  isSalesManager,
  isSalesRep,
  isSalesSupport,
  canSubmitOrders
} from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import { ProgressBar, StatusBar } from '../design';
import FormField from './formField';
import CouponButton from './couponButton';
import {
  normalizedFields,
  calcFieldMonthlyPayment,
  getMultiCheckboxOptions,
  findField,
  getFieldName,
  getFieldValue,
  getFieldType,
  getFieldChecked,
  checkBusinessConnectEdition
} from './utils/formCommon';

import {
  GroupTitle,
  GroupWrapper,
  GroupWrapperStyled,
  SectionHeaderTitle,
  SummaryGroupWrapper
} from './css';
import { Box } from '../design/css';

import {
  CONSTANT,
  orderStatus,
  businessConnectQuoteToolForm,
  contentFulFields,
  fieldAddDevices,
  fieldAdditionalGSuiteBusinessLicences,
  fieldAdditionalTollFreeNumbersNumber,
  fieldAddSpareDevices,
  fieldBAN,
  fieldKANA,
  fieldKANACAR,
  fieldBusinessConnectEdition,
  fieldBusinessConnectEditionWorkplace,
  fieldBusinessIncorporationNumber,
  fieldBusinessType,
  fieldContractStartDate,
  fieldContractTerm,
  fieldCustomerInformation,
  fieldCustomerSegment,
  fieldVulcanOrder,
  fieldDateOfBirth,
  fieldEExistingTelusServices,
  fieldDoesCustomerRequirePrimaryIpDeskPhones,
  fieldDoesCustomerRequireSpareDevices,
  fieldDoesTheCustomerHaveADomainAlready,
  fieldDoesTheCustomerRequireSmartHub,
  fieldDoesTheCustomerRequireWhiteGlove,
  fieldDomainToBeAssociatedWithGSuiteAccount,
  fieldDriversLicenseExpiry,
  fieldDriversLicenseNumber,
  fieldeContractNumber,
  fieldExistingBusinessConnectBANNumber,
  fieldExistingBusinessConnectBANNumberReconnect,
  fieldGSuiteBasicLicences,
  fieldGSuiteEmailMigrationServices,
  fieldGSuiteEmailMigrationServicesPaymentType,
  fieldGSuiteInstallAndSetup,
  fieldHowCustomerWantToPayForWhiteGlove,
  fieldIncorporationDate,
  fieldInternetOffer,
  fieldIsThisAnExistingGSuiteCustomer,
  fieldLegalBusinessNameBusinessPersonal,
  fieldLegalBusinessNameBusinessRegular,
  fieldNumberOfSeatsThatRequireWhiteGlove,
  fieldNumberOfSeatsThatRequireWhiteGloveAI,
  fieldNumberOfTollFreeMinutes,
  fieldOfferConfiguration,
  fieldOfficeSeats,
  fieldOperatingAs,
  fieldOptOutFromGSuiteBusinessLicenses,
  fieldPin,
  fieldPlan,
  fieldMinimumSeats,
  fieldStarterSeat,
  fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
  fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
  fieldTelusBusinessConnectLargeMeetings500NumberOfLicences,
  fieldTelusBusinessConnectLiveReportsNumberOfLicences,
  fieldTelusBusinessConnectRoomConnectorNumberOfLicences,
  fieldTelusBusinessConnectRoomsNumberOfLicences,
  fieldTypeOfInstallation,
  fieldVbpRequired,
  fieldVbpTerm,
  fieldVpbStarterSeatRate,
  fieldWhoIsTheExistingInternetProvider,
  fieldWhoIsTheExistingInternetProviderForOtherState,
  groupDirectoryListing,
  groupVbpOptions,
  keyChannelId,
  keyDevices,
  keyDirectoryListing,
  keyDirectoryListingDetails,
  keyDirectoryListingType,
  keyFeatures,
  keyGSuiteBusinessLicences,
  keyGSuiteComplimentarySeats,
  keyGSuiteEligible,
  keyOfficeSeatRateStandard,
  keyPrimaryDirectoryListingType,
  keySpareDevices,
  keyStarterSeatRateStandard,
  keyWhiteGloveLocations,
  keyDevicesWereChanged,
  paymentTypeEasyPayment,
  paymentTypeUpfront,
  priceSeatsWhiteGloveEasyPayment,
  approvalCodePriceSeatsWhiteGloveEasyPayment,
  priceSeatsWhiteGloveUpfront,
  approvalCodePriceSeatsWhiteGloveUpfront,
  priceSitesWhiteGloveFee,
  TELUS_PROFESSIONAL_INSTALLATION_BAN_NUMBER,
  TELUS_PROFESSIONAL_INSTALLATION_BAN_PRICE,
  quoteStatus,
  sectionAdditionalFeatures,
  sectionDeviceDetails,
  sectionGSuiteDetails,
  sectionWhiteGloveDetails,
  fieldIsThisOrderForAMobileOrVoiceEdition,
  fieldOtherTelusServices,
  fieldIsThisOrderAPartOfTELUSWorkplace,
  fieldAvailableDiscountsAndPromotions,
  fieldCouponBasedDiscountOdysseyAI,
  fieldProfessionalServicesFileCharges,
  fieldProfessionalServicesFileNote,
  fieldProfessionalServicesFile,
  fieldMultisiteOrder,
  fieldMsftDirectRouting,
  fieldDirectoryListing,
  fieldDoesTheCustomerHaveAnExistingInternetConnection,
  fieldVpbOfficeSeatRate,
  orderDetailsForm,
  fieldEmailSigningAuthority,
  fieldEeEnterEmailSigningAuthority,
  fieldPhoneNumberAdministratorContact,
  fieldNumberOfSitesThatRequireWhiteGlove,
  fieldProvinceOfTheOrder,
  fieldDealerNote,
  fieldUploadCustomerReadinessChecklist,
  fieldPostalCodeServiceAddress,
  fieldCustomerAdvisoriesCurrentSpeedNotSupportUsers,
  fieldRsi,
  fieldRsiLicenses,
  fieldAdditionalRsiOptions,
  fieldGenesis,
  fieldGenesisLicenses,
  keyAdditionalRsiOptions,
  keyOutlet,
  fieldYesToAllAdvisories,
  fieldRouterPaymentOption,
  fieldCoperToFibreMigration,
  field5UnlimitedLongDistanceCanUs,
  field10UnlimitedLongDistanceCanUs,
  fieldc2fMigrationSeatPrices,
  fieldBusinessConnectImplementationTollFreeNumber,
  fieldC2fAutomatedActivation,
  fieldIsSrtTeamMember,
  sectionSalesRepInfo,
  sectionNetworkPrequalification,
  allowedChannelsForFourMonthsFreePromo,
  fieldInstallationNote,
  fieldGroupNonC2FFlow,
  fieldNumberOfMultiSites,
  fieldUploadSpeed,
  fieldUploadSpeedForShawOther,
  fieldUploadSpeedForCopperWire,
  fieldUploadSpeedForShawOtherAlbertaAndBritishColumbia,
  fieldWhatIsTheCustomersCurrentStarterSeatPrice,
  fieldWhatIsTheCustomersCurrentOfficeSeatPrice,
  fieldRateChangeApprovedBy,
  fieldRecontractCustomer,
  fieldRecontractChangeEdition,
  fieldRecontractAddSubtractSeats,
  fieldDoesCustomerRequireRouter,
  fieldRecontractSeatsCustomerAdding,
  filedCurrentAddressInSmartDesktop,
  mppOffersOutletIds,
  closingToolOutletIds,
  $100OutletIds,
  readinessChecklistExemptOutletIds,
  fieldNoteVoicePlusRecontract,
  fieldIsTheCustomerPriceChanging,
  fieldWhatIsTheCustomersCurrentPrice,
  fieldWhatIsTheNewStarterSeatPrice,
  fieldWhatIsTheNewOfficeSeatPrice,
  fieldNewPriceNote,
  fieldCustomerInfo,
  fieldBillingAddress,
  fieldServiceAddress,
  fieldPreferredInstallationDate,
  fieldApprovalCodeWhiteGlove,
  filedNeedMoreThanSingleServiceAddress,
  filedNeedMediaAdvertisingBilling,
  filedIsTheirAnyReasonToGoThroughMySOF,
  filedReasonForMySOFOrder,
  BillCreditPromo$70,
  BillCreditPromo$75,
  BillCreditPromo$140,
  Online$100BillCredit,
  CompleteBundled$36,
  CompleteBundled$34,
  CompleteBundled$32,
  CompleteBundled$29,
  CompleteBundledFlat$25,
  BusCon$10OffFor36Months,
  BusCon$10OffFor60Months,
  BusCon$4DiscountOn36Months,
  BusCon$4DiscountOn60Months,
  BusCon$7OffFor36Months,
  BusCon$7OffFor60Months,
  BusCon$5OffFor36Months,
  BusCon$5OffFor60Months,
  CompleteBundled$30,
  EnhancedBundled26_3MF,
  CompleteBundled26_3MF,
  fieldHaveYouArrangedWhiteGloveTechnician,
  fieldWillYourDealershipBePerformingThisWhiteGlove,
  fieldDealershipName,
  fieldDealerFirstName,
  fieldDealerLastName,
  fieldDealerPhoneNumber,
  fieldDealerEmail,
  approvalCodeDealerInstall,
  fieldIsThisAnEContractCustomer,
  fieldProvinceServiceAddress,
  fieldCityServiceAddress,
  fieldIsFibreOpticDrop,
  allowedProvinceQCBundle,
  pureFibreDropEligibleCitiesByProvince,
  CompleteBundledSeat$36,
  CompleteBundleddSeat$34,
  CompleteBundleddSeat$32,
  CompleteBundleddSeat$30,
  CompleteBundleddSeat$29,
  fieldMultisiteOrderOdyssey,
  fieldNumberOfMultiSitesOdyssey,
  fieldUploadSpeedOdyssey,
  fieldUploadSpeedForShawOtherOdyssey,
  fieldUploadSpeedForCopperWireOdyssey,
  fieldUploadSpeedForShawOtherAlbertaAndBritishColumbiaOdyssey,
  c2fDevice24PortApa,
  c2fDeviceUps,
  customerHasMsa,
  fieldCurrentCopperRateOdyssey,
  fieldNewCustomerPriceOdyssey,
  fieldTelusBusinessConnectRooms,
  fieldtelusBusinessConnectRoomConnector,
  fieldTelusBusinessConnectLiveReports,
  fieldTelusBusinessConnectLargeMeetings200,
  fieldLiveReportsOdysseyAI,
  fieldLargeMeetingsOdysseyAI,
  fieldRCIDOdyssey,
  fieldCustomerAdvisoriesAdditionalWiringAndLaborCharges,
  fieldTransferBusinessOwnership,
  fieldLongDistance,
  fieldCustomerAdvisedBusinessConnectOrder,
  fielfirstNameprimaryContact,
  fieldLastNamePrimaryContact,
  fieldPhoneNumberPrimaryContact,
  fieldEmailPrimaryContact,
  primarySalesContact,
  existingBusinessConnectOdysseyBAN,
  ENHANCED_SEAT_PROMO_NON_MULTI_SITE_MAP,
  ENHANCED_SEAT_PROMO_NON_MULTI_SITE,
  ENHANCED_SEAT_PROMO_MULTI_SITE,
  COMPLETE_SEAT_PROMO_NON_MULTI_SITE_MAP,
  COMPLETE_SEAT_PROMO_NON_MULTI_SITE,
  COMPLETE_SEAT_PROMO_MULTI_SITE,
  fieldWLSBusinessConnect,
  fieldPreferredInstallDate,
  fieldPreferredInstallDate1,
  fieldPreferredInstallDate2,
  fieldPreferredInstallDate3,
  fieldPreferredTimePeriod,
  fieldNumberOfLicencesOdyssey,
  telusBusinessLimitedExtensions,
  limitedExtensionOdysseyAIOdysseyAI,
  fieldReceptionistOdysseyAI,
  fieldReceptionistOdysseyAIOdysseyAI,
  fieldInsightsOdysseyAI,
  fieldInsightsOdysseyAIOdysseyAI,
  fieldReceptionistInstall,
  fieldInsightsInstall,
  couponTypeEdition,
  couponTypeInstallation,
  couponTypeBillCredit,
  fieldVbpNumberFreePromotions,
  fieldVbpApprovedCustomOffer,
  fieldVbpApprovalEmailAttachment,
  fieldVbpNumberFreePromotionsCommercial,
  fieldStoreCodeBcon,
  fieldStoreCodeOutletBcon,
  fieldCustomerRequireAIFeatures,
  fieldMigrationGoco,
  fieldToHideInAdditionalfeaturesSectionForOdysseyAi,
  singleSelectChatFields,
  hideChatFieldsForOdysseyAI,
  chatNameTypes,
  hideChatFieldsForNamedOdysseyAI,
  hideChatFieldsForConcurrentOdysseyAI,
  chatConcurrentTypes,
  allAdditionalFeaturesOfOdysseyAIValidationField,
  fieldAssistantAiOdysseyAI,
  fieldAssistantAiOdysseyAIOdysseyAI,
  odysseyAiSupervisorSyncTriggerFields,
  multiUnitDiscountSeatMapping,
  multiUnitDiscountArray,
  fieldSigningEmailAuthority,
  hideAIFeaturesForSMBSegments,
  isOdysseyAiVoicePlusOnlyFieldName,
  clearOdysseyAiVoicePlusOnlyFields
} from '../utils/constant';
import {
  promoDeviceRate,
  hwcPromoDeviceRates,
  rsiLicencesRate,
  genesisLicencesRate,
  ENHANCED_COMPLETE_SEAT_PROMO_RATES,
  editionPriceForOdysseyAI
} from '../utils/rates';
import { isChannelBSEorBSW } from './formSpecificLogic';
import { calculateMaxDevices as calculateMaxPrimaryDevicesCap } from './utils/deviceFiltering';
import { checkHwcAllowance } from './utils/hwcEligibility';
import {
  isZeroSeatAddonAllowed,
  isAiInsightsZeroSeatWarningActive,
  buildPlainTextNote
} from './utils/zeroSeatAddon';
import {
  getTpiTotalSeats,
  isTpiApprovalRequired,
  filterTpiPaymentOptions
} from './utils/tpiRules';
import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import FormSummaryGroup from './formSummaryGroup';
import RepeatedForm from './repeatedForm';
import SeatDetailsForm from './seatDetailsForm';
import FormButtons from './formButtons';
import FormButtonsMultisite from './formButtonsMultiSite';
import stringInterpolation from '../utils/stringInterpolation';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { useLocaleContext } from '../context/LocaleContext';
import { storeCodeOutletMapping, storeCodes } from '../registration/constant';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const seatDetailsFormKey = 'seatDetailsForm';
const profile = request.getProfile();

const FormStep = ({
  stepData,
  steps,
  step,
  updateStep,
  setEligible,
  eligible: prequalEligibility,
  history,
  onFormSubmit,
  onSaveAndExit,
  onSave,
  onViewPdf,
  sendToSRT,
  submitForApproval,
  orderData,
  hideProgressBar,
  setOrderData,
  formName,
  prevStep,
  showFormButtons,
  currentSite,
  isMultisiteOrder,
  totalNumberOfMultisites
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const local = useLocaleContext();

  // SOF-3356 T025 — defence-in-depth mount guard for order-creation routes.
  // Primary UX is dashboard tile suppression in form/index.js (T023). This
  // useEffect catches direct-URL / bookmark / browser-history navigation by
  // SMs without order access. Per Clarifications 2026-04-28: window.alert +
  // history.push('/') only — NO UDS toast / banner / modal.
  //
  // Phase 9 T054: Skip the alert+redirect on the BCx prequal landing
  // (`businessConnectQuoteToolForm`) — SMs without order access are now
  // allowed there to view the SOV / My Orders listing tabs (the inner
  // prequalification section + "New Order" CTA gates suppress the create
  // UI). The guard still fires on `orderDetailsForm` (the actual order
  // entry surface reached via direct-URL replay).
  useEffect(() => {
    if (
      isSalesManager &&
      !canSubmitOrders() &&
      formName !== businessConnectQuoteToolForm
    ) {
      const deniedMessage = _.get(
        local === 'en-US' ? EN : FR,
        'USERS.FORM.MESSAGE.SALES_MANAGER_ORDER_ACCESS_DENIED',
        'You do not have permission to submit orders. Please contact your administrator.'
      );
      // eslint-disable-next-line no-alert
      window.alert(deniedMessage);
      history.push('/');
    }
  }, []);
  const { 
    contentfulValues: { valueQuebec } = {},
    ODYSSEY_AI_PROMOTIONS,
    ODYSSEY_AI_PROMOTIONS_NON_COMMERCIAL = {}
  } = local === 'en-US' ? EN : FR;
  const allOdysseyAIPromos = _.uniq([
    ...Object.values(ODYSSEY_AI_PROMOTIONS),
    ...Object.values(ODYSSEY_AI_PROMOTIONS_NON_COMMERCIAL)
  ]);
  const {
    ORDERS: { internetOfferTelus, internetOfferOther },
    sendFoApprovalModal,
    sendToSRTModal,
    contentfulValues: {
      valueYesLookingToAddSeats,
      valueYesLookingToSubrtactSeats,
      valueTelusProfessionalInstallation,
      valueTelusVirtualInstallation,
      valueNoInstall,
      yes,
      no,
      valueAlberta,
      valueBritishColumbia,
      valueOntario,
      valueNorthwestTerritories,
      valueYukon,
      valueNunavut,
      mobile,
      valueNew,
      valueAddon,
      valueNinetyNineCentDevicePromo,
      valueCrossSellCredit,
      valueHardwareCreditPromo,
      valueThreeMonthsFree,
      valueBusinessConnectEnhancedClosingTool,
      valueFourMonthsFree,
      valueMppPromo,
      value$100BillCreditWithBusinessWifi,
      valueEnhancedPromoAvailable,
      valueMppEnhancedPromoAvailable,
      valueCbmEnhancedPromoAvailable,
      valueInstallationCoTurndownPromo,
      valueBusinessHeroPromo,
      valueVoicePlusPromo,
      valueVirtualInstallPromo,
      valueBravadVirtualInstallPromo,
      valueOneTime50BillCredit,
      valueEasyPayment,
      valuePaymentUpfront,
      businessRegular,
      businessPersonal,
      telusCopperNew,
      threeYears,
      fiveYears,
      monthToMonth,
      devicePolycomVVX250,
      deviceCisco7841,
      devicePolycomVVX250Promo,
      deviceCisco7841Promo,
      valueDealerBilledDirect,
      valueSegmentSmb1To30,
      valueSegmentCommercial,
      valueSegmentSmb30To100,
      devicePolycomVVX150,
      devicePolycomVVX150HWC,
      devicePolyEdgeE220,
      devicePolyEdgeE220HWC,
      deviceYealinkT48U,
      deviceYealinkT48UOld,
      deviceYealinkT48UHWC,
      deviceYealinkT34W,
      deviceYealinkT34WOld,
      deviceYealinkT34WHWC,
      deviceYealinkT33G,
      deviceYealinkT33GOld,
      deviceYealinkT33GHWC,
      devicePolyEdgeE100,
      devicePolyEdgeE100Old,
      devicePolyEdgeE100HWC,
      deviceYealinkT53WHWC,
      editionMapping: { enhanced, complete, voicePlus, voice, completePlus },
      other,
      labelNewContractTerm,
      labelRecontractStartDate,
      labelNewBusinessConnectEdition,
      labelCurrentBusinessConnectEdition,
      labelUpdatedTotalNumberOfSeats,
      labelCurrentNumberOfSeats
    },
    formButtons: {
      confirmButtonLabel,
      cancelButtonLabel,
      newOrderButtonLabel,
      editButtonLabel,
      submittingButtonLabel
    },
    summaryForm: { summaryLabel },
    formStep: {
      maxDevicesErrorMessage,
      maxHwcDevicesErrorMessage,
      minDevicesErrorMessage,
      minSpareDevicesErrorMessage,
      smartDesktopErrorMessage,
      minValueErrorMessage,
      maxValueErrorMessage,
      maxCombinedErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage,
      maxTotalSeatsMessage,
      maxTotalSeatsLessMessage,
      pinNotStartWithZero,
      pinNotBeRepetitive,
      pinNotBeSequential,
      emailDoenotMatch,
      invalidNumber
    },
    modalForm: { fieldRequiredMessage, cannotProceedMessage },
    quoteForm,
    features: { gSuiteNote, gSuiteNote2, customerRequiresDomainName },
    multisite: { siteLabel, summaryLabel: multisiteSummaryLabel },
    ODYSSEY_AI: {
      validationErrorTwo,
      validationErrorThree,
      insightsZeroSeatsWarning
    }
  } = localizedStrings;
  const {
    KEYS: {
      CHANNELS: {
        DEALER,
        SMB_INDIRECT_SALES_OTHER,
        SMB_INDIRECT_SALES_TAG,
        SMB_INDIRECT_SALES_ELITE_PROMOTIONS,
        SMB_INDIRECT_SALES_CORPO_SOLUTION,
        SMB_INDIRECT_SALES_CBTELECOM,
        SMB_INDIRECT_SALES_IDS,
        SMB_INDIRECT_SALES_MSG_CONSULTING,
        SMB_INDIRECT_SALES_CONNEXION_FK,
        SMB_INDIRECT_SALES_REVOLVE,
        SMB_INDIRECT_SALES_GET_INSTINCTIVE,
        SMB_INDIRECT_SALES_TOPS_TECH,
        SMB_INDIRECT_SALES_OUTPUT,
        SMB_INDIRECT_SALES_ATMOS_MANAGEMENT,
        SMB_INDIRECT_SALES_KOLLABB,
        SMB_INDIRECT_SALES_UP_SYSTEMS,
        SMB_INDIRECT_SALES_WATCHDOG,
        CORP_STORE,
        BCX
      },
      DEALERSHIPS: { BRAVAD_TECHNOLOGIE }
    }
  } = CONSTANT;

  // Error messages

  const msgMaxDevices = value =>
    stringInterpolation(maxDevicesErrorMessage, value);
  const msgMaxHwcDevices = value =>
    stringInterpolation(maxHwcDevicesErrorMessage, value);
  const msgMinValue = value => stringInterpolation(minValueErrorMessage, value);
  const msgMaxValue = value => stringInterpolation(maxValueErrorMessage, value);
  const msgMaxCombinedValue = value =>
    stringInterpolation(maxCombinedErrorMessage, value);
  const msgMinLength = value =>
    stringInterpolation(minLengthErrorMessage, value);
  const msgMaxLength = value =>
    stringInterpolation(maxLengthErrorMessage, value);

  if (!stepData) return null;
  const {
    fields: { name: formStepName, formStepFields, formSummary, modalForms }
  } = stepData;
  const [isLoading, setIsLoading] = useState(true);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormValidated, setIsFormValidated] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [formErrorSummary, setFormErrorSummary] = useState('');
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [dueMonthly, setDueMonthly] = useState(0);
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  const [fieldsWithValue, setFieldsWithValue] = useState();
  const [rates, setRates] = useState({
    [keyStarterSeatRateStandard]: 0,
    [keyOfficeSeatRateStandard]: 0,
    starterSeat: 0,
    officeSeats: 0,
    baseStarter: 0,
    baseOffice: 0
  });
  const [priceSeatsWhiteGlove, setPriceSeatsWhiteGlove] = useState({
    dueNow: 0,
    dueMonthly: 0
  });
  const [isVBP, setIsVBP] = useState(false);
  const [modalData, setModalData] = useState({
    title: '',
    body: '',
    confirmText: confirmButtonLabel,
    cancelText: cancelButtonLabel,
    open: false
  });
  const [priceFeatures, setPriceFeatures] = useState(0);
  const [priceGSuite, setPriceGSuite] = useState({
    price: 0,
    monthlyPayment: 0
  });
  const [isFieldReset, setIsFieldReset] = useState(false);
  const [billCredit70Applied, setBillCredit70Applied] = useState(0);
  const [billCredit75Applied, setBillCredit75Applied] = useState(0);
  const [billCredit140Applied, setBillCredit140Applied] = useState(0);
  const [odysseyAIPromotionApplied, setOdysseyAIPromotionApplied] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formStepRef = createRef();
  // User roles logic
  const userProfile = request.getProfile();
  const { channels } = userProfile;
  const userChannel = channels && channels.length > 0 ? channels[0] : {};
  const { name: userChannelName } = userChannel;
  const isSendToSRT = false;
  const isAdminFlow =
    (isAdmin || isOrderFulfillmentTeam) && formName === orderDetailsForm;
  const isSalesSupportFlow =
    isSalesSupport && formName === businessConnectQuoteToolForm && step === 1;
  const channelCode = _.get(orderData, 'channelCode', '');
  const dealership = _.get(orderData, 'Dealership.name', '');
  const outletId = _.get(userProfile, 'outlet', 0);
  /** All Indirect Sales channel */

  const isVarAgent =
    isSalesRep &&
    [
      SMB_INDIRECT_SALES_OTHER,
      SMB_INDIRECT_SALES_TAG,
      SMB_INDIRECT_SALES_ELITE_PROMOTIONS,
      SMB_INDIRECT_SALES_CORPO_SOLUTION,
      SMB_INDIRECT_SALES_CBTELECOM,
      SMB_INDIRECT_SALES_IDS,
      SMB_INDIRECT_SALES_MSG_CONSULTING,
      SMB_INDIRECT_SALES_CONNEXION_FK,
      SMB_INDIRECT_SALES_REVOLVE,
      SMB_INDIRECT_SALES_GET_INSTINCTIVE,
      SMB_INDIRECT_SALES_TOPS_TECH,
      SMB_INDIRECT_SALES_OUTPUT,
      SMB_INDIRECT_SALES_ATMOS_MANAGEMENT,
      SMB_INDIRECT_SALES_KOLLABB,
      SMB_INDIRECT_SALES_UP_SYSTEMS,
      SMB_INDIRECT_SALES_WATCHDOG
    ].includes(channelCode);

  const isDealer = channelCode === DEALER;
  const isUserProfileChannelDealer = userChannelName === DEALER;
  const isBCX = channelCode === BCX;
  const isCorpStore = channelCode === CORP_STORE;

  const isDealerShipBravad = dealership === BRAVAD_TECHNOLOGIE;

  const isRecontractFlow =
    _.get(orderData, fieldRecontractCustomer, '') === yes;

  const isc2fMigrationFlow =
    _.get(orderData, fieldCoperToFibreMigration, '') === yes;
  const isThisMobileEditionOrder =
    _.get(orderData, fieldIsThisOrderForAMobileOrVoiceEdition, '') === yes;
  const valueCoperToFibreMigration =
    _.get(orderData, fieldCoperToFibreMigration, '') === yes;
  const valueWLSBusinessConnect =
    getFieldValue(fieldWLSBusinessConnect, formFields) ||
    _.get(orderData, fieldWLSBusinessConnect, []);

  const valueIsEContractCustomer =
    getFieldValue(fieldIsThisAnEContractCustomer, formFields) ||
    _.get(orderData, fieldIsThisAnEContractCustomer, []);

  const valueNeedMoreThanSingleServiceAddress =
    getFieldValue(filedNeedMoreThanSingleServiceAddress, formFields) ||
    _.get(orderData, filedNeedMoreThanSingleServiceAddress, []);

  const valueNeedMediaAdvertisingBilling =
    getFieldValue(filedNeedMediaAdvertisingBilling, formFields) ||
    _.get(orderData, filedNeedMediaAdvertisingBilling, []);

  const isRecontractFlowAi =
    getFieldValue(fieldRecontractCustomer, formFields) ||
    _.get(orderData, fieldRecontractCustomer, '');

  const valueVulcanOrderAi =
    getFieldValue(fieldVulcanOrder, formFields) ||
    _.get(orderData, fieldVulcanOrder, '');

  const valueCoperToFibreMigrationAi =
    getFieldValue(fieldCoperToFibreMigration, formFields) ||
    _.get(orderData, fieldCoperToFibreMigration, '');

  const valueCustomerRequireAIFeatures =
    getFieldValue(fieldCustomerRequireAIFeatures, formFields) ||
    _.get(orderData, fieldCustomerRequireAIFeatures, '');

  const valueMigrationGoco =
    getFieldValue(fieldMigrationGoco, formFields) ||
    _.get(orderData, fieldMigrationGoco, '');

  const isAllValuesNoOdyssey = [
    valueIsEContractCustomer,
    valueNeedMoreThanSingleServiceAddress,
    valueNeedMediaAdvertisingBilling,
    valueWLSBusinessConnect
  ].every(value => value === no);

  const isThisOdysseyAIOrder =
    valueCustomerRequireAIFeatures === yes &&
    (valueVulcanOrderAi === yes ||
     (valueVulcanOrderAi === no &&
      valueCoperToFibreMigrationAi === no &&
      valueMigrationGoco === no &&
      (isRecontractFlowAi === no || userChannelName === 'Dealer')));

  const isOdysseyAiChatOrContactCentreLineSelected = flds =>
    singleSelectChatFields.some(fieldId => {
      const cell = flds && flds[fieldId];
      return !!(cell && cell.checked);
    });

  const gSuiteMigrateUsersPrice = 400;
  const gSuiteMigrateUsersNowPrice = 100;
  const gSuiteMigrateUsersMonthlyPrice = 10;
  const gSuiteInstallAndSetupPrice = 50;
  const isGSuiteOk = amount => amount > 0 && amount < 10;

  // Seat Rates
  const [ratesStarterSeat, setRatesStarterSeat] = useState();
  const [ratesOfficeSeats, setRatesOfficeSeats] = useState();
  const [cbmPromoPostalCodeList, setCbmPromoPostalCodeList] = useState([]);
  const isLastStep = step === steps.length;
  const isSecondLastStep = step === steps.length - 1;
  const [multiSiteOrderSummaryData, setMultiSiteOrderSummaryData] = useState();

  useEffect(() => {
    const config = {
      ...contentfulFormConfig,
      content_type: 'seatRates'
    };
    getContentfulData(config)
      .then(res => {
        const {
          starterSeatRates,
          officeSeatRates,
          cbmPromoPostalCodeList: postalCodeList
        } = getData(res);
        setRatesStarterSeat(starterSeatRates);
        setRatesOfficeSeats(officeSeatRates);
        setCbmPromoPostalCodeList(postalCodeList);
      })
      .catch(() => {});
  }, []);

  const editionCoupons = useMemo(() =>
      appliedCoupons.filter(c => c.couponType.toLowerCase().includes(couponTypeEdition)),
    [appliedCoupons]
  );

  const installationCoupons = useMemo(() =>
     appliedCoupons.filter(c => c.couponType.toLowerCase().includes(couponTypeInstallation)),
     [appliedCoupons]
   );
   
   // Bill credit applies to the first site only. On subsequent sites of a
   // multisite order, exclude bill credit from pricing/totals WITHOUT removing
   // it from the persisted `appliedCoupons` (which is shared with site 1 and
   // must not be stripped). The quote PDF filters bill credit out of child site
   // sections on the backend, and the coupon button is hidden on sites > 1.
   const billCreditCoupons = useMemo(() => 
     isMultisiteOrder && currentSite > 1
       ? []
       : appliedCoupons.filter(c => c.couponType.toLowerCase().includes(couponTypeBillCredit)),
     [appliedCoupons, isMultisiteOrder, currentSite]
   );

  const getOdysseyProfessionalServicesFileChargesNow = fields => {
    if (!isThisOdysseyAIOrder) return 0;
    const raw = getFieldValue(fieldProfessionalServicesFileCharges, fields);
    const n = Number(raw);
    return Number.isNaN(n) || n < 0 ? 0 : n;
  };

  // Function to check if coupon-related form fields changed and return affected coupon IDs
  const checkCouponFieldChanges = (changedFieldName) => {
    if (!appliedCoupons || appliedCoupons.length === 0) {
      return [];
    }

    // Only check coupon-related field changes on site 1 for multi-site orders
    // Coupons are only applied on site 1, so changes on other sites shouldn't affect them
    if (isMultisiteOrder && currentSite > 1) {
      return [];
    }

    const couponAffectingFields = [
      'customerSegment',
      'contractTerm', 
      'businessConnectEdition',
      'doesTheCustomerRequireWhiteGlove',
      'typeOfInstallation',
      'provinceOfTheOrder',
      'multisiteOrder',
      'otherTelusServices',
      'starterSeat',
      'officeSeats',
      'minimumSeats',
      'howCustomerWantToPayForWhiteGlove'
    ];

    // Check if the changed field affects coupons
    if (!couponAffectingFields.includes(changedFieldName)) {
      return [];
    }

    const affectedCouponIds = [];

    appliedCoupons.forEach(coupon => {
      const couponAnswers = coupon.answers || {};
      
      // Map form field names to coupon answer keys (using original BCON field names)
      const fieldToAnswerKey = {
        'customerSegment': 'customerSegment',
        'contractTerm': 'contractTerm',
        'businessConnectEdition': 'businessConnectEdition',
        'doesTheCustomerRequireWhiteGlove': 'doesTheCustomerRequireWhiteGlove',
        'typeOfInstallation': 'typeOfInstallation',
        'provinceOfTheOrder': 'provinceOfTheOrder',
        'multisiteOrder': 'multisiteOrder',
        'otherTelusServices': 'otherTelusServices',
        'starterSeat': 'minimumSeats',
        'officeSeats': 'minimumSeats',
        'minimumSeats': 'minimumSeats',
        'howCustomerWantToPayForWhiteGlove': 'howCustomerWantToPayForWhiteGlove'
      };

      const answerKey = fieldToAnswerKey[changedFieldName];
      if (answerKey && couponAnswers[answerKey]) {
        affectedCouponIds.push(coupon.couponCode);
      }
      
      // For installation coupons, also check if duration matches payment type
      // This handles the case where installation coupons don't have the field in answers
      // but are validated based on duration matching payment type
      if (changedFieldName === 'howCustomerWantToPayForWhiteGlove') {
        const couponType = (coupon.coupon && coupon.coupon.couponType) || coupon.couponType || '';
        if (couponType.toLowerCase().includes('installation')) {
          affectedCouponIds.push(coupon.couponCode);
        }
      }
    });

    return affectedCouponIds;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;

    return id === formSection;
  });

  const isFieldInGroup = (data, fieldName, groupName) => {
    let result = false;
    let i = 0;

    while (data && i < data.length && !result) {
      const {
        sys: {
          contentType: {
            sys: { id }
          }
        },
        fields: { name }
      } = data[i];

      if (id === formSection) {
        result = isFieldInGroup(
          data[i].fields.formFields,
          fieldName,
          groupName
        );
      } else if (id === formFieldsGroup && name === groupName) {
        const isFound = data[i].fields.fields.find(
          item => item.fields.name === fieldName
        );
        result = typeof isFound !== 'undefined';
      }
      i += 1;
    }

    return result;
  };

  const maxDevices = (fields, isCheckForPrimary = true) => {
    if (isRecontractFlow && isCheckForPrimary) {
      const valueRecontractAddSubtractSeats = getFieldValue(
        fieldRecontractAddSubtractSeats,
        fields
      );

      if (valueRecontractAddSubtractSeats === valueYesLookingToAddSeats) {
        const valueRecontractSeatsCustomerAdding = getFieldValue(
          fieldRecontractSeatsCustomerAdding,
          fields
        );

        return +valueRecontractSeatsCustomerAdding;
      }
    }
    return calculateMaxPrimaryDevicesCap(fields, orderData);
  };

  const maxTotalDevices = maxDevices(formFields, false) * 4;

  // Same recontract seat basis that maxDevices() applies to the total device cap
  const getHwcAllowanceCheck = fields => {
    const isAddingSeatsOnRecontract =
      isRecontractFlow &&
      getFieldValue(fieldRecontractAddSubtractSeats, fields) ===
        valueYesLookingToAddSeats;

    return checkHwcAllowance(
      fields,
      orderData,
      { valuePaymentUpfront },
      {
        allowanceOverride: isAddingSeatsOnRecontract
          ? +getFieldValue(fieldRecontractSeatsCustomerAdding, fields)
          : undefined
      }
    );
  };

  const gSuiteBusinessLicences = fields => {
    const result = Math.round(maxDevices(fields) * 0.8);
    const maxValue = 500;
    return result > maxValue ? maxValue : result;
  };

  const isFieldGSuiteInstallAndSetupDisabled = fields => {
    const amountX = gSuiteBusinessLicences(fields);
    const amountBusiness = +fields[fieldAdditionalGSuiteBusinessLicences].value;
    const amountBasic = +_.get(fields, 'fieldGSuiteBasicLicences.value', 0);

    return amountX + amountBusiness + amountBasic > 400;
  };

  // Spec 034 US5: on TPI orders the TELUS Professional Installation group's
  // "Preferred install date" replaces "Please indicate a preferred installation date".
  const isPreferredInstallationDateReplaced = fields =>
    !!fields &&
    !!fields[fieldPreferredInstallationDate] &&
    !!fields[fieldPreferredInstallDate] &&
    !isAllValuesNoOdyssey &&
    _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
      valueTelusProfessionalInstallation;

  const customChecks = (fieldName, fields) => {
    const valueTypeOfInstallation =
      getFieldValue(fieldTypeOfInstallation, formFields) ||
      _.get(orderData, fieldTypeOfInstallation, '');
    const valueContractTerm = getFieldValue(fieldContractTerm, formFields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, formFields);
    const valueDirectoryListing = _.get(orderData, fieldDirectoryListing, []);
    const valueRecontractCustomer = getFieldValue(
      fieldRecontractCustomer,
      fields
    );
    const valueVulcanOrder = getFieldValue(fieldVulcanOrder, fields);
    const valueC2FMigration = getFieldValue(
      fieldCoperToFibreMigration,
      formFields
    );
    const valueProvince = getFieldValue(fieldProvinceOfTheOrder, formFields);
    const valueStarterSeat = +getFieldValue(fieldStarterSeat, fields) || 0;
    const valueIsWorkPlaceOrder = getFieldValue(
      fieldIsThisOrderAPartOfTELUSWorkplace,
      fields
    );
    const valueIsVulcanOrder = getFieldValue(fieldVulcanOrder, fields);
    const valueUploadSpeed = [
      fieldUploadSpeed,
      fieldUploadSpeedForShawOther,
      fieldUploadSpeedForCopperWire,
      fieldUploadSpeedForShawOtherAlbertaAndBritishColumbia
    ].reduce((acc, field) => getFieldValue(field, fields) || acc, '');
    const valueUploadSpeedOdyssey = [
      fieldUploadSpeedOdyssey,
      fieldUploadSpeedForShawOtherOdyssey,
      fieldUploadSpeedForCopperWireOdyssey,
      fieldUploadSpeedForShawOtherAlbertaAndBritishColumbiaOdyssey
    ].reduce((acc, field) => getFieldValue(field, fields) || acc, '');

    const valueRecontractChangeEdition =
      getFieldValue(fieldRecontractChangeEdition, fields) ||
      _.get(orderData, fieldRecontractChangeEdition, []);

    const valueRecontractAddSubtractSeats =
      getFieldValue(fieldRecontractAddSubtractSeats, fields) ||
      _.get(orderData, fieldRecontractAddSubtractSeats, []);

    /**
     * MSFT Routing Feature Check
     */
    if (fieldName === fieldMsftDirectRouting && !isRecontractFlow) {
      // When an order is resumed, formFields only holds the current step's
      // fields, so earlier-step answers must come from the saved order data.
      const msftContractTerm =
        valueContractTerm || _.get(orderData, fieldContractTerm, '');
      const msftEdition =
        valueEdition || _.get(orderData, fieldBusinessConnectEdition, '');
      const msftC2FMigration =
        valueC2FMigration || _.get(orderData, fieldCoperToFibreMigration, '');

      if (
        !(
          [threeYears, fiveYears].includes(msftContractTerm) &&
          msftEdition !== mobile &&
          msftC2FMigration === no
        )
      )
        return false;
    }

    if (fieldName === filedCurrentAddressInSmartDesktop && !isRecontractFlow)
      return false;

    if (
      !isRecontractFlow &&
      fieldName === fieldExistingBusinessConnectBANNumberReconnect
    )
      return null;

    const valueVulcanOrderYes = getFieldValue(fieldVulcanOrder, formFields);

    if (fieldName === 'migrationGoco') {
      if ([yes].includes(valueVulcanOrderYes) || fieldName === fieldVulcanOrder)
        return null;
    }

    if (
      fieldName === fieldRecontractCustomer &&
      valueIsVulcanOrder !== no
    )
      return null;
    const valueWLSBusinessConnect =
      getFieldValue(fieldWLSBusinessConnect, formFields) ||
      _.get(orderData, fieldWLSBusinessConnect, []);

    const valueIsEContractCustomer =
      getFieldValue(fieldIsThisAnEContractCustomer, formFields) ||
      _.get(orderData, fieldIsThisAnEContractCustomer, []);

    const valueNeedMoreThanSingleServiceAddress =
      getFieldValue(filedNeedMoreThanSingleServiceAddress, formFields) ||
      _.get(orderData, filedNeedMoreThanSingleServiceAddress, []);

    const valueNeedMediaAdvertisingBilling =
      getFieldValue(filedNeedMediaAdvertisingBilling, formFields) ||
      _.get(orderData, filedNeedMediaAdvertisingBilling, []);

    const isAllValuesNoOdyssey = [
      valueIsEContractCustomer,
      valueNeedMoreThanSingleServiceAddress,
      valueNeedMediaAdvertisingBilling,
      valueWLSBusinessConnect
    ].every(value => value === no);
    if (
      // fieldName === filedIsTheirAnyReasonToGoThroughMySOF ||
      fieldName === filedReasonForMySOFOrder
    ) {
      if (
        [
          valueIsEContractCustomer,
          valueNeedMoreThanSingleServiceAddress,
          valueNeedMediaAdvertisingBilling,
        ].some(value => value === yes)
      ) {
        return false;
      }
    }
    
    /**
     * Customer Require AI Features Field Visibility
     * Show for Vulcan orders OR non-Vulcan orders without C2F/GOCO migrations
     */
    if (fieldName === fieldCustomerRequireAIFeatures) {
      const valueVulcanOrder = getFieldValue(fieldVulcanOrder, fields);
      const valueC2FMigration = getFieldValue(fieldCoperToFibreMigration, fields);
      const valueMigrationGoco = getFieldValue(fieldMigrationGoco, fields);
      
      // Show for Vulcan orders
      if (valueVulcanOrder === yes) {
        return true;
      }
      
      // Show for non-Vulcan orders only if C2F and GOCO are No
      if (valueVulcanOrder === no && 
          valueC2FMigration === no && 
          valueMigrationGoco === no) {
        return true;
      }
      
      // Hide in all other cases
      return false;
    }

    if (
      fieldName === fieldProfessionalServicesFileCharges ||
      fieldName === fieldProfessionalServicesFileNote ||
      fieldName === fieldProfessionalServicesFile
    ) {
      if (!isThisOdysseyAIOrder) return false;
      if (!isOdysseyAiChatOrContactCentreLineSelected(fields)) return false;
    }
    
    /**
     * RSI & Genesis Feature Check
     */
    if (
      [fieldRsi, fieldGenesis].includes(fieldName) &&
      !(valueTypeOfInstallation === valueNew && valueC2FMigration === no) &&
      !isRecontractFlow
    )
      return false;

    if (
      fieldName === groupDirectoryListing &&
      valueDirectoryListing.length === 0
    )
      return false;

    if (fieldName === fieldDirectoryListing && isMultisiteOrder)
      return (
        [valueAlberta, valueBritishColumbia].includes(valueProvince) &&
        valueStarterSeat === 1
      );

    if (
      fieldName === fieldContractStartDate &&
      (isThisMobileEditionOrder || isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    )
      return false;

    if (fieldName === fieldMinimumSeats) {
      // Show only on site 1 of multisite orders — this field captures total seats across all sites.
      return isMultisiteOrder && currentSite === 1;
    }

    if ([fieldMultisiteOrder, fieldNumberOfMultiSites].includes(fieldName)) {
      if (
        valueIsWorkPlaceOrder !== yes &&
        !valueUploadSpeed > 0
      )
        return false;
    }
    if (
      [fieldMultisiteOrderOdyssey, fieldNumberOfMultiSitesOdyssey].includes(
        fieldName
      )
    ) {
      if (!valueUploadSpeedOdyssey > 0) return false;
    }
    if (fieldName === c2fDevice24PortApa && isAllValuesNoOdyssey) {
      return false;
    }
    if (fieldName === c2fDeviceUps && isAllValuesNoOdyssey) {
      return false;
    }
    if (fieldName === fieldDoesCustomerRequireRouter && isAllValuesNoOdyssey) {
      return false;
    }
    if (
      fieldName === fieldTransferBusinessOwnership &&
      (isAllValuesNoOdyssey || valueCoperToFibreMigration || isThisOdysseyAIOrder)
    ) {
      return false;
    }
    if (
      fieldName === fieldOtherTelusServices &&
      (isAllValuesNoOdyssey || valueCoperToFibreMigration)
    ) {
      return false;
    }
    if (
      fieldName === fieldLongDistance &&
      (isAllValuesNoOdyssey || valueCoperToFibreMigration)
    ) {
      return false;
    }
    if (
      fieldName === customerHasMsa &&
      (isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    ) {
      return false;
    }
    if (fieldName === fieldc2fMigrationSeatPrices && isAllValuesNoOdyssey) {
      return false;
    }
    if (fieldName === fieldCurrentCopperRateOdyssey && !isAllValuesNoOdyssey) {
      return false;
    }
    if (fieldName === fieldNewCustomerPriceOdyssey && !isAllValuesNoOdyssey) {
      return false;
    }
    if (fieldName === fieldTelusBusinessConnectRooms && isAllValuesNoOdyssey) {
      return false;
    }
    if (
      fieldName === fieldtelusBusinessConnectRoomConnector &&
      isAllValuesNoOdyssey
    ) {
      return false;
    }
    if (
      fieldName === fieldPreferredInstallDate &&
      isAllValuesNoOdyssey
    ) {
      return false;
    }
    if (
      fieldName === fieldNumberOfLicencesOdyssey &&
      !isAllValuesNoOdyssey
    ) {
      return false;
    }
    if (fieldName === telusBusinessLimitedExtensions && !isAllValuesNoOdyssey) {
      return false;
    }
    if (
      (fieldName === fieldPreferredInstallDate1 || 
       fieldName === fieldPreferredInstallDate2 || 
       fieldName === fieldPreferredInstallDate3 || 
       fieldName === fieldPreferredTimePeriod) &&
      (!isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    ) {
      return false;
    }    
    if (
      fieldName === fieldTelusBusinessConnectLiveReports &&
      (isAllValuesNoOdyssey || valueEdition === voicePlus)
    ) {
      formFields[fieldTelusBusinessConnectLiveReports].isRequired = false;
      if (formFields[fieldTelusBusinessConnectLiveReports].checked) {
        formFields[fieldTelusBusinessConnectLiveReports].checked = false;
      }

      return false;
    }
    if (
      fieldName === fieldTelusBusinessConnectLargeMeetings200 &&
      (isAllValuesNoOdyssey || valueEdition === voicePlus)
    ) {
      formFields[fieldTelusBusinessConnectLargeMeetings200].isRequired = false;
      if (formFields[fieldTelusBusinessConnectLargeMeetings200].checked) {
        formFields[fieldTelusBusinessConnectLargeMeetings200].checked = false;
      }

      return false;
    }

    if (
      [fieldLiveReportsOdysseyAI, fieldLargeMeetingsOdysseyAI].includes(fieldName) &&
      isThisOdysseyAIOrder &&
      valueEdition === voicePlus
    ) {
      if (formFields[fieldName]) {
        formFields[fieldName].isRequired = false;
        if (formFields[fieldName].checked) {
          formFields[fieldName].checked = false;
        }
      }
      return false;
    }

    if (
      fieldToHideInAdditionalfeaturesSectionForOdysseyAi.includes(fieldName) &&
      isThisOdysseyAIOrder
    ) {
      if(formFields[fieldName]){
        formFields[fieldName].isRequired = false;
      }
      return false;
    }

    // Hide AI features for SMB 1-30 and SMB 30-100 segments (only show AI Receptionist and AI Insights)
    if (
      hideAIFeaturesForSMBSegments.includes(fieldName) &&
      isThisOdysseyAIOrder
    ) {
      const valueSegment = _.get(orderData, fieldCustomerSegment, '');
      if ([valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)) {
        if (formFields[fieldName]) {
          formFields[fieldName].isRequired = false;
        }
        return false;
      }
    }

    if (
      fieldName === fieldPin &&
      (isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    ) {
      formFields[fieldPin].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldNumberOfSitesThatRequireWhiteGlove &&
      isAllValuesNoOdyssey
    ) {
      formFields[fieldNumberOfSitesThatRequireWhiteGlove].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldPreferredInstallationDate &&
      isAllValuesNoOdyssey
    ) {
      formFields[fieldPreferredInstallationDate].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldPreferredInstallationDate &&
      isPreferredInstallationDateReplaced(fields || formFields)
    ) {
      if (formFields[fieldPreferredInstallationDate])
        formFields[fieldPreferredInstallationDate].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldBusinessType &&
      (isAllValuesNoOdyssey)
    ) {
      formFields[fieldBusinessType].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldRCIDOdyssey &&
      !isAllValuesNoOdyssey &&
      !isThisOdysseyAIOrder
    ) {
      formFields[fieldRCIDOdyssey].isRequired = false;
      return false;
    }
    if (fieldName === fielfirstNameprimaryContact && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      formFields[fielfirstNameprimaryContact].isRequired = false;
      return false;
    }
    if (fieldName === fieldLastNamePrimaryContact && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      formFields[fieldLastNamePrimaryContact].isRequired = false;
      return false;
    }
    if (fieldName === fieldPhoneNumberPrimaryContact && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      formFields[fieldPhoneNumberPrimaryContact].isRequired = false;
      return false;
    }
    if (fieldName === fieldEmailPrimaryContact && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      formFields[fieldEmailPrimaryContact].isRequired = false;
      return false;
    }
    if (
      fieldName === fieldCustomerAdvisoriesAdditionalWiringAndLaborCharges &&
      (isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    ) {
      formFields[
        fieldCustomerAdvisoriesAdditionalWiringAndLaborCharges
      ].isRequired = false;

      return false;
    }
    if (
      fieldName === fieldCustomerAdvisedBusinessConnectOrder &&
      !isAllValuesNoOdyssey
    ) {
      formFields[fieldCustomerAdvisedBusinessConnectOrder].isRequired = false;
      return false;
    }
    if (
      [
        fieldMultisiteOrder,
        fieldNumberOfMultiSites,
        fieldDoesTheCustomerHaveAnExistingInternetConnection,
        fieldWhoIsTheExistingInternetProviderForOtherState,
        fieldUploadSpeedForShawOtherAlbertaAndBritishColumbia
      ].includes(fieldName) &&
      valueC2FMigration === yes
    )
      return false;
    if (
      fieldName === fieldCustomerSegment &&
      valueC2FMigration !== no &&
      valueRecontractCustomer !== yes &&
      valueVulcanOrder !== yes
    )
      return false;
    if (
      fieldName === fieldProvinceOfTheOrder &&
      fieldVulcanOrder === yes &&
      ((valueRecontractCustomer !== yes && valueC2FMigration === '') ||
        (valueRecontractCustomer === no && valueC2FMigration === ''))
    )
      return false;

    if (
      [
        fieldTypeOfInstallation,
        fieldDoesCustomerRequireRouter,
        fieldAvailableDiscountsAndPromotions,
        fieldVbpRequired,
        fieldKANA,
        fieldKANACAR,
        fieldBAN,
        fieldPin,
        fieldDirectoryListing,
        'preferredInstallationDate',
        'managedInternetProductsSold',
        'customerNeedCanadaDataLocalization',
        'customerRequireActiveDirectoryIntegration',
        'clientRequireBulkDeviceUpdate',
        'customerPortingNumbersFromPRICentrexSystem',
        'customerImplementingMultiLevelIVR',
        'customerUsingFaxline',
        'doesCustomerHaveATADevice',
        'customerNeedOverHeadPaging',
        'existingCopperPhoneNumberForBilling',
        'doesCustomerHaveCat5'
      ].includes(fieldName) &&
      isRecontractFlow
    )
      return false;

    if (
      fieldName === fieldBusinessConnectEdition &&
      isRecontractFlow &&
      !valueRecontractChangeEdition
    )
      return false;

    if (isRecontractFlow) {
      const valueBusinessConnectEdition = getFieldValue(
        fieldBusinessConnectEdition,
        fields
      );
      const totalSeats =
        Number(getFieldValue(fieldStarterSeat, formFields)) +
        Number(getFieldValue(fieldOfficeSeats, formFields));
      if (
        !(
          ((valueRecontractChangeEdition === yes &&
            valueBusinessConnectEdition === voicePlus) ||
            (valueRecontractChangeEdition === no &&
              valueRecontractAddSubtractSeats === valueYesLookingToAddSeats)) &&
          !_.isNaN(totalSeats) &&
          totalSeats > 50
        )
      ) {
        if (formFields[fieldNoteVoicePlusRecontract]) {
          if (fieldName === fieldNoteVoicePlusRecontract) {
            formFields[fieldNoteVoicePlusRecontract].value = false;
            return null;
          }
        }
      } else if (formFields[fieldNoteVoicePlusRecontract]) {
        if (fieldName === fieldNoteVoicePlusRecontract) {
          formFields[fieldNoteVoicePlusRecontract].value = true;
        }
      }
    } else if (
      [
        fieldIsTheCustomerPriceChanging,
        fieldWhatIsTheCustomersCurrentPrice,
        fieldWhatIsTheCustomersCurrentStarterSeatPrice,
        fieldWhatIsTheCustomersCurrentOfficeSeatPrice,
        fieldNoteVoicePlusRecontract
      ].includes(fieldName)
    ) {
      return null;
    }

    if (!isRecontractFlow && fieldName === fieldRateChangeApprovedBy) {
      return null;
    }
    if (isRecontractFlow && fieldName === fieldStarterSeat) {
      formFields.starterSeat.maxValue = undefined;
    }
    // For Odyssey Values and OdysseyAI Add-on orders, lock starter seat to 0
    if (fieldName === fieldStarterSeat && (isAllValuesNoOdyssey || isThisOdysseyAIOrder) && valueTypeOfInstallation === valueAddon) {
      formFields.starterSeat.value = 0;
      formFields.starterSeat.isRequired = false;
      formFields.starterSeat.isDisabled = true;
    }

    // Hide KANA field for OdysseyAI orders
    if (fieldName === fieldKANA && isThisOdysseyAIOrder) {
      return false;
    }

    // Show KANACAR field ONLY for OdysseyAI orders (hide for all other scenarios)
    if (fieldName === fieldKANACAR && !isThisOdysseyAIOrder) {
      return false;
    }

    if (fieldName === fieldNewPriceNote) {
      if (!isRecontractFlow) return null;
      const { baseOffice, baseStarter, officeSeats, starterSeat } = rates;
      const pricePercentageDifference = Math.abs(
        (baseOffice + baseStarter - (officeSeats + starterSeat)) /
          (baseOffice + baseStarter)
      );
      if (formFields[fieldNewPriceNote]) {
        if (pricePercentageDifference <= 0.1) {
          formFields[fieldNewPriceNote].value = false;
          return null;
        }
        formFields[fieldNewPriceNote].value = true;
      }
    }

    if (
      [fieldStarterSeat, fieldOfficeSeats].includes(fieldName) &&
      isRecontractFlow &&
      !valueRecontractAddSubtractSeats
    )
      return false;

    if (fieldName === fieldRecontractAddSubtractSeats && !isRecontractFlow)
      return false;

    if (
      fieldName === fieldBusinessType &&
      isRecontractFlow &&
      valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats
    )
      return false;

    if (
      fieldName === fieldDoesCustomerRequirePrimaryIpDeskPhones &&
      isRecontractFlow &&
      valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats
    ) {
      return false;
    }

    if (
      fieldName === fieldDoesCustomerRequireSpareDevices &&
      !isRecontractFlow &&
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, fields) !== yes
    ) {
      return false;
    }

    if (
      fieldName === fieldDoesCustomerRequireSpareDevices &&
      isRecontractFlow &&
      !valueRecontractAddSubtractSeats
    ) {
      return false;
    }
    if (
      fieldName === fieldDoesCustomerRequireSpareDevices &&
      (isAllValuesNoOdyssey || isThisOdysseyAIOrder)
    ) {
      return false;
    }

    if (
      isRecontractFlow &&
      ['Shipping Address', 'Onsite Contact'].includes(fieldName) &&
      !_.get(orderData, 'devices', []).length
    )
      return false;
    if ([primarySalesContact].includes(fieldName) && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      return false;
    }
    if (
      !isRecontractFlow &&
      [
        fieldDriversLicenseNumber,
        fieldDriversLicenseExpiry,
        fieldDateOfBirth,
        'customerAuthorizedForHardCreditCheck_additionalCustomerInfo',
        fieldOperatingAs,
        fieldBusinessIncorporationNumber,
        fieldIncorporationDate
      ].includes(fieldName) &&
      valueTypeOfInstallation !== valueNew
    )
      return false;

    if (
      isRecontractFlow &&
      (fieldName.includes('customerAdvisories') ||
        fieldName === fieldYesToAllAdvisories)
    ) {
      if (
        valueRecontractAddSubtractSeats === valueYesLookingToAddSeats &&
        fieldName === 'customerAdvisories_customerAuthorizedForHardCreditCheck'
      )
        return true;
      return false;
    }

    /** REMOVE THIS WHEN UPLOADING RECONTRACT UPDATED */
    if (!isAdmin && isSalesRep && fieldName === fieldRecontractCustomer) {
      return true;
    }
    if (!isAdmin && fieldName === fieldRecontractCustomer) return false;

    // Logic for isFibreOpticDrop field visibility
    if (fieldName === fieldIsFibreOpticDrop) {
      // Get required values - options 1, 2, 3 always from orderData
      const valueVulcanOrder = _.get(orderData, fieldVulcanOrder, '');
      const valueCustomerRequireAIFeatures = _.get(orderData, fieldCustomerRequireAIFeatures, '');
      const valueCustomerSegment = _.get(orderData, fieldCustomerSegment, '');
      
      // Options 4, 5 always from getFieldValue
      const valueServiceAddressCity = getFieldValue(fieldCityServiceAddress, formFields);
      const valueServiceAddressProvince = getFieldValue(fieldProvinceServiceAddress, formFields);

      // Check all conditions for field visibility
      const isPureFibreEastNo = valueVulcanOrder === no;
      const isAIFeaturesYes = valueCustomerRequireAIFeatures === yes;
      const isSMBSegment = [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueCustomerSegment);
      // Normalize: trim, strip diacritics (NFD splits e.g. 'é' into 'e' + combining
      // accent in the U+0300–U+036F range, which we then remove), and lowercase.
      // This makes the lookup both case- and accent-insensitive, so 'Québec',
      // 'QUEBEC', 'québec' all match the 'quebec' key in the eligibility map.
      const toKey = (str) => (str || '')
        .toString()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
      const cityNormalized = toKey(valueServiceAddressCity);
      const provinceNormalized = toKey(valueServiceAddressProvince);
      const eligibleCities = pureFibreDropEligibleCitiesByProvince[provinceNormalized] || [];
      const isCityProvinceInScope = eligibleCities.includes(cityNormalized);

      const finalResult = isPureFibreEastNo && isAIFeaturesYes && isSMBSegment && isCityProvinceInScope;
      // Return true only if all conditions are met
      return finalResult;
    }

    return true;
  };

  const dealerAssignmentDetailFields = [
    fieldWillYourDealershipBePerformingThisWhiteGlove,
    fieldDealershipName,
    fieldDealerFirstName,
    fieldDealerLastName,
    fieldDealerPhoneNumber,
    fieldDealerEmail
  ];

  // Quote fields win when present on the current step; later steps (e.g. the
  // Business Connect Implementation page) fall back to the saved order data.
  const getQuoteFieldValue = (fieldName, fields) =>
    fields && fields[fieldName]
      ? getFieldValue(fieldName, fields)
      : _.get(orderData, fieldName, '');

  const isTpiSelected = fields =>
    getQuoteFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
    valueTelusProfessionalInstallation;

  // Outside the Quote step the technician answer mirrors the Quote and is locked.
  const isImplementationTechnicianLocked = fields =>
    !!fields &&
    !fields[fieldDoesTheCustomerRequireWhiteGlove] &&
    !!_.get(orderData, fieldHaveYouArrangedWhiteGloveTechnician);

  const getTpiOrderSeats = fields =>
    getTpiTotalSeats(
      getQuoteFieldValue(fieldStarterSeat, fields),
      getQuoteFieldValue(fieldOfficeSeats, fields)
    );

  /**
   * Spec 034: approval code (NBD tech, $240/seat) is required only for TPI
   * orders under 16 seats where no Dealer Tech has been arranged.
   */
  const isApprovalCodeFieldVisible = (fields = formFields) =>
    isTpiApprovalRequired({
      isProfessionalInstallation:
        getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
        valueTelusProfessionalInstallation,
      dealerTechAnswer: getFieldValue(
        fieldHaveYouArrangedWhiteGloveTechnician,
        fields
      ),
      noValue: no,
      totalSeats: getTpiOrderSeats(fields)
    });

  const isRelatedFieldExisted = (field, fields) => {
    const {
      appearsAfterField,
      appearsAfterValue,
      name,
      backendFieldValidation
    } = field;

    const passCustomChecks = customChecks(name, fields);
    if (!passCustomChecks) return false;

    const isProfessionalInstallation =
      getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
      valueTelusProfessionalInstallation;
    // Only for TELUS Professional Installation (never Virtual / Self / No install).
    if (name === fieldHaveYouArrangedWhiteGloveTechnician) {
      return isTpiSelected(fields);
    }
    if (dealerAssignmentDetailFields.includes(name) && isProfessionalInstallation) {
      return (
        getFieldValue(fieldHaveYouArrangedWhiteGloveTechnician, fields) === yes
      );
    }

    // Main flow -------
    if (!appearsAfterField && !backendFieldValidation) return true;
    if (
      getFieldValue(fieldTypeOfInstallation, fields) === valueAddon &&
      getFieldValue(fieldVbpRequired, fields) === yes &&
      isFieldInGroup(formStepFields, name, groupVbpOptions)
    ) {
      // BCON-2653: custom pricing fields on Add On orders are visible to all
      // roles now, matching New order behaviour (previously gated to
      // isAdminFlow || isOrderFulfillmentTeam only). The edition-specific
      // applicability check below (starter seat rate only for Voice +) is
      // preserved and now applies universally.
      if (
        !name.startsWith('vpbOfficeSeatRate') &&
        !name.startsWith('vbpDesiredPrice')
      ) {
        return !(
          name === fieldVpbStarterSeatRate &&
          getFieldValue(fieldBusinessConnectEdition, fields) !== voicePlus
        );
      }
    }

    let result = true;
    let i = 0;
    if (appearsAfterField) {
      while (i < appearsAfterField.length && result) {
        const relatedFieldName = getFieldName(
          appearsAfterField[i],
          orderData,
          formName,
          yes
        );
        const relatedFieldType = getFieldType(relatedFieldName, fields);
        const relatedFieldValue =
          relatedFieldType === 'Checkbox'
            ? getFieldChecked(relatedFieldName, fields)
            : getFieldValue(relatedFieldName, fields);
        if (relatedFieldName) {
          if (
            fields[relatedFieldName] &&
            fields[relatedFieldName].isVisible &&
            relatedFieldValue
          ) {
            if (appearsAfterValue) {
              let isValueSelected;
              if (_.isArray(relatedFieldValue)) {
                isValueSelected = appearsAfterValue.find(item =>
                  relatedFieldValue.includes(item.fields.value)
                );
              } else {
                isValueSelected = appearsAfterValue.find(
                  item => relatedFieldValue === item.fields.value
                );
              }
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else if (orderData && orderData[relatedFieldName]) {
            if (fields[relatedFieldName]) {
              if (
                (isFormTouched &&
                  orderData[relatedFieldName] === relatedFieldValue) ||
                !isFormTouched
              ) {
                if (appearsAfterValue) {
                  const isValueSelected = appearsAfterValue.find(
                    item => orderData[relatedFieldName] === item.fields.value
                  );
                  result = result && typeof isValueSelected !== 'undefined';
                }
              } else result = false;
            } else if (appearsAfterValue) {
              const isValueSelected = appearsAfterValue.find(
                item => orderData[relatedFieldName] === item.fields.value
              );
              result = result && typeof isValueSelected !== 'undefined';
            }
          } else {
            result = false;
          }
        }
        i += 1;
      }
    }

    if (formName === businessConnectQuoteToolForm && step === 1) {
      const networkCondition = isChannelBSEorBSW(
        fields,
        name,
        no,
        valueSegmentSmb1To30
      );
      if (networkCondition !== undefined) {
        return networkCondition;
      }
    }
    if (backendFieldValidation) {
      let isVisible = result;
      for (let index = 0; index < backendFieldValidation.length; index += 1) {
        const {
          fields: { key, value }
        } = backendFieldValidation[index];
        isVisible =
          isVisible &&
          (value.split('|').includes(orderData[key]) ||
            (value.split('|').includes('undefined') &&
              typeof orderData[key] === 'undefined'));
      }
      return isVisible;
    }

    return result;
  };

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (!isRelatedFieldExisted(section.fields, fields)) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  const aiInstallDependencyMap = {
    [fieldReceptionistInstall]: {
      component: fieldReceptionistOdysseyAI,
      valueField: fieldReceptionistOdysseyAIOdysseyAI
    },
    [fieldInsightsInstall]: {
      component: fieldInsightsOdysseyAI,
      valueField: fieldInsightsOdysseyAIOdysseyAI
    }
  };

  const isAiInstallField = name =>
    name === fieldReceptionistInstall || name === fieldInsightsInstall;

  const isAiInstallFieldEnabled = (name, fields) => {
    const dep = aiInstallDependencyMap[name];
    if (!dep) return false;
    // A Checkbox keeps its value ("on" / true) after being unticked, so only
    // `checked` reflects its selection state.
    const componentSelected =
      getFieldType(dep.component, fields) === 'Checkbox'
        ? !!getFieldChecked(dep.component, fields)
        : !!getFieldChecked(dep.component, fields) ||
          !!getFieldValue(dep.component, fields);
    const componentValue = getFieldValue(dep.valueField, fields);
    return (
      componentSelected &&
      !!componentValue &&
      !isApprovalCodeFieldVisible(fields)
    );
  };

  const isAnyAiInstallFieldChecked = fields =>
    Object.keys(aiInstallDependencyMap).some(
      name =>
        !!getFieldChecked(name, fields) && isAiInstallFieldEnabled(name, fields)
    );

  useEffect(() => {
    if (formStepFields && !isFieldReset) {
      const updatedFields = normalizedFields(
        formStepFields,
        formFields,
        orderData,
        isSalesSupportFlow,
        localizedStrings,
        isVarAgent
      );
      if (orderData && orderData[keyDevices]) {
        updatedFields[keyDevices] = orderData[keyDevices];
      }
      if (orderData && orderData[keySpareDevices]) {
        updatedFields[keySpareDevices] = orderData[keySpareDevices];
      }

      [fieldReceptionistInstall, fieldInsightsInstall].forEach(fieldName => {
        if (
          updatedFields[fieldName] &&
          !isAiInstallFieldEnabled(fieldName, updatedFields)
        ) {
          updatedFields[fieldName].checked = false;
        }
      });

      if (
        updatedFields[fieldApprovalCodeWhiteGlove] &&
        !isApprovalCodeFieldVisible(updatedFields)
      ) {
        updatedFields[fieldApprovalCodeWhiteGlove].value = '';
      }
      if (
        updatedFields[fieldHowCustomerWantToPayForWhiteGlove] &&
        getFieldValue(fieldHowCustomerWantToPayForWhiteGlove, updatedFields) ===
          valueDealerBilledDirect &&
        isApprovalCodeFieldVisible(updatedFields)
      ) {
        updatedFields[fieldHowCustomerWantToPayForWhiteGlove].value = '';
      }

      // Business Connect Implementation page (spec 034 US5).
      if (
        isImplementationTechnicianLocked(updatedFields) &&
        updatedFields[fieldHaveYouArrangedWhiteGloveTechnician]
      ) {
        updatedFields[fieldHaveYouArrangedWhiteGloveTechnician].value = _.get(
          orderData,
          fieldHaveYouArrangedWhiteGloveTechnician
        );
      }
      if (updatedFields[fieldNumberOfSitesThatRequireWhiteGlove]) {
        updatedFields[fieldNumberOfSitesThatRequireWhiteGlove].value = 1;
      }

      if (
        updatedFields[fieldeContractNumber] &&
        !_.get(orderData, 'assignedToSRT', 0)
      ) {
        updatedFields[fieldeContractNumber].isRequired = false;
      }

      if (
        (!orderData[fieldBAN] ||
          (orderData[fieldBAN] &&
            orderData[fieldBAN] !==
              orderData[fieldExistingBusinessConnectBANNumber])) &&
        orderData[fieldExistingBusinessConnectBANNumber]
      ) {
        const updatedOrderData = {
          ...orderData,
          [fieldBAN]: orderData[fieldExistingBusinessConnectBANNumber]
        };
        setOrderData(updatedOrderData);
      }
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData]);

  // Calculate initial open panels immediately (lazy initializer)
  const [openPanels, setOpenPanels] = useState(() => {
    return sections.reduce((acc, section) => {
      const {
        fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
      } = section;

      if (isPanelInitiallyOpen) {
        acc.push(name);
      } else {
        const isErrors =
          sectionFields &&
          sectionFields.find(item => {
            const {
              fields: { name: itemName }
            } = item;
            return formErrors[itemName];
          });
        if (typeof isErrors !== 'undefined') acc.push(name);
      }

      return acc;
    }, []);
  });

  // Update open panels when sections or formErrors change
  useEffect(() => {
    const newOpen = sections.reduce((acc, section) => {
      const {
        fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
      } = section;

      if (isPanelInitiallyOpen) {
        acc.push(name);
      } else {
        const isErrors =
          sectionFields &&
          sectionFields.find(item => {
            const {
              fields: { name: itemName }
            } = item;
            return formErrors[itemName];
          });
        if (typeof isErrors !== 'undefined') acc.push(name);
      }

      return acc;
    }, []);
    
    setOpenPanels(newOpen);
  }, [sections, formErrors]);

  const sectionIsVisible = name => {
    /** Hiding Prequalification section for role Order fulfillment */
    // SOF-3356 R-006 / FR-006: SMs with `canSubmitOrders === true` MUST be
    // allowed to start a new BCx order (and therefore see the prequalification
    // section). Pre-feature behaviour for SMs without order access (or any
    // legacy/non-SM-aware caller) is preserved verbatim.
    if (
      (isOrderFulfillmentTeam || isProposalHouse || (isSalesManager && !canSubmitOrders())) &&
      name === sectionNetworkPrequalification
    )
      return false;

    /** Hiding Sales Rep Info for Admin and Sales Rep */
    // SOF-3356 R-006 / FR-006: SMs with `canSubmitOrders === true` create
    // orders on their own behalf (SM identity is auto-injected by
    // formSubmitLogic T027 — `salesManagerName` / `salesManagerCpmsId`), so
    // the Sales Rep Info entry section MUST be hidden for them too. Other
    // roles' behaviour preserved verbatim.
    if (
      (isAdmin || isSalesRep || (isSalesSupport && channels.length === 1) || (isSalesManager && canSubmitOrders())) &&
      name === sectionSalesRepInfo
    )
      return false;

    if (
      name === sectionGSuiteDetails &&
      Number(orderData[fieldStarterSeat]) +
        Number(orderData[fieldOfficeSeats]) <
        1
    ) {
      return false;
    }

    /**
     * Edge Case: Hide Additional features section
     * when the following condition is satisfied
     */

    if (
      name === sectionAdditionalFeatures &&
      getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon &&
      [voice, mobile].includes(
        getFieldValue(fieldBusinessConnectEdition, formFields)
      ) &&
      getFieldValue(fieldStarterSeat, formFields) !== '1'
    ) {
      return false;
    }

    if (name === sectionDeviceDetails && isRecontractFlow) {
      const valueRecontractAddSubtractSeats = getFieldValue(
        fieldRecontractAddSubtractSeats,
        formFields
      );
      if (!valueRecontractAddSubtractSeats) return false;
    }
    if (name === sectionWhiteGloveDetails && isRecontractFlow) {
      const valueRecontractAddSubtractSeats = getFieldValue(
        fieldRecontractAddSubtractSeats,
        formFields
      );
      if (valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats)
        return false;
    }

    return (
      typeof sections.find(item => item.fields.name === name) !== 'undefined'
    );
  };

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required
    );
    const filteredData = formValues.filter(formValue => {
      const filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }) => !formValue[formKeyValue]
      );
      return filteredValues.length > 0;
    });
    return filteredData;
  };

  const currentDevices =
    (formFields[keyDevices] &&
      formFields[keyDevices].reduce((acc, item) => item.quantity + acc, 0)) ||
    0;

  const currentSpareDevices =
    (formFields[keySpareDevices] &&
      formFields[keySpareDevices].reduce(
        (acc, item) => item.quantity + acc,
        0
      )) ||
    0;

  const currentTotalDevices = currentDevices + currentSpareDevices;

  const sectionFeatures = sections.find(
    item => item.fields.name === sectionAdditionalFeatures
  );

  const isFieldInFeatures = name => {
    if (
      !sectionFeatures ||
      [
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences
      ].includes(name)
    )
      return false;

    const {
      fields: { formFields: featuresFields }
    } = sectionFeatures;
    const result = featuresFields.find(item => {
      const {
        fields: { name: featureName }
      } = item;

      return name === featureName;
    });

    return typeof result !== 'undefined';
  };

  const getFeatures = fields => {
    const features = [];

    if (!sectionFeatures) return null;

    const {
      fields: { formFields: featuresFields }
    } = sectionFeatures;
    featuresFields.forEach(item => {
      const {
        fields: {
          type,
          name: featureName,
          label,
          monthlyPayment: featurePrice,
          options
        }
      } = item;
      let feature;
      if (type === 'Checkbox') {
        if (
          getFieldChecked(featureName, fields) &&
          fields[featureName] &&
          fields[featureName].isVisible
        ) {
          const quantityField = featuresFields.find(field => {
            const {
              fields: { appearsAfterField }
            } = field;
            if (appearsAfterField) {
              const isFeatureFound = appearsAfterField.find(
                i => i.fields.name === featureName
              );
              return typeof isFeatureFound !== 'undefined';
            }
            return false;
          });
          let quantity =
            typeof quantityField !== 'undefined'
              ? Number(
                  getFieldValue(
                    getFieldName(quantityField, orderData, formName, yes),
                    fields
                  )
                )
              : 1;
          if (Number.isNaN(Number(quantity))) quantity = 0;
          const unitPrice = Number.isNaN(Number(featurePrice))
            ? 0
            : featurePrice;
          feature = {
            category: '',
            unitPrice,
            name: featureName,
            description: label,
            monthlyCharges: unitPrice,
            oneTimeCharges: '',
            quantity
          };
        }
      } else if (type === 'MultiCheckbox') {
        const fieldValue = getFieldValue(featureName, fields) || [];
        if (fieldValue.length > 0) {
          fieldValue.forEach(featureItem => {
            const itemDetails = options.filter(
              optionItem =>
                _.get(optionItem, 'fields.value', '') === featureItem
            );
            const unitPrice =
              _.get(itemDetails, '[0].fields.monthlyPayment', 0) ||
              _.get(itemDetails, '[0].fields.price', 0);

            features.push({
              category:
                featureName === fieldAdditionalRsiOptions
                  ? keyAdditionalRsiOptions
                  : keyDirectoryListing,
              unitPrice,
              name: featureName,
              description: featureItem,
              monthlyCharges: _.get(
                itemDetails,
                '[0].fields.monthlyPayment',
                0
              ),
              oneTimeCharges: _.get(itemDetails, '[0].fields.price', 0),
              quantity: 1
            });
          });
        }
      } else if (featureName === fieldRsiLicenses) {
        const valueRsiLicenses = getFieldValue(fieldRsiLicenses, fields);
        if (valueRsiLicenses) {
          features.push({
            category: 'RSI',
            unitPrice: rsiLicencesRate[valueRsiLicenses],
            name: featureName,
            description: `Shadow A1 - ${valueRsiLicenses}`,
            monthlyCharges: rsiLicencesRate[valueRsiLicenses],
            oneTimeCharges: '',
            quantity: 1
          });
        }
        /**
         * Adding a One-Time fee depending on the number of licenses
         */
        if (valueRsiLicenses && +valueRsiLicenses <= 250) {
          features.push({
            category: 'RSI',
            unitPrice: 250,
            name: featureName,
            description: `Shadow A1 Implementation Fee`,
            monthlyCharges: '',
            oneTimeCharges: 250,
            quantity: 1
          });
        }
        if (valueRsiLicenses && +valueRsiLicenses > 250) {
          features.push({
            category: 'RSI',
            unitPrice: 400,
            name: featureName,
            description: `Shadow A1 Implementation Fee - large account`,
            monthlyCharges: '',
            oneTimeCharges: 400,
            quantity: 1
          });
        }
      } else if (featureName === fieldGenesisLicenses) {
        const valueGenesisLicenses = getFieldValue(
          fieldGenesisLicenses,
          fields
        );
        if (valueGenesisLicenses) {
          features.push({
            category: 'Genesis',
            unitPrice: genesisLicencesRate[valueGenesisLicenses],
            name: featureName,
            description: `Genesis - GenAlert 911 - ${valueGenesisLicenses} licenses`,
            monthlyCharges: genesisLicencesRate[valueGenesisLicenses],
            oneTimeCharges: '',
            quantity: 1
          });
        }
      } else if (['Select', 'Radio'].includes(type)) {
        if (fields && fields[featureName] && fields[featureName].isVisible) {
          const { monthlyPayment: optionPrice, value } = fields[featureName];
          let unitPrice = Number.isNaN(Number(optionPrice)) ? 0 : optionPrice;

          // Define the unit price
          if (!unitPrice && orderData && orderData[keyFeatures]) {
            const orderDataValue = orderData[keyFeatures].find(
              i => i.name === featureName
            );
            if (typeof orderDataValue !== 'undefined') {
              const { unitPrice: price } = orderDataValue;
              unitPrice = price;
            }
          }

          // Define the description
          const category = [
            keyDirectoryListingType,
            keyPrimaryDirectoryListingType
          ].includes(featureName)
            ? keyDirectoryListing
            : '';
          const capitalizeFirstLetter = str => {
            return str && str.charAt(0).toUpperCase() + str.slice(1);
          };
          let description = `${quoteForm[featureName] || label}: ${value}`;
          if (
            [
              keyDirectoryListingType,
              keyPrimaryDirectoryListingType,
              fieldNumberOfTollFreeMinutes
            ].includes(featureName)
          ) {
            description = capitalizeFirstLetter(value) || category;
          }

          feature = {
            category,
            unitPrice,
            name: featureName,
            description,
            monthlyCharges: unitPrice,
            oneTimeCharges: '',
            quantity: 1
          };
        }
      }
      if (
        (feature && feature.unitPrice && feature.quantity) ||
        (feature &&
          [
            keyDirectoryListingType,
            fieldMsftDirectRouting,
            field5UnlimitedLongDistanceCanUs,
            field10UnlimitedLongDistanceCanUs,
            fieldAssistantAiOdysseyAI
          ].includes(featureName))
      ) {
        if (featureName === fieldAssistantAiOdysseyAI && featuresFields[fieldAssistantAiOdysseyAI] && featuresFields[fieldAssistantAiOdysseyAI].checked === true) {
          features.push(feature);
        } else {
          features.push(feature);
        }
      }
    });

    return features;
  };

  // Calculation for features - their prices are for Monthly
  const updateFeaturesPrices = features => {
    if (!features) return { monthly: 0, oneTime: 0 };
    return (
      features &&
      features.reduce(
        (acc, item) => {
          const price = Number.isNaN(Number(item.unitPrice))
            ? 0
            : item.unitPrice;
          const quantity = +item.quantity;
          if (item.monthlyCharges) acc.monthly += price * quantity;
          if (item.oneTimeCharges) acc.oneTime += price * quantity;
          return acc;
        },
        { monthly: 0, oneTime: 0 }
      )
    );
  };

  const isGSuiteEnabled = fields => {
    return (
      orderData.isThisAnExistingGSuiteCustomer === no &&
      maxDevices(fields) > 0 &&
      !['', monthToMonth].includes(getFieldValue(fieldContractTerm, fields)) &&
      !['', mobile].includes(
        getFieldValue(fieldBusinessConnectEdition, fields)
      ) &&
      !fields[fieldOptOutFromGSuiteBusinessLicenses].checked
    );
  };

  const getGSuitePrice = fields => {
    const result = {
      price: 0,
      monthlyPayment: 0
    };

    if (!isGSuiteEnabled(fields)) return result;

    // G Suite Licences
    const qtyBusinessLicences =
      +getFieldValue(fieldAdditionalGSuiteBusinessLicences, fields) || 0;
    const qtyBasicLicences = +_.get(
      fields,
      `${fieldGSuiteBasicLicences}.value`,
      0
    );
    const priceBusinessLicences = +fields[fieldAdditionalGSuiteBusinessLicences]
      .monthlyPayment;
    const priceBasicLicences = +_.get(
      fields,
      `${fieldGSuiteBasicLicences}.monthlyPayment`,
      0
    );

    result.monthlyPayment +=
      priceBusinessLicences * qtyBusinessLicences +
      priceBasicLicences * qtyBasicLicences;

    // G Suite Install & Setup
    const totalLicences =
      qtyBusinessLicences + qtyBasicLicences + gSuiteBusinessLicences(fields);
    if (
      fields[fieldGSuiteInstallAndSetup].value === yes &&
      !isFieldGSuiteInstallAndSetupDisabled(fields) &&
      isGSuiteOk(totalLicences)
    ) {
      result.price += gSuiteInstallAndSetupPrice;
    }

    // G Suite Email Migration Service
    const numberOfUsers = +fields[fieldGSuiteEmailMigrationServices].value;
    const paymentType =
      fields[fieldGSuiteEmailMigrationServicesPaymentType].value;
    if (numberOfUsers > 0 && numberOfUsers < 5) {
      result.price += gSuiteMigrateUsersPrice;
    } else if (numberOfUsers > 4 && paymentType) {
      if (paymentType === valuePaymentUpfront) {
        result.price += numberOfUsers * gSuiteMigrateUsersNowPrice;
      } else {
        result.monthlyPayment += numberOfUsers * gSuiteMigrateUsersMonthlyPrice;
      }
    }

    return result;
  };

  const isReadinessChecklistAvailable = () => {
    const valueInstallationType = _.get(orderData, fieldTypeOfInstallation, '');
    const isWgRequired =
      _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
      valueTelusProfessionalInstallation;
    const isStarterSeatPorting =
      orderData.starterSeatDetails &&
      orderData.starterSeatDetails.some(
        val => val.willTheLocalPhoneNumberBePortedIn === yes
      );
    const isOfficeSeatPorting =
      orderData.officeSeatDetails &&
      orderData.officeSeatDetails.some(
        val => val.willTheLocalPhoneNumberBePortedIn === yes
      );

    return (
      isDealer &&
      (valueInstallationType === valueNew || isRecontractFlow) &&
      (isWgRequired || isStarterSeatPorting || isOfficeSeatPorting)
    );
  };

  const isAdditionalRsiOptionsAvailable = () => {
    const isRsiChecked = getFieldChecked(fieldRsi, formFields);
    const valueRsiLicenses = getFieldValue(fieldRsiLicenses, formFields);
    return isRsiChecked && valueRsiLicenses;
  };

  const getSeatsData = () => {
    const starterSeatCount = +getFieldValue(fieldStarterSeat, formFields) || 0;
    const officeSeatCount = +getFieldValue(fieldOfficeSeats, formFields) || 0;
    const addedSeatsCount =
      +getFieldValue(fieldRecontractSeatsCustomerAdding, formFields) || 0;
    const totalNoOfSeats = starterSeatCount + officeSeatCount;

    return {
      starterSeatCount,
      officeSeatCount,
      addedSeatsCount,
      totalNoOfSeats
    };
  };

  const isInsightsZeroSeatWarningActive = () =>
    isAiInsightsZeroSeatWarningActive({
      isAiOrder: isThisOdysseyAIOrder,
      isAddon:
        getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon,
      totalSeats: getSeatsData().totalNoOfSeats,
      insightsChecked: getFieldChecked(fieldInsightsOdysseyAI, formFields),
      insightsQuantity: getFieldValue(
        fieldInsightsOdysseyAIOdysseyAI,
        formFields
      )
    });

  const getStandaloneCheckboxPrice = (name, price) => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    if (isAiInstallField(name))
      return valueSegment === valueSegmentCommercial ? 0 : 120;
    return Number(price) || 0;
  };

  const getErrors = (data, errors) => {
    let result = errors;

    if (!data) return result;
    delete result[fieldPin];
    delete result[fieldAddDevices];
    delete result[fieldAddSpareDevices];

    const limitedExtensionOdysseyAiQty =
      Number(
        getFieldValue(limitedExtensionOdysseyAIOdysseyAI, formFields) ||
          _.get(orderData, limitedExtensionOdysseyAIOdysseyAI, '')
      ) || 0;
    const valueTypeOfInstallationForErrors = getFieldValue(
      fieldTypeOfInstallation,
      formFields
    );
    const isZeroSeatAddonAllowedForErrors = isZeroSeatAddonAllowed(
      {
        isAddon: valueTypeOfInstallationForErrors === valueAddon,
        vulcan: valueVulcanOrderAi,
        coperToFibre: valueCoperToFibreMigrationAi,
        goco: valueMigrationGoco
      },
      yes,
      no
    );

    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { ineligible } = fields;
      const key = fields.name;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength,
        type,
        checked
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];

      if (id === formFieldsGroup && isRelatedFieldExisted(fields, formFields)) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired && type !== 'Checkbox') {
          const isRequiredValueMissing =
            type === 'Number' && typeof value === 'number' ?
              value === '' || value === null || value === undefined
              : !value;
          if (
            isRequiredValueMissing &&
            isRelatedFieldExisted(fields, formFields)
          ) {
            result[key] = { text: fieldRequiredMessage, ref };
          } else {
            delete result[key];
          }
        }
        if (ineligible) {
          const {
            fields: { value: ineligibleValue }
          } = ineligible;
          const isIneligibleValue = ineligibleValue.split('|').includes(value);
          if (isIneligibleValue) {
            result[key] = { text: cannotProceedMessage, ref };
          }
          if (isIneligibleValue && isRecontractFlow) {
            result[key] = { text: smartDesktopErrorMessage, ref };
          }
        }
        if (isRequired && type === 'Checkbox') {
          if (!checked && isRelatedFieldExisted(fields, formFields))
            result[key] = { text: fieldRequiredMessage, ref };
          else delete result[key];
        }

        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = { text: msgMinValue(minValue), ref };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = { text: msgMaxValue(maxValue), ref };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = { text: msgMinLength(minLength), ref };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = { text: msgMaxLength(maxLength), ref };
        }

        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(fields, formFields))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = +value < +expectedValue;
                break;
              default:
            }
            if (hasError) {
              result[key] = { text: errorMessage, ref };
            } else if (result[key] && result[key].text === errorMessage) {
              delete result[key];
            }
          }
        }
        if (
          isRecontractFlow &&
          !_.get(orderData, 'devices', []).length &&
          (key.includes('_onsiteContact') || key.includes('_shippingAddress'))
        )
          delete result[key];

        // Checking for Admin phone number which should not start with 888, 877,866,855,844,833,800
        if (key === fieldPhoneNumberAdministratorContact) {
          const valueAdminPhoneNumber =
            getFieldValue(fieldPhoneNumberAdministratorContact, formFields) ||
            '';
          const restrictedNumber = [888, 877, 866, 855, 844, 833, 800];

          if (
            valueAdminPhoneNumber.length < 10 ||
            restrictedNumber.includes(+valueAdminPhoneNumber.slice(0, 3))
          ) {
            result[key] = { text: invalidNumber, ref };
          }
        }
        // IF Business Connect Enhanced Closing Tool is checked off 3 months free cannot be added at the same time validation
        if (key === fieldAvailableDiscountsAndPromotions) {
          const valueAvailableDiscountsAndPromotions =
            getFieldValue(fieldAvailableDiscountsAndPromotions, formFields) ||
            [];
          if (
            valueAvailableDiscountsAndPromotions.includes(
              valueThreeMonthsFree
            ) &&
            valueAvailableDiscountsAndPromotions.includes(
              valueBusinessConnectEnhancedClosingTool
            )
          ) {
            result[key] = {
              text:
                'IF Business Connect Enhanced Closing Tool is checked off 3 months free cannot be added at the same time',
              ref
            };
          } else {
            delete result[key];
          }
        }
        // IF Province of the order and Service address are not same (Quebec), the order cannot be created
        if (key === fieldProvinceServiceAddress) {
          const valueProvinceServiceAddress =
            getFieldValue(fieldProvinceServiceAddress, formFields) || '';
          if (valueProvinceServiceAddress) {
            const isQCProvincePresent = allowedProvinceQCBundle.includes(
              valueProvinceServiceAddress
            );
            const valueSegment = _.get(orderData, fieldCustomerSegment, '');
            if (
              [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
                valueSegment
              ) &&
              allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) &&
              !isQCProvincePresent
            ) {
              result[key] = {
                text: 'The service address does not match the province of order.',
                ref
              };
            } else {
              delete result[key];
            }
          }
        }
        // Custom checks
        if (
          [
            fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
            fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
            fieldTelusBusinessConnectLargeMeetings500NumberOfLicences
          ].includes(key)
        ) {
          const value1 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings200NumberOfLicences,
            formFields
          );
          const value2 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings300NumberOfLicences,
            formFields
          );
          const value3 = getFieldValue(
            fieldTelusBusinessConnectLargeMeetings500NumberOfLicences,
            formFields
          );
          const maxSumValue =
            Number(getFieldValue(fieldStarterSeat, formFields)) +
            Number(getFieldValue(fieldOfficeSeats, formFields));

          if (Number(value1) + Number(value2) + Number(value3) > maxSumValue) {
            result[key] = { text: msgMaxCombinedValue(maxSumValue), ref };
          }
        }
        if (key === fieldOfficeSeats) {
          const starterAmount = +getFieldValue(fieldStarterSeat, formFields);
          const officeAmount = +getFieldValue(fieldOfficeSeats, formFields);
          const valueBCE = getFieldValue(
            fieldBusinessConnectEdition,
            formFields
          );
          const valueTOI = getFieldValue(fieldTypeOfInstallation, formFields);

          // Less than 4
          if (
            valueBCE === voice &&
            valueTOI === valueAddon &&
            starterAmount + officeAmount > 4
          )
            result[key] = { text: maxTotalSeatsLessMessage, ref };
          else if (result[key] && result[key].text === maxTotalSeatsLessMessage)
            delete result[key];

          // Greater than 0 (an Add-on with zero seats is allowed when the migration check is cleared)
          if (
            starterAmount + officeAmount < 1 &&
            !isZeroSeatAddonAllowedForErrors
          )
            result[key] = { text: maxTotalSeatsMessage, ref };
          else if (result[key] && result[key].text === maxTotalSeatsMessage)
            delete result[key];
        }

        if (
          key === fieldNumberOfSeatsThatRequireWhiteGlove &&
          getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, formFields) ===
            valueTelusProfessionalInstallation &&
            !isZeroSeatAddonAllowedForErrors
        ) {
          const maxSumValue = isRecontractFlow
            ? Number(
                getFieldValue(fieldRecontractSeatsCustomerAdding, formFields)
              )
            : Number(getFieldValue(fieldStarterSeat, formFields)) +
              Number(getFieldValue(fieldOfficeSeats, formFields));

          if (parseFloat(value) === 0) {
            result[key] = { text: maxTotalSeatsMessage, ref };
          } else if (parseFloat(value) > maxSumValue) {
            result[key] = { text: msgMaxValue(maxSumValue), ref };
          }
        }
      } else {
        // Field is no longer visible (e.g. a conditional answer changed, hiding
        // fields that appeared under the previous answer) - clear any stale
        // required/validation error left behind so it can't block Continue.
        delete result[key];
      }
      if (!['Primary Sales Contact'].includes(key) && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
        delete result[fieldEmailPrimaryContact];
      }
      if (key === fieldUploadCustomerReadinessChecklist) {
        if (
          formFields.uploadCustomerReadinessChecklist.fileUploded ||
          !isReadinessChecklistAvailable() ||
          readinessChecklistExemptOutletIds.includes(String(outletId))
        ) {
          delete result[key];
        }
      }

      if (
        key === fieldExistingBusinessConnectBANNumber &&
        isMultisiteOrder &&
        currentSite > 1 &&
        !isOrderFulfillmentTeam
      ) {
        delete result[key];
      }

      // minimumSeats is required only on site 1 of multisite orders
      if (key === fieldMinimumSeats && (!isMultisiteOrder || currentSite > 1)) {
        delete result[key];
      }

      if (key === fieldVbpRequired) {
        const totalSeats =
          Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
          Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
        const valueSegment = _.get(orderData, fieldCustomerSegment, '');

        if (
          totalSeats < 1 &&
          [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)
        ) {
          delete result[key];
        }

        // Hide vbpRequired for OdysseyAI orders
        if (isThisOdysseyAIOrder) {
          delete result[key];
        }
      }

      if (key === fieldIsSrtTeamMember && (!isSalesRep || isThisOdysseyAIOrder)) {
        delete result[key];
      }

      if (
        (key === fieldProfessionalServicesFileCharges ||
          key === fieldProfessionalServicesFileNote ||
          key === fieldProfessionalServicesFile) &&
        (!isThisOdysseyAIOrder ||
          !isOdysseyAiChatOrContactCentreLineSelected(formFields))
      ) {
        delete result[key];
      }

      // Show couponBasedDiscountOdysseyAI only for OdysseyAI orders
      if (key === fieldCouponBasedDiscountOdysseyAI && !isThisOdysseyAIOrder) {
        delete result[key];
      }

      /**
       * White Glove Odyssey AI seats: single block for validation errors on this key.
       * (Distinct from getFormData, which omits the key from submit payload when inactive.)
       */
      if (key === fieldNumberOfSeatsThatRequireWhiteGloveAI) {
        if (
          getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, formFields) ===
          valueTelusProfessionalInstallation
        ) {
          const wgAiQty = parseFloat(value) || 0;
          if (wgAiQty > limitedExtensionOdysseyAiQty) {
            result[key] = {
              text: msgMaxValue(limitedExtensionOdysseyAiQty),
              ref
            };
          } else {
            delete result[key];
          }
        } else {
          delete result[key];
        }
      }

      const approvalCode = getFieldValue(fieldApprovalCodeWhiteGlove, formFields);
      const arrangedTechnicianValue = getFieldValue(
        fieldHaveYouArrangedWhiteGloveTechnician,
        formFields
      );

      if (key === fieldHaveYouArrangedWhiteGloveTechnician) {
        if (
          arrangedTechnicianValue === no &&
          approvalCode === approvalCodeDealerInstall
        ) {
          result[fieldHaveYouArrangedWhiteGloveTechnician] = {};
          result[fieldHaveYouArrangedWhiteGloveTechnician].text =
            'Cannot continue when "No" is selected';
        }
      }

      if (key === fieldSigningEmailAuthority) {
        if (!isDealer || orderData.dueMonthlyOdysseyAI < 30000) {
          delete result[key];
        }
      }
    });

    /**
     * Condition for Pin number field
     * 1) Must contain between 4 and 6 digits
     * 2) Cannot start with zero
     * 3) Cannot be repetitive (ex. 0000, 1111, 9999)
     * 4) Cannot be sequential (ex. 1234, 5678)
     */
    if (!isRecontractFlow && formFields[fieldPin] && !isAllValuesNoOdyssey && !isThisOdysseyAIOrder) {
      const valuePin = getFieldValue(fieldPin, formFields);
      if (!valuePin)
        result[fieldPin] = {
          text: fieldRequiredMessage,
          ref: formFields[fieldPin].ref
        };
      else if (valuePin.indexOf('0') === 0)
        result[fieldPin] = {
          text: pinNotStartWithZero,
          ref: formFields[fieldPin].ref
        };
      else {
        // not be repetitive (ex. 0000, 1111, 9999)
        const isRepetitive = valuePin
          .split('')
          .filter(item => item !== valuePin[0]);
        if (!isRepetitive.length) {
          result[fieldPin] = {
            text: pinNotBeRepetitive,
            ref: formFields[fieldPin].ref
          };
        } else {
          /**
           *
           * Can pass upto 2 sequential ie. (12, 34, 45)
           * Cannot pass more then 2 sequence ie. (123, 4567, 12345, 345678)
           */
          const pinDigits = valuePin.split('').map(item => Number(item));
          let isSequential = true;
          let i = 1;
          while (i < pinDigits.length && isSequential) {
            if (pinDigits[i] - pinDigits[i - 1] !== 1) isSequential = false;
            i += 1;
          }
          if (isSequential) {
            result[fieldPin] = {
              text: pinNotBeSequential,
              ref: formFields[fieldPin].ref
            };
          }
        }
      }
    }

    if (isSalesSupportFlow && _.get(userProfile, 'channels', []).length > 1) {
      if (getFieldValue(keyChannelId, formFields)) {
        delete result[keyChannelId];
      } else {
        result[keyChannelId] = {
          text: fieldRequiredMessage,
          ref: formFields[keyChannelId].ref
        };
      }
    }

    if (isVarAgent && formName === businessConnectQuoteToolForm) {
      if (getFieldValue(keyOutlet, formFields) || outletId) {
        delete result[keyOutlet];
      } else {
        result[keyOutlet] = {
          text: fieldRequiredMessage,
          ref: formFields[keyOutlet].ref
        };
      }

      if (!getFieldValue(keyOutlet, formFields) && outletId) {
        formFields[keyOutlet].value = outletId;
      }
    }

    // Checking if Signing Authority & Re-enter Signing Authority emails are the same
    if (
      getFieldValue(fieldEmailSigningAuthority, formFields) !==
      getFieldValue(fieldEeEnterEmailSigningAuthority, formFields)
    ) {
      result[fieldEmailSigningAuthority] = {
        text: emailDoenotMatch,
        ref: formFields[fieldEeEnterEmailSigningAuthority].ref
      };
    }

    // Checking if proper number of PRIMARY DEVICES are selected
    if (
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, formFields) ===
      yes
    ) {
      if (_.get(formFields, 'devices', []).length === 0) {
        result[fieldAddDevices] = {
          text: minDevicesErrorMessage,
          ref: formFields[fieldAddDevices].ref
        };
      } else if (maxDevices(formFields) < currentDevices) {
        result[fieldAddDevices] = {
          text: msgMaxDevices(maxDevices(formFields)),
          ref: formFields[fieldAddDevices].ref
        };
      } else {
        const hwcAllowance = getHwcAllowanceCheck(formFields);
        if (hwcAllowance.isExceeded) {
          result[fieldAddDevices] = {
            text: msgMaxHwcDevices(hwcAllowance.allowance),
            ref: formFields[fieldAddDevices].ref
          };
        }
      }
    }

    // Checking if proper number of SPARE DEVICES are selected
    if (
      getFieldValue(fieldDoesCustomerRequireSpareDevices, formFields) === yes
    ) {
      if (_.get(formFields, 'additionalSpareDevices', []).length === 0) {
        result[fieldAddSpareDevices] = {
          text: minSpareDevicesErrorMessage,
          ref: formFields[fieldAddSpareDevices].ref
        };
      } else if (maxTotalDevices < currentTotalDevices) {
        result[fieldAddSpareDevices] = {
          text: msgMaxDevices(maxTotalDevices),
          ref: formFields[fieldAddSpareDevices].ref
        };
      }
    }
    let chatQuantity;
    
    // FIRST PASS: Collect chatQuantity from chat/contact centre fields
    allAdditionalFeaturesOfOdysseyAIValidationField.forEach(field => {
      if (formFields[field]) {
        const isChecked = formFields[field].checked;
        const seatField = formFields[`${field}_OdysseyAI`];
        const seatValue = seatField && seatField.value;

        if (isChecked && singleSelectChatFields.includes(field) && seatValue) {
          chatQuantity = seatValue;
        }
      }
    });

    // SECOND PASS: Validate all fields
    allAdditionalFeaturesOfOdysseyAIValidationField.forEach(field => {
      if (formFields[field]) {
        const isChecked = formFields[field].checked;
        const seatField = formFields[`${field}_OdysseyAI`];
        const seatValue = seatField && seatField.value;
        const { totalNoOfSeats } = getSeatsData();

        if (isChecked) {
          // Validate only when the main checkbox is checked
          if (!hideChatFieldsForOdysseyAI.includes(field)) {
            // Chat/Contact Centre fields - validate against total seats.
            // AI Insights may exceed the seat count (AI add-on orders, spec 034).
            if (
              seatValue &&
              seatValue > totalNoOfSeats &&
              field !== fieldInsightsOdysseyAI
            ) {
              result[`${field}_OdysseyAI`] = {
                text: `${validationErrorTwo}`,
                ref: seatField.ref
              };
            } else if (seatValue) {
              // If valid, remove previous error (if any)
              delete result[`${field}_OdysseyAI`];
            }
          } else if (hideChatFieldsForOdysseyAI.includes(field)) {
            // AI Enhancement fields (Insights, Agent Assist, Supervisor Assist)
            const isSupervisorField = field === 'supervisorAssistOdysseyAI' || field === 'supervisorAssistConcurrentOdysseyAI';
            
            if (isSupervisorField) {
              // Supervisor Assist quantities are auto-populated; skip manual validation errors.
              delete result[`${field}_OdysseyAI`];
            } else if (seatValue && chatQuantity && Number(seatValue) > Number(chatQuantity)) {
              // Other AI enhancement fields (Insights, Agent Assist) validate against chat quantity
              result[`${field}_OdysseyAI`] = {
                text: `${validationErrorThree}`,
                ref: seatField.ref
              };
            } else if (seatValue && chatQuantity && Number(seatValue) <= Number(chatQuantity)) {
              delete result[`${field}_OdysseyAI`];
            }
          }
        } else if (!isChecked) {
          // Checkbox not selected → always remove the error
          delete result[`${field}_OdysseyAI`];
        }
      }
    });

    if (!_.get(orderData, 'assignedToSRT', 0))
      delete result[fieldeContractNumber];

    if (isc2fMigrationFlow) {
      delete result[fieldeContractNumber];
    }

    if (
      _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
      valueNoInstall
    ) {
      delete result[fieldPreferredInstallationDate];
    }

    if (!isApprovalCodeFieldVisible() || isc2fMigrationFlow) {
      delete result[fieldApprovalCodeWhiteGlove];
    }

    return result;
  };

  const getFormData = () => {
    const result = Object.keys(formFields)
      .filter(key => typeof formFields[key].value !== 'undefined')
      .reduce((acc, key) => {
        const { type, value: oldValue, checked, isVisible } = formFields[key];
        const value = isVisible ? oldValue : '';

        if (key === fieldBusinessConnectEditionWorkplace && value) {
          acc[fieldBusinessConnectEdition] = value;
        }

        acc[key] = type === 'Checkbox' ? checked : value;
        return acc;
      }, {});

    if (
      formFields[fieldApprovalCodeWhiteGlove] &&
      !isApprovalCodeFieldVisible(formFields)
    ) {
      result[fieldApprovalCodeWhiteGlove] = '';
    }
    if (
      formFields[fieldHaveYouArrangedWhiteGloveTechnician] &&
      formFields[fieldDoesTheCustomerRequireWhiteGlove] &&
      !isTpiSelected(formFields)
    ) {
      result[fieldHaveYouArrangedWhiteGloveTechnician] = '';
    }
    [fieldReceptionistInstall, fieldInsightsInstall].forEach(fieldName => {
      if (
        formFields[fieldName] &&
        !isAiInstallFieldEnabled(fieldName, formFields)
      )
        result[fieldName] = false;
    });

    // Implementation page: the TPI group's "Preferred install date" replaces
    // "Please indicate a preferred installation date"; keep SFDC output filled.
    if (isPreferredInstallationDateReplaced(formFields)) {
      result[fieldPreferredInstallationDate] = getFieldValue(
        fieldPreferredInstallDate,
        formFields
      );
    }
    if (
      formFields[fieldNumberOfSitesThatRequireWhiteGlove] &&
      formFields[fieldNumberOfSitesThatRequireWhiteGlove].isVisible
    ) {
      result[fieldNumberOfSitesThatRequireWhiteGlove] = 1;
    }

    // Devices
    if (formFields[keyDevices]) {
      const field = findField(formStepFields, fieldAddDevices);
      if (field) {
        if (isRelatedFieldExisted(field.fields, formFields)) {
          result[keyDevices] = formFields[keyDevices];
        } else {
          result[keyDevices] = [];
        }
      } else {
        result[keyDevices] = formFields[keyDevices];
      }
    }
    if (formFields[keySpareDevices]) {
      const field = findField(formStepFields, fieldAddSpareDevices);
      if (field) {
        if (isRelatedFieldExisted(field.fields, formFields)) {
          result[keySpareDevices] = formFields[keySpareDevices];
        } else {
          result[keySpareDevices] = [];
        }
      } else {
        result[keySpareDevices] = formFields[keySpareDevices];
      }
    }
    if (formFields[keyDevicesWereChanged]) {
      const { starterSeatDetails, officeSeatDetails } = contentFulFields;
      result[starterSeatDetails] = [];
      result[officeSeatDetails] = [];
    }

    if (formFields[fieldNewPriceNote]) {
      result[fieldNewPriceNote] = !!getFieldValue(
        fieldNewPriceNote,
        formFields
      );
    }

    if (formFields[fieldNoteVoicePlusRecontract]) {
      result[fieldNoteVoicePlusRecontract] =
        formFields[fieldNoteVoicePlusRecontract].value;
    }
    if (formFields[keyWhiteGloveLocations]) {
      result[keyWhiteGloveLocations] = formFields[keyWhiteGloveLocations];
    }
    if (formFields[keyDirectoryListingDetails]) {
      result[keyDirectoryListingDetails] =
        formFields[keyDirectoryListingDetails];
    }

    if (step === 1) {
      const editionMapping = {
        'Voice +': 'voicePlus',
        Enhanced: 'enhanced',
        Complete: 'complete',
        'Complete +': 'completePlus',
        'Voix PLUS': 'voicePlus',
        Amélioré: 'enhanced',
        Complet: 'complete',
        'Complet PLUS': 'completePlus'
      };
      const fieldBCEvalue =
        formFields.businessConnectEdition &&
        editionMapping[formFields.businessConnectEdition.value];

      // The internetOffer field is always BYOA now
      if (orderData[fieldWhoIsTheExistingInternetProvider] === 'TELUS') {
        result[fieldInternetOffer] = internetOfferTelus;
      } else {
        result[fieldInternetOffer] = internetOfferOther;
      }

      // Reset VBP Starter Seat Rate if VBP == No
      if (result[fieldVbpRequired] === no) {
        result[fieldVpbStarterSeatRate] = '';
      }

      if (formFields[`vpbOfficeSeatRate_${fieldBCEvalue}`]) {
        result.vpbOfficeSeatRate =
          result[fieldVbpRequired] === no
            ? ''
            : formFields[`vpbOfficeSeatRate_${fieldBCEvalue}`].value;
        delete result[`vpbOfficeSeatRate_${fieldBCEvalue}`];
      }

      if (formFields[`vbpDesiredPrice_${fieldBCEvalue}`]) {
        result.vbpDesiredPrice =
          result[fieldVbpRequired] === no
            ? ''
            : formFields[`vbpDesiredPrice_${fieldBCEvalue}`].value;
        delete result[`vbpDesiredPrice_${fieldBCEvalue}`];
      }

      if (
        getFieldValue(fieldBusinessConnectEdition, formFields) === voice &&
        getFieldValue(fieldTypeOfInstallation, formFields) !== valueAddon &&
        maxDevices(formFields) > 5
      ) {
        // For BCON Voice starter and office seats have the same rate
        result.vpbOfficeSeatRate = rates[keyStarterSeatRateStandard];
      }
    }

    // Features
    const features = getFeatures(formFields);
    if (features) {
      result[keyFeatures] = features;
    }

    // Starter and office seats rates standard
    if (rates[keyStarterSeatRateStandard]) {
      result[keyStarterSeatRateStandard] = rates[keyStarterSeatRateStandard];
    }
    if (rates[keyOfficeSeatRateStandard]) {
      result[keyOfficeSeatRateStandard] = rates[keyOfficeSeatRateStandard];
    }

    if (result[fieldWhoIsTheExistingInternetProviderForOtherState]) {
      result[fieldWhoIsTheExistingInternetProvider] =
        result[fieldWhoIsTheExistingInternetProviderForOtherState];
      delete result[fieldWhoIsTheExistingInternetProviderForOtherState];
    }

    if (!isAdditionalRsiOptionsAvailable())
      result[fieldAdditionalRsiOptions] = [];

    if (result[fieldBusinessType] === businessRegular) {
      result[fieldLegalBusinessNameBusinessPersonal] = '';
      result[fieldDriversLicenseNumber] = '';
      result[fieldDriversLicenseExpiry] = '';
      result[fieldDateOfBirth] = '';
    } else if (result[fieldBusinessType] === businessPersonal) {
      result[fieldLegalBusinessNameBusinessRegular] = '';
      result[fieldOperatingAs] = '';
      result[fieldBusinessIncorporationNumber] = '';
      result[fieldIncorporationDate] = '';
    } else if (
      result[fieldInternetOffer] &&
      result[fieldInternetOffer] !== telusCopperNew
    ) {
      result[fieldPlan] = '';
    }

    // GSuite logic
    if (formName === orderDetailsForm && step === 1) {
      if (
        orderData[fieldIsThisAnExistingGSuiteCustomer] === no &&
        result[fieldBusinessConnectEdition] !== mobile &&
        result[fieldBusinessConnectEdition] !== voice &&
        result[fieldContractTerm] !== monthToMonth
      ) {
        const complimentarySeats = gSuiteBusinessLicences(formFields);
        const customerOptOut = getFieldChecked(
          fieldOptOutFromGSuiteBusinessLicenses,
          formFields
        );
        result[keyGSuiteEligible] = true;
        result[keyGSuiteComplimentarySeats] = complimentarySeats;
        result[keyGSuiteBusinessLicences] = !customerOptOut
          ? stringInterpolation(gSuiteNote, complimentarySeats)
          : '';
        if (result[fieldOptOutFromGSuiteBusinessLicenses] === true) {
          result[fieldAdditionalGSuiteBusinessLicences] = '';
          result[fieldGSuiteBasicLicences] = '';
          result[fieldGSuiteInstallAndSetup] = '';
          result[fieldGSuiteEmailMigrationServices] = '';
          result[fieldGSuiteEmailMigrationServicesPaymentType] = '';
        }
      } else {
        result[keyGSuiteEligible] = false;
        result[keyGSuiteComplimentarySeats] = '';
        result[keyGSuiteBusinessLicences] = '';
        result[fieldAdditionalGSuiteBusinessLicences] = '';
        result[fieldGSuiteBasicLicences] = '';
        result[fieldGSuiteInstallAndSetup] = '';
        result[fieldGSuiteEmailMigrationServices] = '';
        result[fieldGSuiteEmailMigrationServicesPaymentType] = '';
      }
    }

    if (result[fieldDoesTheCustomerHaveADomainAlready] === no) {
      result[
        fieldDomainToBeAssociatedWithGSuiteAccount
      ] = customerRequiresDomainName;
    }

    const valueIsThisOdysseyAI = _.get(orderData, 'isThisOdysseyAI', '');
    // odyssey payload
    if (step === 1 && valueIsThisOdysseyAI === yes) {
      const valueCustomerSegment = _.get(orderData, fieldCustomerSegment, '');
      const valueContractTerm =
        getFieldValue(fieldContractTerm, formFields) || '';
      const valueProvinceServiceAddress =
        getFieldValue(fieldProvinceServiceAddress, formFields) || '';
      const valueOtherTelusServices = getFieldValue(
        fieldOtherTelusServices,
        formFields
      );
      const valueBusinessConnectEdition = getFieldValue(
        fieldBusinessConnectEdition,
        formFields
      );

      const editionSeatPriceOdysseyAI = editionPriceForOdysseyAI[valueBusinessConnectEdition];

      const multiUnitDiscountValue =
        formFields[fieldAvailableDiscountsAndPromotions].value &&
        formFields[fieldAvailableDiscountsAndPromotions].value.find(item =>
          item.includes('Multi-Unit Discount')
        );

      // Get selected OdysseyAI promotions.
      // The new BCON-AI flat $10-off offers ("Bus Con $10 off for 36/60 months")
      // are not part of the Contentful ODYSSEY_AI_PROMOTIONS list but must
      // participate in the same pricing math (treated as contract discounts
      // using their Contentful monthlyPayment), so include them explicitly.
      // The same applies to the edition-specific $4/$7 off promos.
      const extraAiPricingPromos = [
        BusCon$10OffFor36Months,
        BusCon$10OffFor60Months,
        BusCon$4DiscountOn36Months,
        BusCon$4DiscountOn60Months,
        BusCon$7OffFor36Months,
        BusCon$7OffFor60Months,
        BusCon$5OffFor36Months,
        BusCon$5OffFor60Months
      ];
      const selectedOdysseyAIPromos = formFields[fieldAvailableDiscountsAndPromotions].value
        ? formFields[fieldAvailableDiscountsAndPromotions].value.filter(promo =>
            allOdysseyAIPromos.includes(promo) || extraAiPricingPromos.includes(promo)
          )
        : [];

      // Calculate contract discount from selected promotions
      let contractDiscount = 0;
      let contractDiscountLabel = '';
      const contractDiscounts = [];
      let bundledDiscount = 0;

      selectedOdysseyAIPromos.forEach(promo => {
        const promoOption = formFields[fieldAvailableDiscountsAndPromotions].options.find(
          opt => opt.fields.value === promo
        );
        if (promoOption && promoOption.fields.monthlyPayment) {
          const discountAmount = Math.abs(promoOption.fields.monthlyPayment);
          
          // Check if it's a contract discount (3 or 5 years, no bundling)
          // English: "contract discount" | French: "avec une entente de"
          const isContractDiscount = 
            promo.includes('contract discount') ||
            extraAiPricingPromos.includes(promo) ||
            (promo.includes('avec une entente de') && !promo.includes('services groupés'));
          
          if (isContractDiscount) {
            const label = extraAiPricingPromos.includes(promo) ? promo : '';
            contractDiscount += discountAmount;
            contractDiscounts.push({
              amount: discountAmount,
              label
            });
            if (!contractDiscountLabel || label) {
              contractDiscountLabel = label;
            }
          }
          
          // Check if it's a bundled discount
          // English: "bundled discount" | French: "services groupés"
          const isBundledDiscount = 
            promo.includes('bundled discount') || 
            promo.includes('services groupés');
          
          if (isBundledDiscount) {
            bundledDiscount = Math.max(bundledDiscount, discountAmount);
          }
        }
      });

      // Check if "3 months free" is selected
      const hasThreeMonthsFree = formFields[fieldAvailableDiscountsAndPromotions].value
        ? formFields[fieldAvailableDiscountsAndPromotions].value.includes(valueThreeMonthsFree)
        : false;

      // Get MUD discount value if selected
      let mudDiscount = 0;
      if (multiUnitDiscountValue) {
        // Extract dollar value from MUD option name (e.g., "Multi-Unit Discount: Bus Con $2")
        const mudMatch = multiUnitDiscountValue.match(/\$(\d+)/);
        if (mudMatch && mudMatch[1]) {
          mudDiscount = Number(mudMatch[1]);
        }
      }

      // Calculate 3 months free value: editionPrice - bundled - contract - MUD
      let threeMonthsFreeValue = 0;
      if (hasThreeMonthsFree) {
        const editionPrice = editionSeatPriceOdysseyAI;
        const appliedBundledDiscount = valueOtherTelusServices === yes ? bundledDiscount : 0;
        threeMonthsFreeValue = editionPrice - appliedBundledDiscount - contractDiscount - mudDiscount;
        // Ensure it's not negative
        threeMonthsFreeValue = Math.max(0, threeMonthsFreeValue);
      }

      result.isThisOdysseyAIDataForQuote = {
        editionPrice: editionSeatPriceOdysseyAI,
        bundledPrice:
          valueOtherTelusServices === yes ? bundledDiscount : 0,
        contract: contractDiscount,
        contractLabel: contractDiscountLabel,
        contractDiscounts,
        offer: !multiUnitDiscountValue ? '' : multiUnitDiscountValue
      };

      // Add threeMonthsFree if the promotion is selected, otherwise clear it
      if (hasThreeMonthsFree) {
        result.isThisOdysseyAIDataForQuote.threeMonthsFree = threeMonthsFreeValue;
      } else {
        result.isThisOdysseyAIDataForQuote.threeMonthsFree = 0;
      }
    }

    return result;
  };

  // This function is used to determine if VBP approval is required
  const checkVBP = () => {
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      formFields
    );
    const statusOfQuote = _.get(orderData, 'quoteStatus', '');
    const statusOfOrder = _.get(orderData, 'status', '');
    const valueIsSrtTeamMember = getFieldValue(
      fieldIsSrtTeamMember,
      formFields
    );

    if (statusOfOrder === orderStatus.waitingOnSales) return false;
    const customerRequireVBP = _.get(formFields, 'vbpRequired.value', no);

    // BCON-2653: Add On orders with custom pricing now go through the same
    // approval-workflow check as New orders (the previous unconditional
    // `valueOrderType === valueAddon` bypass has been removed). The role
    // exemptions below (Order Fulfillment Team, Sales Support, SRT-team
    // Sales Reps) are unchanged and apply regardless of installation type.
    if (
      isOrderFulfillmentTeam ||
      isSalesSupport ||
      (isSalesRep && valueIsSrtTeamMember === yes)
    )
      return false;

    if (customerRequireVBP === yes && statusOfQuote === quoteStatus.approved) {
      const approvedRate = _.get(orderData, fieldVpbOfficeSeatRate);
      const vbpOfficeSeatRateKey = {
        'Voice +': 'vpbOfficeSeatRate_voicePlus',
        Enhanced: 'vpbOfficeSeatRate_enhanced',
        Complete: 'vpbOfficeSeatRate_complete',
        'Complete +': 'vpbOfficeSeatRate_completePlus'
      };
      const currentRate = getFieldValue(
        vbpOfficeSeatRateKey[valueBusinessConnectEdition],
        formFields
      );
      return +approvedRate !== +currentRate;
    }
    return customerRequireVBP === yes;
  };

  const validateForm = e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      setFormErrorSummary('');
      const fields = getFormData();
      const vbp = checkVBP();
      const newStatus = vbp
        ? quoteStatus.pendingApproval
        : quoteStatus.approved;

      onSave({ ...fields,appliedCoupons, quoteStatus: newStatus }).then(() => {
        setIsFormValidated(true);
        setIsVBP(vbp);
      });
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref, text } = firstError;
      if (ref && ref.current) {
        ref.current.focus();
      } else {
        // Field failing validation isn't currently rendered/focusable (e.g. a conditionally
        // hidden required field) - surface a visible banner instead of silently no-op'ing.
        setFormErrorSummary(text || fieldRequiredMessage);
        if (formStepRef && formStepRef.current) formStepRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const onSendToSRT = e => {
    e.preventDefault();
    const fields = getFormData();
    sendToSRT({ ...fields }).then(() => {
      setModalData({
        ...modalData,
        title: sendToSRTModal.title,
        body: sendToSRTModal.body,
        confirmText: sendToSRTModal.confirmText,
        cancelText: sendToSRTModal.cancelText,
        open: true
      });
    });
  };

  const onSubmitForApproval = e => {
    e.preventDefault();
    const fields = getFormData();
    submitForApproval({ ...fields, appliedCoupons }).then(() => {
      setModalData({
        ...modalData,
        title: sendFoApprovalModal.title,
        body: sendFoApprovalModal.body,
        confirmText: sendFoApprovalModal.confirmText,
        cancelText: sendFoApprovalModal.cancelText,
        open: true
      });
    });
  };
  const saveAndExit = () => {
    const fields = getFormData();
    const availablePromo = _.get(orderData, 'availableNewpromo', []);

    fields.availableNewpromo = fields.availableDiscountsAndPromotions
      ? fields.availableDiscountsAndPromotions
      : availablePromo;
    if (Object.entries(fields).length) {
      onSaveAndExit({ ...fields,appliedCoupons });
    }
  };

  const nextStep = e => {
    if (isSubmitting) return;
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      setFormErrorSummary('');
      setIsSubmitting(true);
      try {
        const fields = getFormData();
        if (formName === orderDetailsForm && step === 1) {
          fields.quoteStatus = quoteStatus.approved;
        }
        onFormSubmit({ ...fields,appliedCoupons, ...(isThisOdysseyAIOrder ? { dueMonthlyOdysseyAI: step === 1 ? dueMonthly : 0 } : {}) });
      } finally {
        setTimeout(() => setIsSubmitting(false), 2000);
      }
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref, text } = firstError;
      if (ref && ref.current) {
        ref.current.focus();
      } else {
        // Field failing validation isn't currently rendered/focusable (e.g. a conditionally
        // hidden required field) - surface a visible banner instead of silently no-op'ing.
        setFormErrorSummary(text || fieldRequiredMessage);
        if (formStepRef && formStepRef.current) formStepRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  const resetFormFields = (fields, currentFieldName) => {
    if (currentFieldName === fieldYesToAllAdvisories) return fields;
    const { resetFields, customResetFields } = fields[currentFieldName];
    let isResetRequired = false;
    const newFields = { ...fields };
    for (let index = 0; index < formStepFields.length; index += 1) {
      const {
        fields: { name, appearsAfterField, value }
      } = formStepFields[index];
      if (name === currentFieldName) {
        isResetRequired = true;
      } else if (isResetRequired) {
        const field = fields[name];
        if (appearsAfterField && field.isVisible)
          newFields[name] = { ...field, isVisible: false, value };
      }
    }
    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(newFields[fieldName], 'value'))
          newFields[fieldName].value = '';
        else delete newFields[fieldName];
      });
    }
    return newFields;
  };

  const isFieldCalculated = (type, value, checked, price) => {
    switch (type) {
      case 'Radio':
        return value === yes && price;
      case 'Checkbox':
        return checked && price;
      default:
        return value && price;
    }
  };

  const calcPriceSeatsWhiteGlove = fields => {
    let result = { dueNow: 0, dueMonthly: 0 };
    const approvalCode = getFieldValue(fieldApprovalCodeWhiteGlove, fields);

    // Get BAN value - check both BAN fields
    const banValue = getFieldValue(fieldBAN, fields) || 
                     getFieldValue(fieldExistingBusinessConnectBANNumber, fields);
    const isTELUSProfessionalInstallationBAN = banValue === TELUS_PROFESSIONAL_INSTALLATION_BAN_NUMBER;
    
    // Check if approval code is "Dealer Install" - should use regular pricing, not approval code pricing
    const isDealerInstall = approvalCode && approvalCode.trim().toUpperCase() === approvalCodeDealerInstall.toUpperCase();

    // Get latest installation coupon (used for both Professional and Virtual)
    const latestInstallationCoupon = installationCoupons
      .filter(coupon => {
        const couponType = (coupon.coupon && coupon.coupon.couponType) || coupon.couponType || '';
        return couponType.toLowerCase().includes(couponTypeInstallation.toLowerCase()) && coupon.isApplied !== false;
      })
      .sort((a, b) => {
        const dateA = new Date(a.appliedAt || 0);
        const dateB = new Date(b.appliedAt || 0);
        return dateB - dateA; // Sort by most recent first
      })[0];
    
    const paymentType =
      fields[fieldHowCustomerWantToPayForWhiteGlove] &&
      fields[fieldHowCustomerWantToPayForWhiteGlove].value;
    const isPaymentMonthly = paymentType === valueEasyPayment;
    
    // Only apply coupon if duration matches payment type (for Professional Installation)
    // For Virtual Installation, use one-time coupon value if available
    let isCouponMonthly = false;
    let couponValue = 0;
    if (latestInstallationCoupon) {
      const couponDuration = (latestInstallationCoupon.duration || '').toLowerCase();
      isCouponMonthly = couponDuration.includes('monthly');
      const installationType = getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields);
      
      if (installationType === valueTelusProfessionalInstallation) {
        // For Professional Installation: only use coupon if duration matches payment type
        if ((isCouponMonthly && isPaymentMonthly) || (!isCouponMonthly && !isPaymentMonthly && paymentType === valuePaymentUpfront)) {
          couponValue = Number(latestInstallationCoupon.dollarValue) || 0;
        }
      } else {
        // For Virtual Installation: use one-time coupon value if available
        if (!isCouponMonthly) {
          couponValue = Number(latestInstallationCoupon.dollarValue) || 0;
        }
      }
    }

    if (
      getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
      valueTelusProfessionalInstallation
    ) {

      const baseQuantity = isRecontractFlow
        ? +(
            (fields[fieldRecontractSeatsCustomerAdding] &&
              fields[fieldRecontractSeatsCustomerAdding].value) ||
            0
          )
        : +(
            (fields[fieldNumberOfSeatsThatRequireWhiteGlove] &&
              fields[fieldNumberOfSeatsThatRequireWhiteGlove].value) ||
            0
          );
      // BCON: Limited Edition / Limited Extension (LE) seats no longer drive
      // the TELUS Professional Installation (TPI) charge on OdysseyAI orders
      // (undo of BCON-2601 — FR-017, AI orders only).
      // FR-018 (AI only): On OdysseyAI Add-on orders, TPI is charged for Office
      // Seats only — starter seats excluded. Non-AI orders keep baseQuantity.
      const isAddonInstallationForWg =
        getFieldValue(fieldTypeOfInstallation, fields) === valueAddon;
      const quantity =
        isThisOdysseyAIOrder && !isRecontractFlow && isAddonInstallationForWg
          ? +(getFieldValue(fieldOfficeSeats, fields) || 0)
          : baseQuantity;
      if (paymentType === valueEasyPayment) {
        let newPrice;
        let newPriceDueNow = 0;
        
        // Check for BAN-specific pricing first (only for upfront, but check here for consistency)
        // For Easy Payment, BAN doesn't change pricing, use normal logic
        
        // Check if approval code exists and is NOT "Dealer Install"
        if (
          isApprovalCodeFieldVisible(fields) &&
          // approvalCode === approvalCodeProfessionalInstall && // For Easy Payment, we can have a different approval code, so don't check for specific code, just check if approval code is entered
          !isDealerInstall
        ) {
          newPrice = quantity * (couponValue && isCouponMonthly ? couponValue : approvalCodePriceSeatsWhiteGloveEasyPayment);
        } else {
          newPrice = quantity * (couponValue && isCouponMonthly ? couponValue : priceSeatsWhiteGloveEasyPayment);
        }
        // 1 site pricing stays fixed - don't apply coupon, exclude if BAN matches
        if (
          Number(getFieldValue(fieldStarterSeat, fields)) === 1 &&
          !isRecontractFlow &&
          !isTELUSProfessionalInstallationBAN
        ) {
          newPriceDueNow += priceSitesWhiteGloveFee;
        }
        result = { dueNow: newPriceDueNow, dueMonthly: newPrice };
      } else if (paymentType === valuePaymentUpfront) {
        let newPrice;
        
        // Check for BAN-specific pricing first
        if (isTELUSProfessionalInstallationBAN) {
          // BAN 39475589 uses special price 270, no coupon applied
          newPrice = quantity * TELUS_PROFESSIONAL_INSTALLATION_BAN_PRICE;
        } else if (
          isApprovalCodeFieldVisible(fields) &&
          approvalCode &&
          !isDealerInstall
        ) {
          // Approval code pricing (not dealer install)
          newPrice = quantity * (couponValue && !isCouponMonthly ? couponValue : approvalCodePriceSeatsWhiteGloveUpfront);
        } else {
          // Regular pricing
          newPrice = quantity * (couponValue && !isCouponMonthly ? couponValue : priceSeatsWhiteGloveUpfront);
        }
        // 1 site pricing stays fixed - don't apply coupon, exclude if BAN matches
        if (
          Number(getFieldValue(fieldStarterSeat, fields)) === 1 &&
          !isRecontractFlow &&
          !isTELUSProfessionalInstallationBAN
        ) {
          newPrice += priceSitesWhiteGloveFee;
        }
        result = { dueNow: newPrice, dueMonthly: 0 };
      } else if (paymentType === valueDealerBilledDirect) {
        // Dealer Billed Direct is hidden when approval is required; the $240
        // branch only guards stale values.
        let newPrice =
          quantity *
          (isApprovalCodeFieldVisible(fields)
            ? approvalCodePriceSeatsWhiteGloveUpfront
            : priceSeatsWhiteGloveUpfront);
        if (
          Number(getFieldValue(fieldStarterSeat, fields)) === 1 &&
          !isRecontractFlow &&
          !isTELUSProfessionalInstallationBAN
        ) {
          newPrice += priceSitesWhiteGloveFee;
        }
        result = { dueNow: newPrice, dueMonthly: 0 };
      } else {
        result = { dueNow: 0, dueMonthly: 0 };
      }
    }

    if (
      getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
      valueTelusVirtualInstallation
    ) {
      result = { dueNow: isc2fMigrationFlow ? 0 : (couponValue && !isCouponMonthly ? couponValue : 75), dueMonthly: 0 };
    }
    const totalSeats =
      Number(getFieldValue(fieldStarterSeat, fields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, fields) || 0);
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const isVirtualInstallationVisible =
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      getFieldValue(fieldTypeOfInstallation, fields) === valueAddon &&
      totalSeats <= 99 &&
      (isThisMobileEditionOrder ||
        [mobile, complete, completePlus, voicePlus, enhanced].includes(
          valueBusinessConnectEdition
        )) &&
      getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
        valueTelusVirtualInstallation;
    if (isVirtualInstallationVisible) {
      result = { dueNow: (couponValue && !isCouponMonthly ? couponValue : 75) };
    }

    if (
      getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields) ===
      valueNoInstall
    ) {
      result = { dueNow: isc2fMigrationFlow ? 0 : (couponValue && !isCouponMonthly ? couponValue : 0), dueMonthly: 0 };
    }
    return result;
  };

  const updateTotals = (name, field) => {
    const { value, checked, type, price, monthlyPayment, isVisible } = field;

    if (isFieldInFeatures(name)) return;
    if (!isVisible) return;

    if (name === fieldProfessionalServicesFileCharges) {
      if (!isThisOdysseyAIOrder) return;
      const oldRaw = formFields[name] && formFields[name].value;
      const oldAmt =
        oldRaw === '' || oldRaw === undefined || oldRaw === null
          ? 0
          : Number(oldRaw);
      const newAmt =
        value === '' || value === undefined || value === null
          ? 0
          : Number(value);
      const safeOld = Number.isNaN(oldAmt) || oldAmt < 0 ? 0 : oldAmt;
      const safeNew = Number.isNaN(newAmt) || newAmt < 0 ? 0 : newAmt;
      setDueNow(dueNow - safeOld + safeNew);
      return;
    }

    if (
      [
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences
      ].includes(name)
    )
      return;

    let oldQuantity;
    let newQuantity;
    let oldPrice;
    let newPrice;

    if (type === 'Number') {
      oldQuantity = (formFields[name] && formFields[name].value) || 0;
      newQuantity = value ? Number(value) : 0;
      if (price > 0) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment > 0) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    } else if (type === 'Checkbox' && name !== fieldDoesTheCustomerRequireSmartHub) {
      // Standalone checkbox pricing — isolated from the value-based path below
      // so it cannot affect existing field logic. A checkbox stores its on/off
      // state in `checked` (its `value` stays ''), so the quantity is derived
      // from `checked`. The old-vs-new delta means selecting ADDS the price and
      // unselecting REMOVES it. Guarded by a truthy price / monthlyPayment so
      // checkboxes without a configured charge are left untouched.
      const oldChecked = formFields[name] && formFields[name].checked ? 1 : 0;
      const newChecked = checked ? 1 : 0;
      const oneTimePrice = getStandaloneCheckboxPrice(name, price);
      if (oneTimePrice) {
        setDueNow(
          dueNow - oneTimePrice * oldChecked + oneTimePrice * newChecked
        );
      }
      if (monthlyPayment) {
        setDueMonthly(
          dueMonthly - monthlyPayment * oldChecked + monthlyPayment * newChecked
        );
      }
    } else if (name !== fieldDoesTheCustomerRequireSmartHub) {
      oldQuantity = formFields[name] && formFields[name].value ? 1 : 0;
      newQuantity = value ? 1 : 0;
      if (isFieldCalculated(type, value, checked, price)) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (isFieldCalculated(type, value, checked, monthlyPayment)) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    }
  };

  // Sum the monthly / one-time charges of standalone (non-feature) checkboxes
  // that are checked and visible. Kept out of the feature and rate pipelines so
  // it cannot affect existing pricing; used on order re-open (in the totals
  // effect and Due Now recompute) to restore a checked checkbox's price.
  const getStandaloneCheckboxPrices = fields => {
    const result = { monthly: 0, oneTime: 0 };
    if (!fields) return result;
    Object.keys(fields).forEach(name => {
      const field = fields[name];
      if (
        field &&
        field.type === 'Checkbox' &&
        field.checked &&
        field.isVisible &&
        name !== fieldDoesTheCustomerRequireSmartHub &&
        !isFieldInFeatures(name)
      ) {
        const monthly = Number(field.monthlyPayment);
        const oneTime = getStandaloneCheckboxPrice(name, field.price);
        if (!Number.isNaN(monthly)) result.monthly += monthly;
        result.oneTime += oneTime;
      }
    });
    return result;
  };

  const isMppEnhancedPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );

    return (
      valueSegment === valueSegmentSmb1To30 &&
      valueBusinessConnectEdition === enhanced
    );
  };

  const isVoicePlusPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );

    return (
      isDealer &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueOtherTelusServices === yes &&
      valueBusinessConnectEdition === voicePlus
    );
  };

  const isOneTime50BillCreditAvailable = fields => {
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueTerm = getFieldValue(fieldContractTerm, fields);
    const valueType = getFieldValue(fieldTypeOfInstallation, fields);

    return (
      [voicePlus, enhanced, complete, 'Complete +'].includes(
        valueBusinessConnectEdition
      ) &&
      valueTerm === threeYears &&
      valueType === valueNew &&
      !isBCX &&
      !isCorpStore
    );
  };

  const isCbmEnhancedPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valuePostalCode =
      getFieldValue(fieldPostalCodeServiceAddress, fields) || '';
    const isPostalCodePresent = cbmPromoPostalCodeList.includes(
      valuePostalCode.replace(/\s+/g, '').slice(0, 3)
    );

    return (
      valueSegment === valueSegmentSmb1To30 &&
      valueBusinessConnectEdition === enhanced &&
      isPostalCodePresent
    );
  };

  const isEnhancedPromoAvailable = fields => {
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueIsThisAnExistingGSuiteCustomer = _.get(
      orderData,
      fieldIsThisAnExistingGSuiteCustomer,
      ''
    );
    const valueOptedGoogleWorkspace =
      valueTerm === monthToMonth
        ? true
        : getFieldChecked(fieldOptOutFromGSuiteBusinessLicenses, fields);

    return (
      valueBusinessConnectEdition === enhanced &&
      valueOtherTelusServices === yes &&
      (valueIsThisAnExistingGSuiteCustomer !== no || valueOptedGoogleWorkspace)
    );
  };

  const updateRates = fields => {
    const fieldBCE = checkBusinessConnectEdition(
      fieldBusinessConnectEdition,
      orderData,
      formName,
      yes
    );

    const valueBCE = getFieldValue(fieldBCE, fields);
    const quantityStarter = +getFieldValue(fieldStarterSeat, fields) || 0;
    const quantityOffice = +getFieldValue(fieldOfficeSeats, fields) || 0;
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueSelectedPromos =
      getFieldValue(fieldAvailableDiscountsAndPromotions, fields) || [];
    const valueBundle =
      valueOtherTelusServices === yes ||
      (valueOtherTelusServices === no &&
        valueSelectedPromos.includes(valueMppPromo))
        ? 'bundled'
        : 'nonBundled';

    const valueNewStarterSeatPrice = getFieldValue(
      fieldWhatIsTheNewStarterSeatPrice,
      fields
    );

    const valueNewOfficeSeatPrice = getFieldValue(
      fieldWhatIsTheNewOfficeSeatPrice,
      fields
    );

    const valueCustomerCurrentStarterSeatPrice = getFieldValue(
      fieldWhatIsTheCustomersCurrentStarterSeatPrice,
      fields
    );
    const valueCustomerCurrentOfficeSeatPrice = getFieldValue(
      fieldWhatIsTheCustomersCurrentOfficeSeatPrice,
      fields
    );
    const valueNewCustomerPrice = getFieldValue(
      fieldNewCustomerPriceOdyssey,
      fields
    ); 

    const valueProvinceServiceAddress =
      getFieldValue(fieldProvinceServiceAddress, fields) || '';
    const isQCProvincePresent = allowedProvinceQCBundle.includes(
      valueProvinceServiceAddress
    );
    const isQCProvinceNot = !allowedProvinceQCBundle.includes(
      valueProvinceServiceAddress
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields) || '';
    const valueEdition =
      getFieldValue(fieldBusinessConnectEdition, fields) || '';
    const valueTOI = getFieldValue(fieldTypeOfInstallation, fields) || '';

    const enhancedPromosList = [
      valueEnhancedPromoAvailable,
      valueMppEnhancedPromoAvailable,
      valueCbmEnhancedPromoAvailable
    ];
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueCustomerSegment = _.get(orderData, fieldCustomerSegment, '');
    const buinessConnectNewPrice = [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueCustomerSegment);
    const buinessConnectNewPriceMobile = [monthToMonth].includes(valueContractTerm) && valueOtherTelusServices === no;
    const buinessConnectNewPriceThreeYear = [threeYears].includes(valueContractTerm) && valueOtherTelusServices === no;
    const buinessConnecQCMonthtoMonth = buinessConnectNewPrice && valueContractTerm === monthToMonth && valueOtherTelusServices === yes && isQCProvinceNot;
    const buinessConnecQCThreeYear = buinessConnectNewPrice && valueContractTerm === threeYears && valueOtherTelusServices === yes && isQCProvinceNot;
    const bundleMonthtoMonth = buinessConnectNewPrice && allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) && valueOtherTelusServices === yes && valueContractTerm === monthToMonth && isQCProvincePresent ;
    const bundlethreeYear = buinessConnectNewPrice && allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) && valueOtherTelusServices === yes && valueContractTerm === threeYears && isQCProvincePresent ;
    const checkEligibility = valueOfEdition => {
      return (
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
        [threeYears, monthToMonth].includes(valueContractTerm) &&
        [valueOfEdition].includes(valueEdition) &&
        [valueAddon, valueNew].includes(valueTOI) &&
        allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) &&
        isQCProvincePresent &&
        valueOtherTelusServices === yes
      );
    };
    // const isEligibleComplete = checkEligibility(complete);
    // const isEligibleEnhanced = checkEligibility(enhanced);
    // const isEligibleVoicePlus = checkEligibility(voicePlus);
    const isEligibleCompletePlus = checkEligibility(completePlus);
    const isEnhancedPromoSelected =
      valueBCE === enhanced &&
      valueSelectedPromos.some(promo => enhancedPromosList.includes(promo));

    const isBusinessHeroPromoSelected = valueSelectedPromos.includes(
      valueBusinessHeroPromo
    );

    const isThreeMonthsPromoSelected = valueSelectedPromos.includes(
      valueThreeMonthsFree
    );

    const isVoicePlusPromoSelected = valueSelectedPromos.includes(
      valueVoicePlusPromo
    );

    let rateStarter = _.get(
      ratesStarterSeat,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );
    let rateOffice = _.get(
      ratesOfficeSeats,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );
    const rateStarterBase = rateStarter;
    const rateOfficeBase = rateOffice;
    if(buinessConnectNewPrice && buinessConnectNewPriceMobile && valueBusinessConnectEdition === mobile) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceMobile && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 35;
      rateOffice = 35;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceMobile && valueBusinessConnectEdition === enhanced) {
      rateStarter = 40;
      rateOffice = 40;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceMobile && valueBusinessConnectEdition === complete) {
      rateStarter = 45;
      rateOffice = 45;
    }
    // 3year
    if(buinessConnectNewPrice && buinessConnectNewPriceThreeYear && valueBusinessConnectEdition === mobile) {
      rateStarter = 20;
      rateOffice = 20;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceThreeYear && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceThreeYear && valueBusinessConnectEdition === enhanced) {
      rateStarter = 35;
      rateOffice = 35;
    }
    if(buinessConnectNewPrice && buinessConnectNewPriceThreeYear && valueBusinessConnectEdition === complete) {
      rateStarter = 40;
      rateOffice = 40;
    }
    // month to month Quebec
    if(buinessConnecQCMonthtoMonth && valueBusinessConnectEdition === mobile) {
      rateStarter = 20;
      rateOffice = 20;
    }
    if(buinessConnecQCMonthtoMonth && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if(buinessConnecQCMonthtoMonth && valueBusinessConnectEdition === enhanced) {
      rateStarter = 35;
      rateOffice = 35;
    }
    if(buinessConnecQCMonthtoMonth && valueBusinessConnectEdition === complete) {
      rateStarter = 40;
      rateOffice = 40;
    }
    // 3 year quebec
    if(buinessConnecQCThreeYear && valueBusinessConnectEdition === mobile) {
      rateStarter = 15;
      rateOffice = 15;
    }
    if(buinessConnecQCThreeYear && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if(buinessConnecQCThreeYear && valueBusinessConnectEdition === enhanced) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if(buinessConnecQCThreeYear && valueBusinessConnectEdition === enhanced && isThreeMonthsPromoSelected) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if(buinessConnecQCThreeYear && valueBusinessConnectEdition === complete) {
      rateStarter = 35;
      rateOffice = 35;
    }
    // month to month Quibec orderdata
    if(bundleMonthtoMonth && valueBusinessConnectEdition === mobile) {
      rateStarter = 20;
      rateOffice = 20;
    }
    if(bundleMonthtoMonth && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if(bundleMonthtoMonth && valueBusinessConnectEdition === enhanced) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if(bundleMonthtoMonth && valueBusinessConnectEdition === complete) {
      rateStarter = 35;
      rateOffice = 35;
    }
    // three year bundle quibec orderdata
    if(bundlethreeYear && valueBusinessConnectEdition === mobile) {
      rateStarter = 15;
      rateOffice = 15;
    }
    if(bundlethreeYear && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 20;
      rateOffice = 20;
    }
    if(bundlethreeYear && valueBusinessConnectEdition === enhanced) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if(bundlethreeYear && valueBusinessConnectEdition === complete) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if (isEnhancedPromoSelected) {
      rateStarter = 30;
      rateOffice = 30;
    }

    if (isBusinessHeroPromoSelected) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if (isVoicePlusPromoSelected) {
      rateStarter = 20;
      rateOffice = 20;
    }

    // ---------------------------------------------------------------------
    // NEW BCON Bundled flat-rate offers — override seat rate when selected.
    //   * Complete Bundled $25  : flat $25/seat (Regular BCON, all provinces)
    //   * Complete Bundled $30  : flat $30/seat (Regular BCON, all eligible terms)
    //   * Bus Con $10 off 36 mo : -$10/seat off the standard rate (BCON AI 3yr)
    //   * Bus Con $10 off 60 mo : -$10/seat off the standard rate (BCON AI 5yr)
    // The $25 and $30 are absolute rates (overrides). The $10-off promos are
    // additive discounts and stack with the prevailing rate.
    // ---------------------------------------------------------------------
    if (valueSelectedPromos.includes(CompleteBundledFlat$25)) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if (valueSelectedPromos.includes(CompleteBundled$30)) {
      rateStarter = 30;
      rateOffice = 30;
    }
    if (
      valueSelectedPromos.includes(BusCon$10OffFor36Months) ||
      valueSelectedPromos.includes(BusCon$10OffFor60Months)
    ) {
      rateStarter = Math.max(0, rateStarter - 10);
      rateOffice = Math.max(0, rateOffice - 10);
    }

    // OdysseyAI Enhanced $4 off and Complete $7 off per-seat promos.
    // Applied after the base OdysseyAI edition rate has been set above.
    if (
      valueSelectedPromos.includes(BusCon$4DiscountOn36Months) ||
      valueSelectedPromos.includes(BusCon$4DiscountOn60Months)
    ) {
      rateStarter = Math.max(0, rateStarter - 4);
      rateOffice = Math.max(0, rateOffice - 4);
    }
    if (
      valueSelectedPromos.includes(BusCon$7OffFor36Months) ||
      valueSelectedPromos.includes(BusCon$7OffFor60Months)
    ) {
      rateStarter = Math.max(0, rateStarter - 7);
      rateOffice = Math.max(0, rateOffice - 7);
    }

    if (isc2fMigrationFlow) {
      const seatRate = getFieldValue(fieldc2fMigrationSeatPrices, fields) || 0;
      rateStarter = seatRate;
      rateOffice = seatRate;
    }
    // if (isEligibleVoicePlus) {
    //   rateStarter = 20;
    //   rateOffice = 20;
    // }
    // if (isEligibleComplete) {
    //   rateStarter = 35;
    //   rateOffice = 35;
    // }
    // if (isEligibleEnhanced) {
    //   rateStarter = 25;
    //   rateOffice = 25;
    // }
    if (isEligibleCompletePlus) {
      rateStarter = 50;
      rateOffice = 50;
    }

    // Ensure OdysseyAI edition pricing overrides all other rate logic
    if (isThisOdysseyAIOrder && valueBusinessConnectEdition === mobile) {
      rateStarter = 25;
      rateOffice = 25;
    }
    if (isThisOdysseyAIOrder && valueBusinessConnectEdition === voicePlus) {
      rateStarter = 35;
      rateOffice = 35;
    }
    if (isThisOdysseyAIOrder && valueBusinessConnectEdition === enhanced) {
      rateStarter = 40;
      rateOffice = 40;
    }
    if (isThisOdysseyAIOrder && valueBusinessConnectEdition === complete) {
      rateStarter = 45;
      rateOffice = 45;
    }

    /**
     * If Enhanced Seat Combo promo is selected
     * update the pricing based on the promo selected
     */
    if (isEnhancedSeatComboPromoAvailable(fields)) {
      const promoSelected = valueSelectedPromos.find(item =>
        ENHANCED_COMPLETE_SEAT_PROMO_RATES.hasOwnProperty(item)
      );
      if (promoSelected) {
        rateStarter = ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
        rateOffice = ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
      }
    }

    /**
     * If Complete Seat Combo promo is selected
     * update the pricing based on the promo selected
     */
    if (isCompleteSeatComboPromoAvailable(fields)) {
      const promoSelected = valueSelectedPromos.find(item =>
        ENHANCED_COMPLETE_SEAT_PROMO_RATES.hasOwnProperty(item)
      );
      if (promoSelected) {
        rateStarter = ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
        rateOffice = ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
      }
    }

    /**
     * Enhanced Bundled $26-3MF / Complete Bundled $28-3MF flat rate overrides.
     * These promos support both 3yr and 5yr terms (the existing seat combo blocks
     * only handle 3yr). Override unconditionally when selected and eligible so
     * the 3MF rate always wins regardless of order in valueSelectedPromos.
     */
    if (
      isEnhanced3MFPromoAvailable(fields) &&
      valueSelectedPromos.includes(EnhancedBundled26_3MF)
    ) {
      rateStarter = ENHANCED_COMPLETE_SEAT_PROMO_RATES[EnhancedBundled26_3MF];
      rateOffice = ENHANCED_COMPLETE_SEAT_PROMO_RATES[EnhancedBundled26_3MF];
    }
    if (
      isComplete3MFPromoAvailable(fields) &&
      valueSelectedPromos.includes(CompleteBundled26_3MF)
    ) {
      rateStarter = ENHANCED_COMPLETE_SEAT_PROMO_RATES[CompleteBundled26_3MF];
      rateOffice = ENHANCED_COMPLETE_SEAT_PROMO_RATES[CompleteBundled26_3MF];
    }

    if (isMultiUnitDiscountPromoAvailable(fields)) {
      const promoSelected = valueSelectedPromos.find(item =>
        ENHANCED_COMPLETE_SEAT_PROMO_RATES.hasOwnProperty(item)
      );
      if (promoSelected) {
        rateStarter -= ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
        rateOffice -= ENHANCED_COMPLETE_SEAT_PROMO_RATES[promoSelected];
      }
    }

    const priceChanging =
      getFieldValue(fieldIsTheCustomerPriceChanging, fields) || '';

    if (priceChanging === 'No') {
      if (valueCustomerCurrentStarterSeatPrice)
        rateStarter = valueCustomerCurrentStarterSeatPrice;
      if (valueCustomerCurrentOfficeSeatPrice)
        rateOffice = valueCustomerCurrentOfficeSeatPrice;
    } else {
      if (valueNewStarterSeatPrice) rateStarter = valueNewStarterSeatPrice;
      if (valueNewOfficeSeatPrice) rateOffice = valueNewOfficeSeatPrice;
    }
    if (isAllValuesNoOdyssey) {
      rateStarter = valueNewCustomerPrice || 0;
      rateOffice = valueNewCustomerPrice || 0;
    }

    return {
      starterSeatRateStandard: rateStarter,
      officeSeatRateStandard: rateOffice,
      starterSeat: rateStarter * quantityStarter,
      officeSeats: rateOffice * quantityOffice,
      baseStarter: rateStarterBase * quantityStarter,
      baseOffice: rateOfficeBase * quantityOffice
    };
  };

  // Function to calculate Rates based on applied coupons
   const updateEditionRates = fields => {
    const fieldBCE = checkBusinessConnectEdition(
      fieldBusinessConnectEdition,
      orderData,
      formName,
      yes
    );

    const valueBCE = getFieldValue(fieldBCE, fields);
    const quantityStarter = +getFieldValue(fieldStarterSeat, fields) || 0;
    const quantityOffice = +getFieldValue(fieldOfficeSeats, fields) || 0;
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueSelectedPromos =
      getFieldValue(fieldAvailableDiscountsAndPromotions, fields) || [];
    const valueBundle =
      valueOtherTelusServices === yes ||
      (valueOtherTelusServices === no &&
        valueSelectedPromos.includes(valueMppPromo))
        ? 'bundled'
        : 'nonBundled';

    const valueNewStarterSeatPrice = getFieldValue(
      fieldWhatIsTheNewStarterSeatPrice,
      fields
    );

    const valueNewOfficeSeatPrice = getFieldValue(
      fieldWhatIsTheNewOfficeSeatPrice,
      fields
    );

    const valueCustomerCurrentStarterSeatPrice = getFieldValue(
      fieldWhatIsTheCustomersCurrentStarterSeatPrice,
      fields
    );
    const valueCustomerCurrentOfficeSeatPrice = getFieldValue(
      fieldWhatIsTheCustomersCurrentOfficeSeatPrice,
      fields
    );
    const valueNewCustomerPrice = getFieldValue(
      fieldNewCustomerPriceOdyssey,
      fields
    ); 

    const valueProvinceServiceAddress =
      getFieldValue(fieldProvinceServiceAddress, fields) || '';
    const isQCProvincePresent = allowedProvinceQCBundle.includes(
      valueProvinceServiceAddress
    );
    const isQCProvinceNot = !allowedProvinceQCBundle.includes(
      valueProvinceServiceAddress
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields) || '';
    const valueEdition =
      getFieldValue(fieldBusinessConnectEdition, fields) || '';
    const valueTOI = getFieldValue(fieldTypeOfInstallation, fields) || '';

    const enhancedPromosList = [
      valueEnhancedPromoAvailable,
      valueMppEnhancedPromoAvailable,
      valueCbmEnhancedPromoAvailable
    ];
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueCustomerSegment = _.get(orderData, fieldCustomerSegment, '');
    const buinessConnectNewPrice = [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueCustomerSegment);
    const buinessConnectNewPriceMobile = [monthToMonth].includes(valueContractTerm) && valueOtherTelusServices === no;
    const buinessConnectNewPriceThreeYear = [threeYears].includes(valueContractTerm) && valueOtherTelusServices === no;
    const buinessConnecQCMonthtoMonth = buinessConnectNewPrice && valueContractTerm === monthToMonth && valueOtherTelusServices === yes && isQCProvinceNot;
    const buinessConnecQCThreeYear = buinessConnectNewPrice && valueContractTerm === threeYears && valueOtherTelusServices === yes && isQCProvinceNot;
    const bundleMonthtoMonth = buinessConnectNewPrice && allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) && valueOtherTelusServices === yes && valueContractTerm === monthToMonth && isQCProvincePresent ;
    const bundlethreeYear = buinessConnectNewPrice && allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) && valueOtherTelusServices === yes && valueContractTerm === threeYears && isQCProvincePresent ;
    const checkEligibility = valueOfEdition => {
      return (
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
        [threeYears, monthToMonth].includes(valueContractTerm) &&
        [valueOfEdition].includes(valueEdition) &&
        [valueAddon, valueNew].includes(valueTOI) &&
        allowedProvinceQCBundle.includes(orderData.provinceOfTheOrder) &&
        isQCProvincePresent &&
        valueOtherTelusServices === yes
      );
    };
    // const isEligibleComplete = checkEligibility(complete);
    // const isEligibleEnhanced = checkEligibility(enhanced);
    // const isEligibleVoicePlus = checkEligibility(voicePlus);
    const isEligibleCompletePlus = checkEligibility(completePlus);
    const isEnhancedPromoSelected =
      valueBCE === enhanced &&
      valueSelectedPromos.some(promo => enhancedPromosList.includes(promo));

    const isBusinessHeroPromoSelected = valueSelectedPromos.includes(
      valueBusinessHeroPromo
    );

    const isThreeMonthsPromoSelected = valueSelectedPromos.includes(
      valueThreeMonthsFree
    );

    const isVoicePlusPromoSelected = valueSelectedPromos.includes(
      valueVoicePlusPromo
    );

    let rateStarter = _.get(
      ratesStarterSeat,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );
    let rateOffice = _.get(
      ratesOfficeSeats,
      `${valueSegment}.${valueBCE}.${valueBundle}`,
      0
    );
    const latestEditionCoupon = editionCoupons
    .filter(coupon => {
      const couponType = (coupon.coupon && coupon.coupon.couponType) || coupon.couponType || '';
      return couponType.toLowerCase().includes(couponTypeEdition.toLowerCase()) && coupon.isApplied !== false;
    })
    .sort((a, b) => {
      const dateA = new Date(a.appliedAt || 0);
      const dateB = new Date(b.appliedAt || 0);
      return dateB - dateA; // Sort by most recent first
    })[0];
    const rateStarterBase = rateStarter;
    const rateOfficeBase = rateOffice;
    // Removed all previous rate calculations and replaced with last applied coupon value

    // Only apply coupon pricing if a valid edition coupon exists and is applied
    if (latestEditionCoupon && latestEditionCoupon.dollarValue) {
      rateStarter = latestEditionCoupon.dollarValue;
      rateOffice = latestEditionCoupon.dollarValue;
    }

    return {
      starterSeatRateStandard: rateStarter,
      officeSeatRateStandard: rateOffice,
      starterSeat: rateStarter * quantityStarter,
      officeSeats: rateOffice * quantityOffice,
      baseStarter: rateStarterBase * quantityStarter,
      baseOffice: rateOfficeBase * quantityOffice
    };
  };

  const calcDevices = (key, method) => {
    if (formFields[key]) {
      return formFields[key].reduce((acc, item) => {
        const { unitPrice, quantity, paymentType } = item;
        return paymentType === method ? acc + unitPrice * quantity : acc;
      }, 0);
    }

    return 0;
  };

  const supportedDevicesNinetynineCentPromo = [
    devicePolycomVVX250,
    deviceCisco7841
  ];

  const isOrderValidForYealinkT34W =
    getFieldValue(fieldContractTerm, formFields) === threeYears;

  const supportedDevicesHardwareCreditPromo = [
    devicePolycomVVX150,
    devicePolyEdgeE220,
    ...(isOrderValidForYealinkT34W
      ? [deviceYealinkT34W, deviceYealinkT34WOld]
      : []),
    deviceYealinkT48U,
    deviceYealinkT48UOld,
    deviceYealinkT33G,
    deviceYealinkT33GOld,
    devicePolyEdgeE100,
    devicePolyEdgeE100Old
  ];

  const supportedDevicesHardwareCreditPromoAddOn = [
    devicePolycomVVX150,
    deviceYealinkT34W,
    deviceYealinkT34WOld,
    deviceYealinkT33G,
    deviceYealinkT33GOld,
  ];

  const isNewInstalation = () => {
    const valueTypeOfInstallation =
      getFieldValue(fieldTypeOfInstallation, formFields) ||
      _.get(orderData, fieldTypeOfInstallation, '');
    const res = valueTypeOfInstallation === valueNew;
    return res;
  };

  const isAddOnInstalation = () => {
    const valueTypeOfInstallation =
      getFieldValue(fieldTypeOfInstallation, formFields) ||
      _.get(orderData, fieldTypeOfInstallation, '');
    const res = valueTypeOfInstallation === valueAddon;
    return res;
  };

  const getDeviceName = device =>
    [
      devicePolycomVVX150HWC,
      devicePolyEdgeE220HWC,
      deviceYealinkT53WHWC,
      deviceYealinkT33GHWC,
      devicePolyEdgeE100HWC,
    ].includes(device)
      ? device.replace(' - HWC', '')
      : device.replace(' HWC', '');

  const getDevicePromoPrices = (promo, deviceName) => {
    if (promo.includes(valueNinetyNineCentDevicePromo)) return promoDeviceRate;
    return _.get(hwcPromoDeviceRates, deviceName, 0);
  };

  const isDevicesPromo = fields => {
    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevicesNinetynineCentPromo.includes(getDeviceName(device.name))
    );
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );

    return (
      [valueSegmentCommercial, valueSegmentSmb30To100].includes(valueSegment) &&
      [threeYears, fiveYears].includes(
        getFieldValue(fieldContractTerm, fields)
      ) &&
      getFieldValue(fieldTypeOfInstallation, fields) === valueNew &&
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, fields) ===
        yes &&
      deviceIndex !== -1
    );
  };

  const isHardwareCreditPromoVisible = fields => {
    let isVisible = false;

    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );

    const supportedDevices =
      valueTypeOfInstallation === valueAddon
        ? supportedDevicesHardwareCreditPromoAddOn
        : supportedDevicesHardwareCreditPromo;

    const deviceList = _.get(formFields, keyDevices, []);

    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevices.includes(getDeviceName(device.name))
    );

    deviceList.forEach(device => {
      if (deviceIndex !== -1 && device.payForDevice === valuePaymentUpfront) {
        isVisible = true;
      }
    });

    return isVisible;
  }; 

  const isHardwareCreditPromo = fields => {
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueBAN = getFieldValue(
      fieldExistingBusinessConnectBANNumber,
      fields
    );
    const bansToAllow = ['39475589'];
    const supportedDevices =
      valueTypeOfInstallation === valueAddon
        ? supportedDevicesHardwareCreditPromoAddOn
        : supportedDevicesHardwareCreditPromo;
    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevices.includes(getDeviceName(device.name))
    );

    if (
      valueTypeOfInstallation === valueAddon &&
      !_.get(orderData, 'groupId', '') &&
      !bansToAllow.includes(valueBAN)
    ) {
      return false;
    }

    return (
      [threeYears].includes(
        getFieldValue(fieldContractTerm, fields)
      ) &&
      getFieldValue(fieldDoesCustomerRequirePrimaryIpDeskPhones, fields) ===
        yes &&
      deviceIndex !== -1 &&
      isHardwareCreditPromoVisible(fields)
    );
  };

  const isHardwareCreditPromoAddOn = fields => {
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const supportedDevices =
      valueTypeOfInstallation === valueAddon
        ? supportedDevicesHardwareCreditPromoAddOn
        : supportedDevicesHardwareCreditPromo;

    const deviceIndex = _.get(fields, keyDevices, []).findIndex(device =>
      supportedDevices.includes(getDeviceName(device.name))
    );
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    return (
      isAddOnInstalation() &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100, valueSegmentCommercial].includes(valueSegment) &&
      [voicePlus, enhanced, complete, 'Complete +'].includes(valueEdition) &&
      [threeYears].includes(valueContractTerm) &&
      deviceIndex !== -1 &&
      isHardwareCreditPromoVisible(fields)
    );
  };

  const getHwcPromoLabel = device =>
    [
      devicePolycomVVX150,
      devicePolyEdgeE220,
      devicePolyEdgeE100,
    ].includes(device.name)
      ? `- ${quoteForm.hwcPromoLabel}`
      : quoteForm.hwcPromoLabel;

  // This function swaps the regular devices with promo device and vice-versa
  const swapRegularDevicesAndPromoDevices = fields => {
    let removeFromMonthly = 0;
    let removeFromNow = 0;
    let addToNow = 0;
    let addToMonthly = 0;
    const deviceList = _.get(fields, keyDevices, []);
    const valuePromotionCodes =
      getFieldValue(fieldAvailableDiscountsAndPromotions, fields) || [];
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const supportedDevices =
      valueTypeOfInstallation === valueAddon
        ? supportedDevicesHardwareCreditPromoAddOn
        : supportedDevicesHardwareCreditPromo;
    const promoDevices = valuePromotionCodes.includes(valueHardwareCreditPromo)
      ? supportedDevices
      : supportedDevicesNinetynineCentPromo;

    const updatedDevice = deviceList.map(device => {
      let newDevice = { ...device };
      if (
        device.payForDevice === valuePaymentUpfront &&
        promoDevices.includes(getDeviceName(device.name)) &&
        (valuePromotionCodes.includes(valueNinetyNineCentDevicePromo) ||
          valuePromotionCodes.includes(valueHardwareCreditPromo))
      ) {
        const {
          name,
          monthlyCharges,
          oneTimeCharges,
          payForDevice,
          quantity
        } = device;

        const promoLabel = valuePromotionCodes.includes(
          valueHardwareCreditPromo
        )
          ? getHwcPromoLabel(device)
          : quoteForm.promoLabel;
        const promoPrice = getDevicePromoPrices(
          valuePromotionCodes,
          getDeviceName(name)
        );

        if (payForDevice === valuePaymentUpfront) {
          removeFromNow += oneTimeCharges * quantity;
          addToNow += promoPrice * quantity;
        } else if (payForDevice === valueEasyPayment) {
          removeFromMonthly += monthlyCharges * quantity;
          addToNow += promoPrice * quantity;
        }

        /** Added this as the promo device name is different from regular device name */
        let promoDeviceName = getDeviceName(name);
        if (promoDeviceName === deviceYealinkT34W)
          promoDeviceName = 'Yealink T34W';
        if (promoDeviceName === deviceYealinkT48U)
          promoDeviceName = 'Yealink T48U';

        newDevice.name = `${promoDeviceName} ${promoLabel}`;
        newDevice.oneTimeCharges = promoPrice;
        newDevice.unitPrice = promoPrice;
        newDevice.paymentType = paymentTypeUpfront;
        newDevice.payForDevice = valuePaymentUpfront;
        if (!newDevice.oldData) newDevice.oldData = device;
        newDevice.promoApplied = true;
      } else if (
        device.payForDevice === valuePaymentUpfront &&
        _.union(supportedDevicesNinetynineCentPromo, supportedDevices).includes(
          getDeviceName(device.name)
        ) &&
        device.promoApplied
      ) {
        const { oneTimeCharges, quantity, oldData } = device;

        if (oldData.payForDevice === valuePaymentUpfront) {
          addToNow += oldData.oneTimeCharges * quantity;
        } else if (oldData.payForDevice === valueEasyPayment) {
          addToMonthly += oldData.monthlyCharges * quantity;
        }
        removeFromNow += oneTimeCharges * device.quantity;
        newDevice = { ...device.oldData };
      }

      return newDevice;
    });
    return {
      newDeviceList: updatedDevice,
      removeFromMonthly,
      removeFromNow,
      addToNow,
      addToMonthly
    };
  };

  const isThreeMonthsFreePromo = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueIsVbpRequired = getFieldValue(fieldVbpRequired, fields);

    return (
      valueSegment !== valueSegmentCommercial &&
      valueOtherTelusServices === yes &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      [enhanced, complete].includes(valueBusinessConnectEdition) &&
      valueTypeOfInstallation !== valueAddon &&
      valueIsVbpRequired !== yes
    );
  };

  const isThreeMonthsFreeVisible = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    // const shouldHideThreeMonthsFree =
    //   [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) ||
    //   isMultisiteOrder;

    // if (shouldHideThreeMonthsFree) {
    //   return {
    //     visibility: false,
    //     isValidMultiOrder: false
    //   };
    // }

    const isValidNormalFlow = (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueTypeOfInstallation === valueNew &&
      valueOtherTelusServices === yes &&
      [enhanced, complete, completePlus].includes(valueEdition) &&
      totalNumberOfSeats >= 15
    );

    const isValidMultiOrder = (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueTypeOfInstallation === valueNew &&
      valueOtherTelusServices === yes &&
      [enhanced, complete, completePlus].includes(valueEdition) &&
      isMultisiteOrder &&
      totalNumberOfSeats >= 15
    );
    return {
      visibility: isValidNormalFlow || isValidMultiOrder,
      isValidMultiOrder
    };
  };
  
  const isFourMonthsFreePromo = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueIsVbpRequired = getFieldValue(fieldVbpRequired, fields);
    const isChannelAllowed = allowedChannelsForFourMonthsFreePromo.includes(
      channelCode
    );

    return (
      isChannelAllowed &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueOtherTelusServices === yes &&
      valueContractTerm === threeYears &&
      [enhanced, complete].includes(valueBusinessConnectEdition) &&
      valueIsVbpRequired !== yes
    );
  };

  const isSMB = () => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const res = [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
      valueSegment
    );
    return res;
  };

  const isThreeYearsContract = fields => {
    const valueTerm = getFieldValue(fieldContractTerm, fields);
    const res = valueTerm === threeYears;
    return res;
  };

  const isBusinessHeroPromoAvailable = fields => {
    const valueCpmsId = profile.cpms_id;
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);

    return (
      valueCpmsId === 'H5QV' &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueBusinessConnectEdition === complete &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)
    );
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      setIsFieldReset(true);
      setOrderData(updatedOrderData);
    }
  };

  const syncOdysseyAiAssistantFields = fields => {
    const assistantTotalSeats =
      Number(getFieldValue(fieldStarterSeat, fields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, fields) || 0);
    const valueBusinessConnectEditionForAssistant = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const isOdysseyAIEnhancedOrComplete =
      isThisOdysseyAIOrder &&
      [enhanced, complete].includes(valueBusinessConnectEditionForAssistant);

    if (fields[fieldAssistantAiOdysseyAI]) {
      fields[fieldAssistantAiOdysseyAI].checked = isOdysseyAIEnhancedOrComplete;
      fields[fieldAssistantAiOdysseyAI].isDisabled = isOdysseyAIEnhancedOrComplete;
    }

    if (fields[fieldAssistantAiOdysseyAIOdysseyAI]) {
      fields[fieldAssistantAiOdysseyAIOdysseyAI].value =
        isOdysseyAIEnhancedOrComplete ? String(assistantTotalSeats) : undefined;
      fields[fieldAssistantAiOdysseyAIOdysseyAI].isDisabled =
        isOdysseyAIEnhancedOrComplete;
    }

    return isOdysseyAIEnhancedOrComplete;
  };

  const syncOdysseyAiSupervisorAssistFields = fields => {
    const getNamedChatOrContactCentreQuantity = () => {
      if (_.get(fields, 'chatNamedOdysseyAI.checked', false)) {
        return _.get(fields, 'chatNamedOdysseyAI_OdysseyAI.value', '');
      }
      if (_.get(fields, 'contactCentreOdysseyAI.checked', false)) {
        return _.get(fields, 'contactCentreOdysseyAI_OdysseyAI.value', '');
      }
      return '';
    };

    const getConcurrentChatOrContactCentreQuantity = () => {
      if (_.get(fields, 'chatConcurrentOdysseyAI.checked', false)) {
        return _.get(fields, 'chatConcurrentOdysseyAI_OdysseyAI.value', '');
      }
      if (_.get(fields, 'contactCentreConcurrentOdysseyAI.checked', false)) {
        return _.get(
          fields,
          'contactCentreConcurrentOdysseyAI_OdysseyAI.value',
          ''
        );
      }
      return '';
    };

    const supervisorNamedChecked = _.get(
      fields,
      'supervisorAssistOdysseyAI.checked',
      false
    );
    const supervisorConcurrentChecked = _.get(
      fields,
      'supervisorAssistConcurrentOdysseyAI.checked',
      false
    );

    if (fields.supervisorAssistOdysseyAI_OdysseyAI) {
      if (supervisorNamedChecked) {
        const namedQty = getNamedChatOrContactCentreQuantity();
        fields.supervisorAssistOdysseyAI_OdysseyAI.value =
          namedQty !== '' && namedQty !== undefined && namedQty !== null
            ? String(namedQty)
            : '';
        fields.supervisorAssistOdysseyAI_OdysseyAI.isDisabled = true;
      } else {
        fields.supervisorAssistOdysseyAI_OdysseyAI.value = undefined;
        fields.supervisorAssistOdysseyAI_OdysseyAI.isDisabled = false;
      }
    }

    if (fields.supervisorAssistConcurrentOdysseyAI_OdysseyAI) {
      if (supervisorConcurrentChecked) {
        const concurrentQty = getConcurrentChatOrContactCentreQuantity();
        fields.supervisorAssistConcurrentOdysseyAI_OdysseyAI.value =
          concurrentQty !== '' &&
          concurrentQty !== undefined &&
          concurrentQty !== null
            ? String(concurrentQty)
            : '';
        fields.supervisorAssistConcurrentOdysseyAI_OdysseyAI.isDisabled = true;
      } else {
        fields.supervisorAssistConcurrentOdysseyAI_OdysseyAI.value = undefined;
        fields.supervisorAssistConcurrentOdysseyAI_OdysseyAI.isDisabled = false;
      }
    }
  };

  const handleFormField = (
    { name, value, checked },
    isFieldModified,
    fileUploded
  ) => {
    const fields = { ...formFields };
    let needToCheck = 1;
    let addAmountToNow = 0;
    let addAmountToMonthly = 0;
    let subtractAmountFromNow = 0;
    let subtractAmountFromMonthly = 0;
    setIsFieldReset(false);
    setIsFormValidated(false);
    setIsVBP(false);
    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }
    fields[name] = {
      ...fields[name],
      value,
      checked,
      isVisible: true,
      touched: true
    };

    if (
      fields[fieldApprovalCodeWhiteGlove] &&
      getFieldValue(fieldApprovalCodeWhiteGlove, fields) &&
      !isApprovalCodeFieldVisible(fields)
    ) {
      fields[fieldApprovalCodeWhiteGlove] = {
        ...fields[fieldApprovalCodeWhiteGlove],
        value: ''
      };
    }
    if (
      name === fieldHaveYouArrangedWhiteGloveTechnician &&
      value !== yes
    ) {
      dealerAssignmentDetailFields.forEach(fieldName => {
        if (fields[fieldName]) {
          fields[fieldName] = { ...fields[fieldName], value: '' };
        }
      });
    }

    Object.entries(aiInstallDependencyMap).forEach(([installField, dependency]) => {
      if (
        [
          dependency.component,
          dependency.valueField,
          fieldHaveYouArrangedWhiteGloveTechnician,
          fieldStarterSeat,
          fieldOfficeSeats
        ].includes(name) &&
        fields[installField] &&
        !isAiInstallFieldEnabled(installField, fields)
      ) {
        if (formFields[installField] && formFields[installField].checked) {
          subtractAmountFromNow += getStandaloneCheckboxPrice(
            installField,
            fields[installField].price
          );
        }
        fields[installField] = {
          ...fields[installField],
          checked: false,
          touched: true
        };
      }
    });

    // Dealer Billed Direct is not offered when the approval code is required.
    if (
      fields[fieldHowCustomerWantToPayForWhiteGlove] &&
      getFieldValue(fieldHowCustomerWantToPayForWhiteGlove, fields) ===
        valueDealerBilledDirect &&
      isApprovalCodeFieldVisible(fields)
    ) {
      fields[fieldHowCustomerWantToPayForWhiteGlove] = {
        ...fields[fieldHowCustomerWantToPayForWhiteGlove],
        value: ''
      };
    }

    if (fields[name].type === 'MultiCheckbox') {
      fields[name].options = getMultiCheckboxOptions(
        fields[name].options,
        value,
        name,
        fields,
        orderData
      );
    }

    /**
     * Auto select all adivsories to YES
     * when Yes to ALL is selected
     */
    if (name === fieldYesToAllAdvisories) {
      Object.keys(fields).forEach(field => {
        if (field.includes('customerAdvisories') && fields[field].isVisible) {
          fields[field].checked = checked;
          fields[field].value = checked;
        }
      });
    }

    if (fields[name].type === 'MultiFileUpload') {
      fields[name] = { ...fields[name], fileUploded };
      formFields[name] = { ...formFields[name], fileUploded };
      formStepFields[name] = { ...formStepFields[name], fileUploded };
    }

    if (name === fieldStoreCodeBcon) {
      formFields[fieldStoreCodeOutletBcon].value =
        storeCodeOutletMapping[value];
    }

    if (isMultisiteOrder && step === 1) {
      /**
       * Defaulting starter seat to 1 for all multi-sites AND
       * Defaulting installation type to Add-on for site 2/3/4 etc
       */

      if (name !== fieldStarterSeat && !fields[fieldStarterSeat].value)
        fields[fieldStarterSeat].value = '1';
      if (currentSite > 1) {
        fields[fieldTypeOfInstallation].value = valueAddon;
        fields[fieldTypeOfInstallation].isDisabled = true;
      }
    }

    /**
     * Defaulting starter seat to 1  if Installation type is new
     * for all non multi-sites orders
     */

    if (
      name === fieldTypeOfInstallation &&
      !isMultisiteOrder &&
      !isRecontractFlow
    ) {
      if (value === valueNew) {
        fields[fieldStarterSeat].value = '1';
        fields[fieldStarterSeat].isDisabled = true;
      } else if (value === valueAddon && isThisOdysseyAIOrder) {
        // For OdysseyAI Add-on, keep starter seat at 0 and locked
        fields[fieldStarterSeat].value = '0';
        fields[fieldStarterSeat].isDisabled = true;
      } else {
        fields[fieldStarterSeat].value = '';
        fields[fieldStarterSeat].isDisabled = false;
      }
    }

    /**
     * Defaulting starter seats to 1 for Re-contract flow
     */
    // if (isRecontractFlow && step === 1) {
    //   fields[fieldStarterSeat].value = '1';
    //   fields[fieldStarterSeat].isDisabled = true;
    // }

    /**
     * if C2F Automated Action is required then
     * default installation type to New and disable Add On option
     */
    if (
      _.get(orderData, fieldC2fAutomatedActivation, '') === yes &&
      _.get(fields, fieldTypeOfInstallation, false)
    ) {
      fields[fieldTypeOfInstallation].value = valueNew;
      fields[fieldTypeOfInstallation].isDisabled = true;
    }

    /**
     * if mobile flow
     * - Default edition to mobile
     * - Default term to MTM
     */
    if (isThisMobileEditionOrder && step === 1) {
      fields[fieldBusinessConnectEdition].value = mobile;

      fields[fieldContractTerm].value = monthToMonth;
      fields[fieldContractTerm].isDisabled = true;
    }

    /**
     * Defaulting Number of sites require WG to 1
     */
    if (
      isMultisiteOrder &&
      step === 4 &&
      _.get(
        orderData,
        fieldDoesTheCustomerRequireWhiteGlove,
        valueTelusVirtualInstallation
      ) === valueTelusProfessionalInstallation
    )
      fields[fieldNumberOfSitesThatRequireWhiteGlove].value = 1;

    /**
     * For Re-Contract flow default Number of Seats for White Glove to
     * Number of new seats added
     */
    if (name === fieldRecontractSeatsCustomerAdding && isRecontractFlow) {
      fields[fieldNumberOfSeatsThatRequireWhiteGlove].value = value;
      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    }

    /**
     * Auto-populate `numberOfSeatsThatRequireWhiteGloveAI` from
     * `limitedExtensionOdysseyAI_OdysseyAI` on Odyssey AI orders
     * whenever the limited extension count or white glove type changes.
     */
    if (
      isThisOdysseyAIOrder &&
      (name === limitedExtensionOdysseyAIOdysseyAI ||
        name === fieldDoesTheCustomerRequireWhiteGlove) &&
      fields[fieldNumberOfSeatsThatRequireWhiteGloveAI]
    ) {
      const limitedExtQty =
        name === limitedExtensionOdysseyAIOdysseyAI
          ? Number(value) || 0
          : Number(
              getFieldValue(limitedExtensionOdysseyAIOdysseyAI, fields) ||
                _.get(orderData, limitedExtensionOdysseyAIOdysseyAI, '')
            ) || 0;
      const isProfessionalInstall =
        (name === fieldDoesTheCustomerRequireWhiteGlove
          ? value
          : getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, fields)) ===
        valueTelusProfessionalInstallation;

      if (isProfessionalInstall && limitedExtQty > 0) {
        fields[fieldNumberOfSeatsThatRequireWhiteGloveAI] = {
          ...fields[fieldNumberOfSeatsThatRequireWhiteGloveAI],
          value: limitedExtQty,
          maxValue: limitedExtQty
        };
      } else {
        fields[fieldNumberOfSeatsThatRequireWhiteGloveAI] = {
          ...fields[fieldNumberOfSeatsThatRequireWhiteGloveAI],
          value: 0
        };
      }

      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    }

    if ([fieldStarterSeat, fieldOfficeSeats].includes(name)) {
      // Custom logic for related fields
      const relatedFieldNames = [
        fieldNumberOfSeatsThatRequireWhiteGlove,
        fieldTelusBusinessConnectRoomsNumberOfLicences,
        fieldTelusBusinessConnectLiveReportsNumberOfLicences,
        fieldTelusBusinessConnectRoomConnectorNumberOfLicences,
        fieldAdditionalTollFreeNumbersNumber
      ];
      const additionalField =
        name === fieldStarterSeat ? fieldOfficeSeats : fieldStarterSeat;
      const defaultValue =
        Number(value) + Number(getFieldValue(additionalField, fields));
      relatedFieldNames.forEach(item => {
        const values = { maxValue: defaultValue };
        if (
          item === fieldNumberOfSeatsThatRequireWhiteGlove &&
          !isRecontractFlow
        ) {
          values.value = defaultValue;
        }
        if (item === fieldAdditionalTollFreeNumbersNumber) {
          values.maxValue = getFieldValue(fieldOfficeSeats, fields);
        }
        fields[item] = { ...fields[item], ...values };
      });
      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    } else if (
      [
        fieldNumberOfSeatsThatRequireWhiteGlove,
        fieldNumberOfSeatsThatRequireWhiteGloveAI,
        fieldHowCustomerWantToPayForWhiteGlove,
        fieldDoesTheCustomerRequireWhiteGlove,
        fieldHaveYouArrangedWhiteGloveTechnician,
        fieldApprovalCodeWhiteGlove,
        fieldReceptionistInstall,
        fieldInsightsInstall
      ].includes(name) &&
      checkBusinessConnectEdition(
        fieldBusinessConnectEdition,
        orderData,
        formName,
        yes
      ) !== fieldBusinessConnectEditionWorkplace
    ) {
      const newPrice = calcPriceSeatsWhiteGlove(fields);
      addAmountToNow += newPrice.dueNow;
      addAmountToMonthly += newPrice.dueMonthly;
      subtractAmountFromNow += priceSeatsWhiteGlove.dueNow;
      subtractAmountFromMonthly += priceSeatsWhiteGlove.dueMonthly;
      setPriceSeatsWhiteGlove(newPrice);
    } else if (name === fieldBusinessConnectEdition) {
      if (value === mobile) {
        subtractAmountFromNow += calcDevices(keyDevices, paymentTypeUpfront);
        subtractAmountFromMonthly += calcDevices(
          keyDevices,
          paymentTypeEasyPayment
        );
        subtractAmountFromNow += calcDevices(
          keySpareDevices,
          paymentTypeUpfront
        );
        subtractAmountFromMonthly += calcDevices(
          keySpareDevices,
          paymentTypeEasyPayment
        );
      }
      // Implementation for OdysseyAI Assistant field visibility and value based on edition selected
      syncOdysseyAiAssistantFields(fields);
      // AI Insights + Contact Centre suite are only available for Voice Plus / Enhanced / Complete
      // editions. When the edition switches to Mobile or Voice, clear those values and resync
      // dependent supervisor-assist fields.
      if ([mobile, voice].includes(value)) {
        clearOdysseyAiVoicePlusOnlyFields(fields);
        syncOdysseyAiSupervisorAssistFields(fields);
      }

    } else if (name === fieldDoesCustomerRequirePrimaryIpDeskPhones) {
      let valueNow = calcDevices(keyDevices, paymentTypeUpfront);
      let valueMonthly = calcDevices(keyDevices, paymentTypeEasyPayment);

      if (
        fields[fieldDoesCustomerRequireSpareDevices] &&
        fields[fieldDoesCustomerRequireSpareDevices].value === yes
      ) {
        valueNow += calcDevices(keySpareDevices, paymentTypeUpfront);
        valueMonthly += calcDevices(keySpareDevices, paymentTypeEasyPayment);
      }
      if (value === yes) {
        addAmountToNow += valueNow;
        addAmountToMonthly += valueMonthly;
      } else {
        subtractAmountFromNow += valueNow;
        subtractAmountFromMonthly += valueMonthly;
      }
      fields[keyDevices] = [];
    } else if (name === fieldDoesCustomerRequireSpareDevices) {
      const valueNow = calcDevices(keySpareDevices, paymentTypeUpfront);
      const valueMonthly = calcDevices(keySpareDevices, paymentTypeEasyPayment);
      if (value === yes) {
        addAmountToNow += valueNow;
        addAmountToMonthly += valueMonthly;
      } else {
        subtractAmountFromNow += valueNow;
        subtractAmountFromMonthly += valueMonthly;
      }
    } else if (
      [
        fieldContractTerm,
        fieldTypeOfInstallation,
        fieldExistingBusinessConnectBANNumber
      ].includes(name)
    ) {
      if (!isDevicesPromo(fields) && fields[keyDevices]) {
        subtractAmountFromNow += fields[keyDevices].reduce((acc, item) => {
          const { unitPrice, quantity } = item;
          return [devicePolycomVVX250Promo, deviceCisco7841Promo].includes(
            item.name
          )
            ? acc + unitPrice * quantity
            : acc;
        }, 0);
        fields[keyDevices] = fields[keyDevices].filter(
          item =>
            ![devicePolycomVVX250Promo, deviceCisco7841Promo].includes(
              item.name
            )
        );
      }

      if (!isHardwareCreditPromo(fields) && fields[keyDevices]) {
        subtractAmountFromNow += fields[keyDevices].reduce((acc, item) => {
          const { unitPrice, quantity } = item;
          return [
            devicePolycomVVX150HWC,
            devicePolyEdgeE220HWC,
            deviceYealinkT48UHWC,
            deviceYealinkT34WHWC,
            deviceYealinkT33GHWC,
            devicePolyEdgeE100HWC
          ].includes(item.name)
            ? acc + unitPrice * quantity
            : acc;
        }, 0);
        fields[keyDevices] = fields[keyDevices].filter(
          item =>
            ![
              devicePolycomVVX150HWC,
              devicePolyEdgeE220HWC,
              deviceYealinkT48UHWC,
              deviceYealinkT34WHWC,
              deviceYealinkT33GHWC,
              devicePolyEdgeE100HWC
            ].includes(item.name)
        );
      }

      if (
        name === fieldContractTerm &&
        getFieldValue(fieldContractTerm, fields) &&
        !getFieldValue(fieldVbpTerm, fields)
      ) {
        fields[fieldVbpTerm].value = getFieldValue(fieldContractTerm, fields);
      }
    } else if (name === fieldGSuiteEmailMigrationServices) {
      if (getFieldValue(fieldGSuiteEmailMigrationServices, fields) < 5) {
        fields[fieldGSuiteEmailMigrationServicesPaymentType].value = '';
      }
    } else if (name === fieldAvailableDiscountsAndPromotions) {
      const valueAvailableDiscountsAndPromotions =
        getFieldValue(name, fields) || [];
      if (valueAvailableDiscountsAndPromotions.includes(valueThreeMonthsFree))
        fields[fieldVbpRequired].value = no;
    } else if (
      name === fieldDoesTheCustomerHaveAnExistingInternetConnection &&
      value === yes
    ) {
      fields[fieldWhoIsTheExistingInternetProviderForOtherState].value = other;
    } else {
      // Handle dueMonthly and dueNow
      updateTotals(name, fields[name]);

      if (['Select', 'Radio'].includes(fields[name].type)) {
        const currentField = findField(formStepFields, name);
        if (
          currentField &&
          currentField.fields &&
          currentField.fields.options
        ) {
          const currentOption = currentField.fields.options.find(
            item => item.fields.value === value
          );

          // field doesTheCustomerRequireSmartHub
          if (name === fieldDoesTheCustomerRequireSmartHub) {
            if (currentOption.fields.value === yes) {
              addAmountToMonthly += fields[name].monthlyPayment;
            } else {
              subtractAmountFromMonthly += fields[name].monthlyPayment;
            }
          } else if (typeof currentOption !== 'undefined') {
            // Price
            let amount = currentOption.fields.price || 0;
            let oldPrice = fields[name].price || 0;
            if (!isFieldInFeatures(name)) {
              subtractAmountFromNow += oldPrice;
              addAmountToNow += amount;
            }
            fields[name].price = amount;

            // Monthly payment
            amount = currentOption.fields.monthlyPayment || 0;
            oldPrice = fields[name].monthlyPayment || 0;
            if (!isFieldInFeatures(name)) {
              subtractAmountFromMonthly += oldPrice;
              addAmountToMonthly += amount;
            }
            fields[name].monthlyPayment = amount;
          } else {
            if (fields[name].price) {
              if (!isFieldInFeatures(name)) {
                subtractAmountFromNow += fields[name].price;
              }
              fields[name].price = 0;
            }
            if (fields[name].monthlyPayment) {
              if (!isFieldInFeatures(name)) {
                subtractAmountFromMonthly += fields[name].monthlyPayment;
              }
              fields[name].monthlyPayment = 0;
            }
          }
        }
      }
    }

    if (
      [
        fieldDoesCustomerRequirePrimaryIpDeskPhones,
        fieldAvailableDiscountsAndPromotions
      ].includes(name)
    ) {
      const {
        newDeviceList,
        removeFromMonthly,
        removeFromNow,
        addToNow,
        addToMonthly
      } = swapRegularDevicesAndPromoDevices(fields);

      fields[keyDevices] = newDeviceList;
      addAmountToNow += addToNow;
      subtractAmountFromNow += removeFromNow;
      subtractAmountFromMonthly += removeFromMonthly;
      addAmountToMonthly += addToMonthly;
    }

    if (
      [
        fieldTypeOfInstallation,
        fieldStarterSeat,
        fieldOfficeSeats,
        fieldBusinessConnectEdition,
        fieldBusinessConnectEditionWorkplace,
        fieldContractTerm,
        fieldOtherTelusServices,
        fieldAvailableDiscountsAndPromotions,
        fieldc2fMigrationSeatPrices,
        fieldWhatIsTheNewOfficeSeatPrice,
        fieldWhatIsTheNewStarterSeatPrice,
        fieldWhatIsTheCustomersCurrentStarterSeatPrice,
        fieldWhatIsTheCustomersCurrentOfficeSeatPrice,
        fieldNewCustomerPriceOdyssey
      ].includes(name)
    ) {
      // Get rates for Starter and Office
      const newRates = editionCoupons.length === 0 ? updateRates(fields) : updateEditionRates(fields);
      addAmountToMonthly += newRates.starterSeat + newRates.officeSeats;
      subtractAmountFromMonthly += rates.starterSeat + rates.officeSeats;
      setRates(newRates);
    }

    // Update G Suite price
    if (
      [
        fieldContractTerm,
        fieldBusinessConnectEdition,
        fieldStarterSeat,
        fieldOfficeSeats,
        fieldOptOutFromGSuiteBusinessLicenses,
        fieldAdditionalGSuiteBusinessLicences,
        fieldGSuiteBasicLicences,
        fieldGSuiteInstallAndSetup,
        fieldGSuiteEmailMigrationServices,
        fieldGSuiteEmailMigrationServicesPaymentType
      ].includes(name)
    ) {
      const newPriceGSuite = getGSuitePrice(fields);
      addAmountToNow += newPriceGSuite.price;
      addAmountToMonthly += newPriceGSuite.monthlyPayment;
      subtractAmountFromNow += priceGSuite.price;
      subtractAmountFromMonthly += priceGSuite.monthlyPayment;
      setPriceGSuite(newPriceGSuite);
    }

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));

    const getDisabledFields = (data, initFields) => {
      let result = initFields;

      const filter = !data
        ? []
        : data.filter(item => {
            const { sys, fields: itemFields } = item;
            const { name: itemName, appearsAfterField } = itemFields;
            const {
              contentType: {
                sys: { id }
              }
            } = sys;

            if (id === formFieldsGroup) {
              result = getDisabledFields(itemFields.fields, result);
            } else if (id === formSection) {
              result = getDisabledFields(itemFields.formFields, result);
            } else if (fields[itemName] && appearsAfterField) {
              const isVisible = isRelatedFieldExisted(item.fields, fields);
              if (fields[itemName].isVisible) {
                fields[itemName].isVisible = isVisible;
                return !isVisible;
              }
              if (
                isVisible &&
                !isFieldInFeatures(itemName) &&
                ![
                  fieldAdditionalGSuiteBusinessLicences,
                  fieldGSuiteBasicLicences
                ].includes(itemName)
              ) {
                if (
                  isFieldCalculated(
                    fields[itemName].type,
                    fields[itemName].value,
                    fields[itemName].checked,
                    fields[itemName].price
                  )
                ) {
                  const itemPrice =
                    fields[itemName].type === 'Number'
                      ? Number(fields[itemName].initPrice) *
                        Number(fields[itemName].value)
                      : Number(fields[itemName].price);
                  addAmountToNow += itemPrice;
                }
                if (
                  isFieldCalculated(
                    fields[itemName].type,
                    fields[itemName].value,
                    fields[itemName].checked,
                    fields[itemName].monthlyPayment
                  )
                ) {
                  const itemPrice =
                    fields[itemName].type === 'Number'
                      ? Number(fields[itemName].initMonthlyPayment) *
                        Number(fields[itemName].value)
                      : Number(fields[itemName].monthlyPayment);
                  addAmountToMonthly += itemPrice;
                }
              }
              fields[itemName].isVisible = isVisible;
            }

            return false;
          });

      return [...result, ...filter];
    };

    while (needToCheck > 0 && needToCheck < 5) {
      const disabledFields = getDisabledFields(formStepFields, []);

      // eslint-disable-next-line no-loop-func
      disabledFields.forEach(item => {
        const {
          fields: { name: itemName }
        } = item;

        if (
          !isFieldInFeatures(itemName) &&
          ![
            fieldAdditionalGSuiteBusinessLicences,
            fieldGSuiteBasicLicences
          ].includes(itemName)
        ) {
          if (
            isFieldCalculated(
              fields[itemName].type,
              fields[itemName].value,
              fields[itemName].checked,
              fields[itemName].price
            )
          ) {
            const itemPrice =
              fields[itemName].type === 'Number'
                ? Number(fields[itemName].initPrice) *
                  Number(fields[itemName].value)
                : Number(fields[itemName].price);
            subtractAmountFromNow += itemPrice;
          }
          if (
            isFieldCalculated(
              fields[itemName].type,
              fields[itemName].value,
              fields[itemName].checked,
              fields[itemName].monthlyPayment
            )
          ) {
            const itemPrice =
              fields[itemName].type === 'Number'
                ? Number(fields[itemName].initMonthlyPayment) *
                  Number(fields[itemName].value)
                : Number(fields[itemName].monthlyPayment);
            subtractAmountFromMonthly += itemPrice;
          }
        }
      });

      needToCheck = disabledFields.length > 0 ? needToCheck + 1 : 0;
    }

    // Set the value of assistantOdysseyAI_OdysseyAI field and disable it
    // if (name === fieldAssistantOdysseyAI && checked) {
    //   const { totalNoOfSeats } = getSeatsData();
    //   fields[fieldassistantOdysseyAIOdysseyAI].isDisabled = true;
    //   fields[fieldassistantOdysseyAIOdysseyAI].value = totalNoOfSeats;
    // }

    // Reset the value of AI additional fields
    if (singleSelectChatFields.includes(name)) {
      hideChatFieldsForOdysseyAI.forEach(field => {
        fields[field].checked = false;
      });
    }

    // Update features price
    const newFeaturesPrice = updateFeaturesPrices(getFeatures(fields));
    addAmountToMonthly += _.get(newFeaturesPrice, 'monthly', 0);
    subtractAmountFromMonthly += _.get(priceFeatures, 'monthly', 0);
    addAmountToNow += _.get(newFeaturesPrice, 'oneTime', 0);
    subtractAmountFromNow += _.get(priceFeatures, 'oneTime', 0);
    setPriceFeatures(newFeaturesPrice);

    // Update prices
    if (addAmountToNow || subtractAmountFromNow) {
      setDueNow(dueNow - subtractAmountFromNow + addAmountToNow);
    }
    if (addAmountToMonthly || subtractAmountFromMonthly) {
      setDueMonthly(
        dueMonthly - subtractAmountFromMonthly + addAmountToMonthly
      );
    }

    // Logic for adding and subtracting $70/$75/$140 Bill Credit from Due Now
    if (name === fieldAvailableDiscountsAndPromotions) {
      const oldPromoValue = _.get(
        formFields,
        `${fieldAvailableDiscountsAndPromotions}.value`,
        []
      );
      // For $70 Bill Credit
      if (
        !oldPromoValue.includes(BillCreditPromo$70) &&
        value.includes(BillCreditPromo$70)
      ) {
        const amountDeducted = dueNow >= 70 ? 70 : dueNow;
        setBillCredit70Applied(amountDeducted);
        setDueNow(dueNow - amountDeducted);
      }

      if (
        oldPromoValue.includes(BillCreditPromo$70) &&
        !value.includes(BillCreditPromo$70)
      ) {
        setDueNow(dueNow + billCredit70Applied);
      }

      // For $75 Bill Credit
      if (
        !oldPromoValue.includes(BillCreditPromo$75) &&
        value.includes(BillCreditPromo$75)
      ) {
        const amountDeducted = dueNow >= 75 ? 75 : dueNow;
        setBillCredit75Applied(amountDeducted);
        setDueNow(dueNow - amountDeducted);
      }

      if (
        oldPromoValue.includes(BillCreditPromo$75) &&
        !value.includes(BillCreditPromo$75)
      ) {
        setDueNow(dueNow + billCredit75Applied);
      }

      // For $140 Bill Credit
      if (
        !oldPromoValue.includes(BillCreditPromo$140) &&
        value.includes(BillCreditPromo$140)
      ) {
        const amountDeducted = dueNow >= 140 ? 140 : dueNow;
        setBillCredit140Applied(amountDeducted);
        setDueNow(dueNow - amountDeducted);
      }

      if (
        oldPromoValue.includes(BillCreditPromo$140) &&
        !value.includes(BillCreditPromo$140)
      ) {
        setDueNow(dueNow + billCredit140Applied);
      }

      // OdysseyAI Promotions pricing calculation
      const extraAiPricingPromos = [
        BusCon$10OffFor36Months,
        BusCon$10OffFor60Months,
        BusCon$4DiscountOn36Months,
        BusCon$4DiscountOn60Months,
        BusCon$7OffFor36Months,
        BusCon$7OffFor60Months,
        BusCon$5OffFor36Months,
        BusCon$5OffFor60Months
      ];
      const isAiPricingPromo = promo =>
        allOdysseyAIPromos.includes(promo) ||
        extraAiPricingPromos.includes(promo);
      const odysseyAIPromos = value.filter(isAiPricingPromo);
      const oldOdysseyAIPromos = oldPromoValue.filter(isAiPricingPromo);

      // Only recalculate if OdysseyAI promotions changed
      if (JSON.stringify(odysseyAIPromos.sort()) !== JSON.stringify(oldOdysseyAIPromos.sort())) {
        // Calculate total seats
        const starterSeats = Number(getFieldValue(fieldStarterSeat, formFields) || 0);
        const officeSeats = Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
        const totalSeats = starterSeats + officeSeats;

        // Calculate and apply the new discount from the current selection.
        let newTotalDiscount = 0;
        if (odysseyAIPromos.length > 0 && totalSeats > 0) {
          odysseyAIPromos.forEach(promo => {
            const promoOption = fields[fieldAvailableDiscountsAndPromotions].options.find(
              opt => opt.fields.value === promo
            );
            if (promoOption && promoOption.fields.monthlyPayment) {
              const discountPerSeat = Math.abs(promoOption.fields.monthlyPayment);
              newTotalDiscount += discountPerSeat * totalSeats;
            }
          });
        }

        setDueMonthly(dueMonthly + odysseyAIPromotionApplied - newTotalDiscount);
        setOdysseyAIPromotionApplied(newTotalDiscount);
      }

    }

    if (
      isThisOdysseyAIOrder &&
      odysseyAiSupervisorSyncTriggerFields.includes(name)
    ) {
      syncOdysseyAiSupervisorAssistFields(fields);
    }

    // Update form fields
    setFormFields(resetFormFields(fields, name));

    // Reset Selected Fields Logic
    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }

    // Check if coupon-related field changed and get affected coupon IDs
    const affectedCouponIds = checkCouponFieldChanges(name);
    if (affectedCouponIds.length > 0) {
      // Set isApplied to false for affected coupons
      const updatedAppliedCoupons = appliedCoupons.map(coupon => {
        if (affectedCouponIds.includes(coupon.couponCode)) {
          return { ...coupon, isApplied: false };
        }
        return coupon;
      });
      
      // Update the applied coupons with new isApplied status
      if (setAppliedCoupons) {
        setAppliedCoupons(updatedAppliedCoupons);
      }
    }
  };      

  /**
   * This function is the single point or truth for Due Now Total
   */
  function calculateDueNowTotal(fields) {
    let total = 0;

    // 1. Router cost
    if (
      fields[fieldDoesCustomerRequireRouter].value === yes &&
      fields[fieldRouterPaymentOption].value === valuePaymentUpfront
    ) {
      total += 144;
    }

    // 2. Primary Devices
    if (_.get(fields, 'devices', []).length > 0) {
      total += fields.devices.reduce((acc, currentItem) => {
        if (currentItem.payForDevice === valuePaymentUpfront)
          acc += currentItem.oneTimeCharges * currentItem.quantity;
        return acc;
      }, 0);
    }

    // 3. Spare Devices
    if (_.get(fields, 'additionalSpareDevices', []).length > 0) {
      total += fields.additionalSpareDevices.reduce((acc, currentItem) => {
        if (currentItem.payForDevice === valuePaymentUpfront)
          acc += currentItem.oneTimeCharges * currentItem.quantity;
        return acc;
      }, 0);
    }

    // 4. Installation
    const { dueNow } = calcPriceSeatsWhiteGlove(fields);
    total += dueNow;

    total += getOdysseyProfessionalServicesFileChargesNow(fields);

    // // 5. Promos
    // /** $70 Bill Credit Promo */
    if (
      _.get(
        fields,
        `${fieldAvailableDiscountsAndPromotions}.value`,
        []
      ).includes(BillCreditPromo$70)
    ) {
      total -= 70;
    }

    // /** $75 Bill Credit Promo */
    if (
      _.get(
        fields,
        `${fieldAvailableDiscountsAndPromotions}.value`,
        []
      ).includes(BillCreditPromo$75)
    ) {
      total -= 75;
    }

    // /** $140 Bill Credit Promo */
    if (
      _.get(
        fields,
        `${fieldAvailableDiscountsAndPromotions}.value`,
        []
      ).includes(BillCreditPromo$140)
    ) {
      total -= 140;
    }
    // For Coupon Bill Credit - only apply one-time bill credits here
    if (billCreditCoupons.length > 0) {
      const oneTimeBillCreditTotal = billCreditCoupons.reduce((acc, curr) => {
        if (curr.isApplied === true) {
          const duration = (curr.duration || '').toLowerCase();
          const isMonthly = duration.includes('monthly');
          // Only include one-time bill credits (not monthly)
          if (!isMonthly) {
            const value = Number(curr.dollarValue);
            return acc + (Number.isNaN(value) ? 0 : value);
          }
        }
        return acc;
      }, 0);
      // Apply value directly: positive credits reduce total, negative charges increase total
      total += oneTimeBillCreditTotal;
    }

    // Standalone (non-feature) checkbox one-time charges.
    total += getStandaloneCheckboxPrices(fields).oneTime;

    const finalTotal = total < 0 ? 0 : total;
    setDueNow(finalTotal);
  }
  const checkIfPrequalificationPass = prequalFields => {
    let prequalInEligibleNote = {};
    let isPrequalEligible = true;
    prequalFields.forEach(field => {
      const {
        fields: { name, ineligible, ineligibleNote }
      } = field;

      let fieldVisible = isRelatedFieldExisted(field.fields, formFields);

      if (
        userChannelName !== CORP_STORE &&
        (name === fieldStoreCodeBcon || name === fieldStoreCodeOutletBcon)
      ) {
        fieldVisible = false;
      }

      if (
        name === fieldCoperToFibreMigration &&
        (formFields[fieldRecontractCustomer].value.includes(yes) ||
          formFields['vulcanOrder'].value.includes(yes))
      ) {
        fieldVisible = false;
      }

      if (name === fieldMultisiteOrder && isThisOdysseyAIOrder) {
        fieldVisible = false;
      }

      if (fieldVisible) {
        const { value: fieldValue } = formFields[name];
        const valueField = name.includes('uploadSpeed')
          ? +fieldValue
          : fieldValue;
        if (!valueField) {
          isPrequalEligible = false;
          return;
        }
        if (ineligible) {
          const {
            fields: { value: inEligibleValue }
          } = ineligible;
          if (inEligibleValue.split('|').includes(fieldValue)) {
            isPrequalEligible = false;
            // Keep the first ineligible note, regardless of unanswered fields before it
            if (!prequalInEligibleNote.content)
              prequalInEligibleNote = { ...ineligibleNote };
          }
        }
      }
    });
    return { prequalEligible: isPrequalEligible, prequalInEligibleNote };
  };

  const reduceFields = (acc, field) => {
    const {
      fields: { type, required },
      sys: {
        contentType: {
          sys: { id }
        }
      }
    } = field;

    if (id === 'formFieldsGroup') {
      const groupFields = _.get(field, 'fields.fields', []).reduce(
        reduceFields,
        []
      );
      return [...acc, ...groupFields];
    }
    if (id === 'formField' && required && type !== 'TextNote')
      return [...acc, field];
    return acc;
  };

  useEffect(() => {
    const formFieldsKeys = Object.keys(formFields);
    if (formFieldsKeys.length) {
      const initFieldsWithValue = [];
      formFieldsKeys.forEach(name => {
        const { value } = formFields[name];
        if (value) {
          initFieldsWithValue.push({ name, value });
          updateTotals(name, formFields[name]);
        }
      });
      setFieldsWithValue(initFieldsWithValue);
    }
  }, [Object.keys(formFields).length, orderData]);
  // Initialize applied coupons from orderData
  useEffect(() => {
    if (orderData && orderData.appliedCoupons) {
      // Keep the full set of applied coupons (including bill credit) in state on
      // every site so saving a subsequent site never strips the bill credit that
      // belongs to site 1. Site-specific exclusion (pricing + quote rendering) is
      // handled by the `billCreditCoupons` memo and the backend child filter.
      setAppliedCoupons(orderData.appliedCoupons);
    }
  }, [orderData && orderData.appliedCoupons]);

  useEffect(() => {
    if (ratesStarterSeat && ratesOfficeSeats) {
      if (typeof fieldsWithValue === 'undefined' || !fieldsWithValue.length)
        return;

      // Get custom amounts
      const totalPlan = calcFieldMonthlyPayment(
        fieldPlan,
        getFieldValue(fieldPlan, formFields),
        formStepFields
      );
      const totalSmartHub =
        getFieldValue(fieldDoesTheCustomerRequireSmartHub, formFields) === yes
          ? formFields[fieldDoesTheCustomerRequireSmartHub].monthlyPayment
          : 0;
      // Get main amounts
      const totalPriceFeatures = orderData.features
        ? updateFeaturesPrices(orderData.features)
        : { monthly: 0, oneTime: 0 };
      const totalRates = editionCoupons.length === 0 ? updateRates(formFields) : updateEditionRates(formFields);

      // When custom pricing has been approved, override the seat totals with the
      // approved rate so the UI "due monthly" matches the approved quote PDF.
      // Mirror the edition-specific logic in the backend quote service:
      //   Voice          → vpbOfficeSeatRate applies to starter seats only
      //   Voice+         → vpbStarterSeatRate → starter, vpbOfficeSeatRate → office
      //   Enhanced / Complete / Complete+ → vpbOfficeSeatRate → office seats only
      const rawVbpOfficeRate = _.get(orderData, 'vpbOfficeSeatRate');
      const isQuoteApproved = _.get(orderData, 'quoteStatus') === 'QUOTE_APPROVED';
      const isVbpRequired = [yes, 'Oui'].includes(_.get(orderData, 'vbpRequired', ''));
      if (isQuoteApproved && isVbpRequired) {
        const currentEdition = getFieldValue(fieldBusinessConnectEdition, formFields);
        const quantityStarter = +getFieldValue(fieldStarterSeat, formFields) || 0;
        const quantityOffice = +getFieldValue(fieldOfficeSeats, formFields) || 0;

        // Resolve the approved office seat rate (handle "Other"/"Autre" → vbpDesiredPrice)
        const isOtherRate = ['Other', 'Autre'].includes(rawVbpOfficeRate);
        const approvedOfficeRate = isOtherRate
          ? +_.get(orderData, 'vbpDesiredPrice', 0)
          : +rawVbpOfficeRate;

        if (currentEdition === voice) {
          // Voice: approved rate covers starter seats (no office seats in Voice)
          if (!Number.isNaN(approvedOfficeRate) && approvedOfficeRate > 0)
            totalRates.starterSeat = approvedOfficeRate * quantityStarter;
        } else if (currentEdition === voicePlus) {
          // Voice+: separate rates for starter and office seats
          const approvedStarterRate = +_.get(orderData, 'vpbStarterSeatRate', 0);
          if (!Number.isNaN(approvedStarterRate) && approvedStarterRate > 0)
            totalRates.starterSeat = approvedStarterRate * quantityStarter;
          if (!Number.isNaN(approvedOfficeRate) && approvedOfficeRate > 0)
            totalRates.officeSeats = approvedOfficeRate * quantityOffice;
        } else if (!Number.isNaN(approvedOfficeRate) && approvedOfficeRate > 0) {
          // Enhanced / Complete / Complete+: approved rate covers office seats only
          totalRates.officeSeats = approvedOfficeRate * quantityOffice;
        }
      }

      const totalNowDevices = calcDevices(keyDevices, paymentTypeUpfront);
      const totalMonthlyDevices = calcDevices(
        keyDevices,
        paymentTypeEasyPayment
      );
      const totalNowSpareDevices = calcDevices(
        keySpareDevices,
        paymentTypeUpfront
      );
      const totalMonthlySpareDevices = calcDevices(
        keySpareDevices,
        paymentTypeEasyPayment
      );

      /**
       * Router
       */
      const valueRouterPaymentOption = getFieldValue(
        fieldRouterPaymentOption,
        formFields
      );
      let valueRouterUpfront = 0;
      let valueRouterMonthly = 0;
      if (valueRouterPaymentOption === valueEasyPayment)
        valueRouterMonthly =
          formFields[fieldRouterPaymentOption].monthlyPayment;
      else if (valueRouterPaymentOption === valuePaymentUpfront)
        valueRouterUpfront = formFields[fieldRouterPaymentOption].price;

      // G Suite
      const totalGSuite = getGSuitePrice(formFields);
      const totalNowGSuite = totalGSuite.price;
      const totalMonthlyGSuite = totalGSuite.monthlyPayment;

      // Add prices from the order data
      let newDueNow =
        totalNowDevices +
        totalNowSpareDevices +
        totalNowGSuite +
        _.get(totalPriceFeatures, 'oneTime', 0) +
        valueRouterUpfront;
      let newDueMonthly =
        totalPlan +
        totalSmartHub +
        totalRates.starterSeat +
        totalRates.officeSeats +
        _.get(totalPriceFeatures, 'monthly', 0) +
        totalMonthlyDevices +
        totalMonthlySpareDevices +
        totalMonthlyGSuite +
        valueRouterMonthly;
      if (
        checkBusinessConnectEdition(
          fieldBusinessConnectEdition,
          orderData,
          formName,
          yes
        ) !== fieldBusinessConnectEditionWorkplace
      ) {
        const totalPriceSeatsWhiteGlove = calcPriceSeatsWhiteGlove(formFields);
        newDueNow += totalPriceSeatsWhiteGlove.dueNow;
        newDueMonthly += totalPriceSeatsWhiteGlove.dueMonthly;
        setPriceSeatsWhiteGlove(totalPriceSeatsWhiteGlove);
      }
      newDueNow += getOdysseyProfessionalServicesFileChargesNow(formFields);
      // Apply monthly bill credit coupons to monthly total
      if (billCreditCoupons.length > 0) {
        const monthlyBillCreditTotal = billCreditCoupons.reduce((acc, curr) => {
          if (curr.isApplied === true) {
            const duration = (curr.duration || '').toLowerCase();
            const isMonthly = duration.includes('monthly');
            // Only include monthly bill credits
            if (isMonthly) {
              const value = Number(curr.dollarValue);
              return acc + (Number.isNaN(value) ? 0 : value);
            }
          }
          return acc;
        }, 0);
        // Apply value directly: positive credits reduce total, negative charges increase total
        newDueMonthly += monthlyBillCreditTotal;
      }

      // Apply OdysseyAI promotion discounts to monthly total.
      // Include the new BCON-AI flat $10-off offers ("Bus Con $10 off for
      // 36/60 months") even though they live outside the Contentful
      // ODYSSEY_AI_PROMOTIONS list — they must reduce the monthly total
      // exactly like the existing contract-discount promos.
      const extraAiPricingPromos = [
        BusCon$10OffFor36Months,
        BusCon$10OffFor60Months,
        BusCon$4DiscountOn36Months,
        BusCon$4DiscountOn60Months,
        BusCon$7OffFor36Months,
        BusCon$7OffFor60Months,
        BusCon$5OffFor36Months,
        BusCon$5OffFor60Months
      ];
      const selectedOdysseyAIPromos = formFields[fieldAvailableDiscountsAndPromotions] && formFields[fieldAvailableDiscountsAndPromotions].value
        ? formFields[fieldAvailableDiscountsAndPromotions].value.filter(promo =>
            allOdysseyAIPromos.includes(promo) || extraAiPricingPromos.includes(promo)
          )
        : [];

      const starterSeats = Number(getFieldValue(fieldStarterSeat, formFields) || 0);
      const officeSeats = Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
      const totalSeats = starterSeats + officeSeats;
      let totalOdysseyAIDiscount = 0;

      if (selectedOdysseyAIPromos.length > 0 && totalSeats > 0) {
        selectedOdysseyAIPromos.forEach(promo => {
          const promoOption = formFields[fieldAvailableDiscountsAndPromotions] && formFields[fieldAvailableDiscountsAndPromotions].options && formFields[fieldAvailableDiscountsAndPromotions].options.find(
            opt => opt.fields.value === promo
          );
          if (promoOption && promoOption.fields.monthlyPayment) {
            const discountPerSeat = Math.abs(promoOption.fields.monthlyPayment);
            totalOdysseyAIDiscount += discountPerSeat * totalSeats;
          }
        });
      }

      if (totalOdysseyAIDiscount > 0) {
        newDueMonthly -= totalOdysseyAIDiscount;
      }
      setOdysseyAIPromotionApplied(totalOdysseyAIDiscount);

      // Standalone (non-feature) checkbox charges so a checked priced checkbox
      // (e.g. AI Receptionist install) is reflected in the totals on re-open.
      const standaloneCheckboxCharges = getStandaloneCheckboxPrices(formFields);
      newDueMonthly += standaloneCheckboxCharges.monthly;
      newDueNow += standaloneCheckboxCharges.oneTime;

      setDueNow(newDueNow);
      setDueMonthly(newDueMonthly);
      setPriceFeatures(totalPriceFeatures);
      setRates(totalRates);
      setPriceGSuite(totalGSuite);
    }
  }, [fieldsWithValue, ratesStarterSeat, ratesOfficeSeats, appliedCoupons]);
    useEffect(() => {
    if (formName === businessConnectQuoteToolForm) {
      const prequalFields = formStepFields.find(
        stepFields => stepFields.fields.name === 'networkPrequalification'
      );
      const reducedFields = _.get(
        prequalFields,
        'fields.formFields',
        []
      ).reduce(reduceFields, []);
      const {
        prequalEligible,
        prequalInEligibleNote
      } = checkIfPrequalificationPass(reducedFields);
      setEligible({ isEligible: prequalEligible, note: prequalInEligibleNote });
    }
    if (formName === orderDetailsForm && step === 1) {
      calculateDueNowTotal(formFields);
    }
  }, [formFields,billCreditCoupons]);

  const renderFormSummary = (formSummaryGroup, data = orderData) => {
    let summaryData = data;
    if (formName === businessConnectQuoteToolForm) {
      summaryData = { ...profile, ...summaryData };
    }

    // Ensure appliedCoupons are included in summaryData.
    // Bill credit applies to site 1 only. On subsequent sites of a multisite
    // order, exclude bill credit from the Order Summary display WITHOUT removing
    // it from the persisted `appliedCoupons` (shared with site 1). The combined
    // Order Summary on the last site renders every site via this function, so
    // use the per-site `currentSite` from `data` (siteOrderData) rather than the
    // currently-open order's site, otherwise site 1's section would be filtered.
    const summarySiteNumber = _.get(data, 'currentSite', currentSite);
    const excludeBillCreditForSite = coupons =>
      isMultisiteOrder && summarySiteNumber > 1
        ? (coupons || []).filter(
            c => !((c && c.couponType ? c.couponType : '').toLowerCase().includes(couponTypeBillCredit))
          )
        : coupons;
    if (appliedCoupons && appliedCoupons.length > 0) {
      summaryData = { ...summaryData, appliedCoupons: excludeBillCreditForSite(appliedCoupons) };
    } else if (orderData && orderData.appliedCoupons) {
      summaryData = { ...summaryData, appliedCoupons: excludeBillCreditForSite(orderData.appliedCoupons) };
    }

    if (isSalesSupport) {
      summaryData = {
        handleFormField,
        isSelectAllowed: formName === businessConnectQuoteToolForm,
        ref: formFields[keyChannelId] && formFields[keyChannelId].ref,
        error:
          formErrors &&
          formErrors[keyChannelId] &&
          formErrors[keyChannelId].text,
        ...summaryData
      };
    }
    if (isVarAgent) {
      summaryData = {
        handleFormField,
        isSelectAllowed: formName === businessConnectQuoteToolForm,
        ref: formFields[keyOutlet] && formFields[keyOutlet].ref,
        error:
          formErrors && formErrors[keyOutlet] && formErrors[keyOutlet].text,
        ...summaryData
      };
    }
    if (
      isRecontractFlow &&
      formSummaryGroup.fields.backendKey === fieldCustomerInfo
    ) {
      // eslint-disable-next-line no-param-reassign
      formSummaryGroup.fields.backendFields = formSummaryGroup.fields.backendFields.filter(
        field => field.fields.backendKey !== fieldBillingAddress
      );
      // eslint-disable-next-line no-param-reassign
      formSummaryGroup.fields.backendFields = formSummaryGroup.fields.backendFields.map(
        field => {
          if (field.fields.backendKey === fieldServiceAddress) {
            // eslint-disable-next-line no-param-reassign
            field.fields.name = 'Billing Address';
          }
          return field;
        }
      );
    }
    return <FormSummaryGroup data={formSummaryGroup} orderData={summaryData} />;
  };

  const isCrossSellCreditPromoAvailable = fields => {
    const valueIsTelusWorkplaceOrder = _.get(
      orderData,
      fieldIsThisOrderAPartOfTELUSWorkplace,
      no
    );
    const valueBundleServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    return (
      [valueSegmentCommercial, valueSegmentSmb30To100].includes(valueSegment) &&
      valueIsTelusWorkplaceOrder !== yes &&
      valueBundleServices === yes
    );
  };

  const isMppPromo = () => {
    const valueSegment = _.get(
      orderData,
      fieldCustomerSegment,
      valueSegmentSmb1To30
    );
    return valueSegment === valueSegmentSmb1To30;
  };
  const is$100BillCreditPromo = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueIsNewInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const isThreeYearContract = getFieldValue(fieldContractTerm, fields);
    // Retrieve and sanitize seat counts
    const starterSeatCount = +getFieldValue(fieldStarterSeat, formFields);
    const officeSeatCount = +getFieldValue(fieldOfficeSeats, formFields);
    // eslint-disable-next-line no-restricted-globals
    const sanitizedStarterSeatCount = Number.isNaN(starterSeatCount)
      ? 0
      : starterSeatCount;
    // eslint-disable-next-line no-restricted-globals
    const sanitizedOfficeSeatCount = Number.isNaN(officeSeatCount)
      ? 0
      : officeSeatCount;
    const totalNoOfSeats = sanitizedStarterSeatCount + sanitizedOfficeSeatCount;
    const basicPromoEligibility =
      !isDealer &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueIsNewInstallation === valueNew &&
      valueProvince === 'Ontario' &&
      isThreeYearContract === threeYears &&
      totalNoOfSeats >= 2 &&
      totalNoOfSeats <= 30;
    return basicPromoEligibility;
  };

  const businessConnectEnhancedClosingTool = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const starterSeatCount = +getFieldValue(fieldStarterSeat, formFields);
    const officeSeatCount = +getFieldValue(fieldOfficeSeats, formFields);
    const sanitizedStarterSeatCount = Number.isNaN(starterSeatCount)
      ? 0
      : starterSeatCount;
    const sanitizedOfficeSeatCount = Number.isNaN(officeSeatCount)
      ? 0
      : officeSeatCount;

    const totalNoOfSeats = sanitizedStarterSeatCount + sanitizedOfficeSeatCount;
    const isContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueBusinessConnectEdition = getFieldValue(
      fieldBusinessConnectEdition,
      fields
    );
    const valueIsNewInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueBundleServices = getFieldValue(fieldOtherTelusServices, fields);
    const basicPromoEligibility =
      [valueSegmentSmb1To30].includes(valueSegment) &&
      totalNoOfSeats >= 6 &&
      totalNoOfSeats <= 14 &&
      (valueProvince === 'Ontario' || valueProvince === 'Atlantic') &&
      isContractTerm === threeYears &&
      valueBusinessConnectEdition === enhanced &&
      valueBundleServices === yes &&
      closingToolOutletIds.includes(outletId) &&
      valueIsNewInstallation === valueNew &&
      !isMultisiteOrder;
    return basicPromoEligibility;
  };

  const is$70BillCreditPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueProvinceServiceAddress = getFieldValue(
      fieldProvinceServiceAddress, 
      fields
    );
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    return (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueContractTerm === threeYears &&
      valueTypeOfInstallation === valueNew &&
      valueOtherTelusServices === yes &&
      [enhanced, complete].includes(valueEdition) &&
      !allowedProvinceQCBundle.includes(valueProvince) &&
      !allowedProvinceQCBundle.includes(valueProvinceServiceAddress) &&
      totalNumberOfSeats >= 3 &&
      totalNumberOfSeats <= 14
    );
  };

  const is$140BillCreditPromoAvailable = fields => {
    // For multisite this offer is only available to first site
    if (isMultisiteOrder && currentSite > 1) {
      return false;
    }

    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    // const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    // const valueProvinceServiceAddress = getFieldValue(
    //   fieldProvinceServiceAddress, 
    //   fields
    // );
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    return (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueContractTerm === threeYears &&
      valueTypeOfInstallation === valueNew &&
      valueOtherTelusServices === yes &&
      valueEdition === complete &&
      totalNumberOfSeats >= 3
    );
  };

  const is$75BillCreditPromoAvailable = fields => {
    // For multisite this offer is only available to first site
    if (isMultisiteOrder && currentSite > 1) {
      return false;
    }

    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    // const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    // const valueProvinceServiceAddress = getFieldValue(
    //   fieldProvinceServiceAddress,
    //   fields
    // );
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    return (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueContractTerm === threeYears &&
      valueTypeOfInstallation === valueNew &&
      valueOtherTelusServices === yes &&
      [voicePlus, enhanced].includes(valueEdition) &&
      totalNumberOfSeats >= 3
    );
  };

  // ---------------------------------------------------------------------
  // Visibility predicates for the new flat-rate BCON Bundled offers.
  // Common eligibility (shared across all):
  //   * Segment      : SMB (1-30) or SMB (30-100)
  //   * Edition      : Complete
  //   * Term         : 3 yr or 5 yr (specific term enforced per-offer)
  //   * Bundled cust : valueOtherTelusServices === yes
  //   * Acquisition  : New install (single-site) OR multi-site addon
  //                    sub-site (per spec: available on add-on seat when
  //                    first seat is new — multi-site sub-sites at
  //                    currentSite > 1 are forced to Add-on type while
  //                    the lead site is New).
  // Additional per-offer rules:
  //   * $25           : All provinces, NOT BCON AI flow
  //   * $10 off 36mo  : BCON AI flow AND 3 yr term (all provinces)
  //   * $10 off 60mo  : BCON AI flow AND 5 yr term (all provinces)
  // ---------------------------------------------------------------------
  const isCommonNewBconBundledOfferEligible = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    // Multi-site sub-site exemption: currentSite > 1 is auto-forced to
    // Add-on, but the first site is New, so the offer remains available.
    const isAddonOnMultisiteSubSite =
      isMultisiteOrder && currentSite > 1 && isAddOnInstalation();
    const installEligible = isNewInstalation() || isAddonOnMultisiteSubSite;
    return (
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      ['Complete'].includes(valueEdition) &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueOtherTelusServices === yes &&
      totalNumberOfSeats >= 3
    );
  };

  const isNewBconCompleteBundled25Available = fields =>
    isCommonNewBconBundledOfferEligible(fields) && !isThisOdysseyAIOrder;

  const isBusCon10OffFor36MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return (
      isCommonNewBconBundledOfferEligible(fields) &&
      isThisOdysseyAIOrder &&
      valueContractTerm === threeYears
    );
  };

  const isBusCon10OffFor60MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return (
      isCommonNewBconBundledOfferEligible(fields) &&
      isThisOdysseyAIOrder &&
      valueContractTerm === fiveYears
    );
  };

  // ---------------------------------------------------------------------
  // OdysseyAI edition-specific bundled discount promos.
  // Enhanced: $4/seat off; Complete: $7/seat off.
  // Eligibility: OdysseyAI flow, SMB 1-30 / 30-100, non-Quebec (both
  // order province and service province), bundled, new acquisition,
  // 3+ seats, 3 or 5 year term, and the matching edition.
  // ---------------------------------------------------------------------
  const isCommonNewBconEditionBundledOfferEligible = (fields, edition) => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceOrder = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueProvinceService = getFieldValue(fieldProvinceServiceAddress, fields);
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const isAddonOnMultisiteSubSite = isMultisiteOrder && currentSite > 1 && isAddOnInstalation();
    const installEligible = isNewInstalation() || isAddonOnMultisiteSubSite;
    return (
      isThisOdysseyAIOrder &&
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueEdition === edition &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueOtherTelusServices === yes &&
      !allowedProvinceQCBundle.includes(valueProvinceOrder) &&
      !allowedProvinceQCBundle.includes(valueProvinceService) &&
      totalNumberOfSeats >= 3
    );
  };

  const isBusCon4DiscountOn36MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isCommonNewBconEditionBundledOfferEligible(fields, enhanced) && valueContractTerm === threeYears;
  };

  const isBusCon4DiscountOn60MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isCommonNewBconEditionBundledOfferEligible(fields, enhanced) && valueContractTerm === fiveYears;
  };

  const isBusCon7OffFor36MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isCommonNewBconEditionBundledOfferEligible(fields, complete) && valueContractTerm === threeYears;
  };

  const isBusCon7OffFor60MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isCommonNewBconEditionBundledOfferEligible(fields, complete) && valueContractTerm === fiveYears;
  };

  // BCON-2645 Scenario A: Bus Con $5 off for 36/60 months.
  // BCON AI flow, Complete edition, Ontario order + service province,
  // bundled, SMB 1-30/30-100, 3 or 5 year term, and at least one seat.
  // New and single-site add-on orders are eligible. Multi-site add-on sites
  // inherit eligibility only when site 1 was eligible as a New installation.
  // Uses its own eligibility (not the shared common helper) so single-site
  // add-on is allowed without affecting the $4/$7-off promos.
  const isBusCon5OffEligible = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceOrder = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueProvinceService = getFieldValue(fieldProvinceServiceAddress, fields);
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const isEligibleAddon =
      isAddOnInstalation() && (!isMultisiteOrder || currentSite > 1);
    const installEligible = isNewInstalation() || isEligibleAddon;
    return (
      isThisOdysseyAIOrder &&
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueEdition === complete &&
      valueOtherTelusServices === yes &&
      valueProvinceOrder === valueOntario &&
      valueProvinceService === valueOntario &&
      totalNumberOfSeats > 0
    );
  };

  const isBusCon5OffFor36MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isBusCon5OffEligible(fields) && valueContractTerm === threeYears;
  };

  const isBusCon5OffFor60MonthsAvailable = fields => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    return isBusCon5OffEligible(fields) && valueContractTerm === fiveYears;
  };

  // BCON-2645 Scenario B: Complete Bundled $30 — Regular BCON (non-OdysseyAI),
  // Complete edition, Ontario order + service province, bundled,
  // SMB 1-30/30-100, 3 or 5 year term, and at least one seat.
  // New and single-site add-on orders are eligible. Multi-site add-on sites
  // inherit eligibility only when site 1 was eligible as a New installation.
  const isCompleteBundled30Available = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvinceOrder = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceService = getFieldValue(fieldProvinceServiceAddress, fields);
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const isEligibleAddon =
      isAddOnInstalation() && (!isMultisiteOrder || currentSite > 1);
    const installEligible = isNewInstalation() || isEligibleAddon;
    return (
      !isThisOdysseyAIOrder &&
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueEdition === complete &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueOtherTelusServices === yes &&
      valueProvinceOrder === valueOntario &&
      valueProvinceService === valueOntario &&
      totalNumberOfSeats > 0
    );
  };

  // Enhanced Bundled $26-3MF — regular BCON only (non-OdysseyAI).
  // SMB 1-30 / SMB 30-100, non-Quebec (order + service province), bundled,
  // new acquisition OR multisite sub-site, 3+ seats, 3yr or 5yr term, Enhanced edition.
  const isEnhanced3MFPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceServiceAddress = getFieldValue(fieldProvinceServiceAddress, fields);
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const isAddonOnMultisiteSubSite =
      isMultisiteOrder && currentSite > 1 && isAddOnInstalation();
    const installEligible = isNewInstalation() || isAddonOnMultisiteSubSite;
    return (
      !isThisOdysseyAIOrder &&
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueEdition === enhanced &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueOtherTelusServices === yes &&
      !allowedProvinceQCBundle.includes(valueProvince) &&
      !allowedProvinceQCBundle.includes(valueProvinceServiceAddress) &&
      totalNumberOfSeats >= 3
    );
  };

  // Complete Bundled $28-3MF — same criteria as Enhanced 3MF but for Complete edition.
  const isComplete3MFPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceServiceAddress = getFieldValue(fieldProvinceServiceAddress, fields);
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const isAddonOnMultisiteSubSite =
      isMultisiteOrder && currentSite > 1 && isAddOnInstalation();
    const installEligible = isNewInstalation() || isAddonOnMultisiteSubSite;
    return (
      !isThisOdysseyAIOrder &&
      installEligible &&
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueEdition === complete &&
      [threeYears, fiveYears].includes(valueContractTerm) &&
      valueOtherTelusServices === yes &&
      !allowedProvinceQCBundle.includes(valueProvince) &&
      !allowedProvinceQCBundle.includes(valueProvinceServiceAddress) &&
      totalNumberOfSeats >= 3
    );
  };

  const isEnhancedSeatComboPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueIsThisOdysseyAI = _.get(orderData, 'isThisOdysseyAI', '');
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueProvinceServiceAddress = getFieldValue(
      fieldProvinceServiceAddress, 
      fields
    );

    return (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueContractTerm === threeYears &&
      (valueTypeOfInstallation === valueNew ||
        (isMultisiteOrder && currentSite !== 1)) &&
      valueOtherTelusServices === yes &&
      valueEdition === enhanced &&
      !allowedProvinceQCBundle.includes(valueProvince) &&
      !allowedProvinceQCBundle.includes(valueProvinceServiceAddress) &&
      valueIsThisOdysseyAI !== yes
    );
  };

  const isCompleteSeatComboPromoAvailable = fields => {
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueIsThisOdysseyAI = _.get(orderData, 'isThisOdysseyAI', '');
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      fields
    );
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    const valueProvinceServiceAddress = getFieldValue(
      fieldProvinceServiceAddress, 
      fields
    );

    return (
      [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
      valueContractTerm === threeYears &&
      (valueTypeOfInstallation === valueNew ||
        (isMultisiteOrder && currentSite !== 1)) &&
      valueOtherTelusServices === yes &&
      valueEdition === complete &&
      !allowedProvinceQCBundle.includes(valueProvince) &&
      !allowedProvinceQCBundle.includes(valueProvinceServiceAddress) &&
      valueIsThisOdysseyAI !== yes
    );
  };

  const isOdysseyAIPromoAvailable = fields => {
    const valueIsThisOdysseyAI = _.get(orderData, 'isThisOdysseyAI', '');
    
    // Only available for OdysseyAI orders
    return valueIsThisOdysseyAI === yes;
  };

  const getOdysseyAIPromoList = (promoList, fields) => {
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueOtherTelusServices = getFieldValue(fieldOtherTelusServices, fields);
    const valueProvinceOrder = _.get(orderData, fieldProvinceOfTheOrder, '');
    const valueProvinceService = getFieldValue(fieldProvinceServiceAddress, fields);
    const valueCustomerSegment = _.get(orderData, fieldCustomerSegment, '');
    
    // Check if Quebec (either order province or service province)
    const isQuebec = allowedProvinceQCBundle.includes(valueProvinceOrder) && allowedProvinceQCBundle.includes(valueProvinceService);
    const isBundled = valueOtherTelusServices === yes;
    const nonQuebecBundledPromotions =
      valueCustomerSegment === valueSegmentCommercial
        ? ODYSSEY_AI_PROMOTIONS
        : {
            ...ODYSSEY_AI_PROMOTIONS,
            ...ODYSSEY_AI_PROMOTIONS_NON_COMMERCIAL
          };

    let availablePromos = [];
    
    // Contract Discount Promos (no bundling required)
    if (valueContractTerm === threeYears) {
      availablePromos.push(ODYSSEY_AI_PROMOTIONS.CONTRACT_DISCOUNT_3_YEARS);
    }
    if (valueContractTerm === fiveYears) {
      availablePromos.push(ODYSSEY_AI_PROMOTIONS.CONTRACT_DISCOUNT_5_YEARS);
    }
    
    // Bundled Discount Promos
    if (isBundled) {
      if (isQuebec) {
        // Quebec bundled promos ($10)
        if (valueContractTerm === monthToMonth) {
          availablePromos.push(ODYSSEY_AI_PROMOTIONS.BUNDLED_DISCOUNT_MTM_QC);
        }
        if (valueContractTerm === threeYears) {
          availablePromos.push(ODYSSEY_AI_PROMOTIONS.BUNDLED_DISCOUNT_3_YEARS_QC);
        }
        if (valueContractTerm === fiveYears) {
          availablePromos.push(ODYSSEY_AI_PROMOTIONS.BUNDLED_DISCOUNT_5_YEARS_QC);
        }
      } else {
        // Non-Quebec bundled promos: commercial gets $10, other segments get $5
        if (valueContractTerm === monthToMonth) {
          availablePromos.push(nonQuebecBundledPromotions.BUNDLED_DISCOUNT_MTM_NON_QC);
        }
        if (valueContractTerm === threeYears) {
          availablePromos.push(nonQuebecBundledPromotions.BUNDLED_DISCOUNT_3_YEARS_NON_QC);
        }
        if (valueContractTerm === fiveYears) {
          availablePromos.push(nonQuebecBundledPromotions.BUNDLED_DISCOUNT_5_YEARS_NON_QC);
        }
      }
    }
    
    // Filter promoList to only include available OdysseyAI promos
    return promoList.filter(item => availablePromos.includes(item.fields.value));
  };

  const isMultiUnitDiscountPromoAvailable = fields => {
    const valueIsThisOdysseyAI = _.get(orderData, 'isThisOdysseyAI', '');
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);

    // OdysseyAI is required for ALL installation types
    // Now supports MTM, 3-year, and 5-year terms
    // Supports both bundled and non-bundled
    return (
      [monthToMonth, threeYears, fiveYears].includes(valueContractTerm) &&
      [complete, enhanced].includes(valueEdition) &&
      valueIsThisOdysseyAI === yes
    );
  };

  const getMultiUnitDiscountPromoList = promoList => {
    let listCopy = [...promoList];
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
    const valueTypeOfInstallation = getFieldValue(
      fieldTypeOfInstallation,
      formFields
    );

    /**
     * If it's not a multi-site order then select all Non Multi-site promos AND
     * Filter them based on seat count (except for Add-on installation type)
     */
    if (!isMultisiteOrder) {
      // Add all non multi-site promos
      listCopy = listCopy.filter(promo =>
        multiUnitDiscountArray.includes(promo.fields.value)
      );
      
      // For Add-on installation type: Show ALL MUD promos (no seat filtering)
      // For New installation type: Filter based on seat count
      if (valueTypeOfInstallation !== valueAddon) {
        // Filter non multi-site promos based on seat count
        listCopy = listCopy.filter(promo => {
          const range =
            multiUnitDiscountSeatMapping[promo.fields.value];
          return (
            range &&
            totalNumberOfSeats >= range.minSeats &&
            totalNumberOfSeats <= range.maxSeats
          );
        });
      }
    }

    return listCopy;
  };

  const getEnhancedSeatComboPromoList = promoList => {
    let listCopy = [...promoList];
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    /**
     * If it's a multi-site order then select all Multi-site promos
     */
    if (isMultisiteOrder) {
      listCopy = listCopy.filter(promo =>
        ENHANCED_SEAT_PROMO_MULTI_SITE.includes(promo.fields.value)
      );
    }

    /**
     * If it's not a multi-site order then select all Non Multi-site promos AND
     * Filter them based on seat count
     */
    if (!isMultisiteOrder) {
      // Add all non multi-site promos
      listCopy = listCopy.filter(promo =>
        ENHANCED_SEAT_PROMO_NON_MULTI_SITE.includes(promo.fields.value)
      );
      // Filter non multi-site promos based on seat count
      listCopy = listCopy.filter(promo => {
        const range =
          ENHANCED_SEAT_PROMO_NON_MULTI_SITE_MAP[promo.fields.value];
        return (
          range &&
          totalNumberOfSeats >= range.minSeats &&
          totalNumberOfSeats <= range.maxSeats
        );
      });
    }

    return listCopy;
  };

  const getCompleteSeatComboPromoList = promoList => {
    let listCopy = [...promoList];
    const totalNumberOfSeats =
      Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
      Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

    /**
     * If it's a multi-site order then select all Multi-site promos
     */
    if (isMultisiteOrder) {
      listCopy = listCopy.filter(promo =>
        COMPLETE_SEAT_PROMO_MULTI_SITE.includes(promo.fields.value)
      );
    }

    /**
     * If it's not a multi-site order then select all Non Multi-site promos AND
     * Filter them based on seat count
     */
    if (!isMultisiteOrder) {
      // Add all non multi-site promos
      listCopy = listCopy.filter(promo =>
        COMPLETE_SEAT_PROMO_NON_MULTI_SITE.includes(promo.fields.value)
      );
      // Filter non multi-site promos based on seat count
      listCopy = listCopy.filter(promo => {
        const range =
          COMPLETE_SEAT_PROMO_NON_MULTI_SITE_MAP[promo.fields.value];
        return (
          range &&
          totalNumberOfSeats >= range.minSeats &&
          totalNumberOfSeats <= range.maxSeats
        );
      });
    }

    return listCopy;
  };

  const getPromotionList = (list, fields) => {
    const valueInstallation = getFieldValue(
      fieldDoesTheCustomerRequireWhiteGlove,
      fields
    );
    const valueSegment = _.get(orderData, fieldCustomerSegment, '');
    const valueContractTerm = getFieldValue(fieldContractTerm, fields);
    const valueEdition = getFieldValue(fieldBusinessConnectEdition, fields);

    const valueOfficeSeat = getFieldValue(fieldOfficeSeats, formFields);
    const valueStarterSeat = getFieldValue(fieldStarterSeat, formFields);
    const valueOtherTelusServices = getFieldValue(
      fieldOtherTelusServices,
      fields
    );
    let promoList = list;

    // for below logic first check  SMB only,New activations only, 3 year contract only
    if (
      isSMB() &&
      isNewInstalation() &&
      isThreeYearsContract(fields) &&
      mppOffersOutletIds.includes(outletId)
    ) {
      const starterSeatCount = +getFieldValue(fieldStarterSeat, formFields);
      const officeSeatCount = +getFieldValue(fieldOfficeSeats, formFields);
      // eslint-disable-next-line no-restricted-globals
      const sanitizedStarterSeatCount = Number.isNaN(starterSeatCount)
        ? 0
        : starterSeatCount;
      // eslint-disable-next-line no-restricted-globals
      const sanitizedOfficeSeatCount = Number.isNaN(officeSeatCount)
        ? 0
        : officeSeatCount;
      const totalNoOfSeats =
        sanitizedStarterSeatCount + sanitizedOfficeSeatCount;
      if (totalNoOfSeats === 1) {
        promoList = promoList.filter(
          item =>
            item.fields.value !== 'MPP Offer' &&
            item.fields.value !== '$50 Bill Credit' &&
            item.fields.value !== 'MPP $100 Bill Credit' &&
            item.fields.value !== '$150 Bill Credit'
        );
      } else if (totalNoOfSeats >= 2 && totalNoOfSeats <= 5) {
        promoList = promoList.filter(
          item =>
            item.fields.value !== 'MPP $100 Bill Credit' &&
            item.fields.value !== '$150 Bill Credit'
        );
      } else if (totalNoOfSeats >= 6 && totalNoOfSeats <= 10) {
        promoList = promoList.filter(
          item =>
            item.fields.value !== '$50 Bill Credit' &&
            item.fields.value !== '$150 Bill Credit'
        );
      } else if (totalNoOfSeats >= 11) {
        promoList = promoList.filter(
          item =>
            item.fields.value !== '$50 Bill Credit' &&
            item.fields.value !== 'MPP $100 Bill Credit'
        );
      } else {
        promoList = promoList.filter(
          item =>
            item.fields.value !== '$50 Bill Credit' &&
            item.fields.value !== '$150 Bill Credit'
        );
      }
    } else {
      promoList = promoList.filter(
        item =>
          item.fields.value !== '$50 Bill Credit' &&
          item.fields.value !== 'MPP $100 Bill Credit' &&
          item.fields.value !== '$150 Bill Credit' &&
          item.fields.value !== 'MPP Offer'
      );
    }
    if (!isDevicesPromo(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueNinetyNineCentDevicePromo
      );

    if (!isHardwareCreditPromo(fields) && !isHardwareCreditPromoAddOn(fields)) {
      promoList = promoList.filter(
        item => item.fields.value !== valueHardwareCreditPromo
      );
    }

    if (!isCrossSellCreditPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueCrossSellCredit
      );

    if (!isThreeMonthsFreePromo(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueThreeMonthsFree
      );
    
    if (!isThreeMonthsFreeVisible(fields).visibility) {
      promoList = promoList.filter(
        item => item.fields.value !== valueThreeMonthsFree
      );
    } 
    // else if(isThreeMonthsFreeVisible(fields).isValidMultiOrder) {
    //   // Append label for Three Months Free promo if present
    //   promoList = promoList.map(item => {
    //     if (item.fields.value === valueThreeMonthsFree) {
    //       return {
    //         ...item,
    //         fields: {
    //           ...item.fields,
    //           label: `${item.fields.label} (Only valid for 15 or more seats)`
    //         }
    //       };
    //     }
    //     return item;
    //   });
    // }

    if (!isFourMonthsFreePromo(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueFourMonthsFree
      );

    if (!isMppPromo(fields))
      promoList = promoList.filter(item => item.fields.value !== valueMppPromo);

    if (!isEnhancedPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueEnhancedPromoAvailable
      );

    if (!isMppEnhancedPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueMppEnhancedPromoAvailable
      );

    if (!isCbmEnhancedPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueCbmEnhancedPromoAvailable
      );

    if (!isBusinessHeroPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueBusinessHeroPromo
      );

    if (!isVoicePlusPromoAvailable(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueVoicePlusPromo
      );

    if (!isOneTime50BillCreditAvailable(fields) || isThisOdysseyAIOrder)
      promoList = promoList.filter(
        item => item.fields.value !== valueOneTime50BillCredit
      );

    if (!businessConnectEnhancedClosingTool(fields))
      promoList = promoList.filter(
        item => item.fields.value !== valueBusinessConnectEnhancedClosingTool
      );

    if (!is$100BillCreditPromo(fields) || isThisOdysseyAIOrder)
      promoList = promoList.filter(
        item => item.fields.value !== value$100BillCreditWithBusinessWifi
      );
    if (
      valueInstallation !== valueTelusVirtualInstallation ||
      isDealer ||
      ![valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) ||
      [monthToMonth, fiveYears].includes(valueContractTerm)
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== valueVirtualInstallPromo
      );
    }

    if (
      valueInstallation !== valueTelusVirtualInstallation ||
      !(isDealer && isDealerShipBravad) ||
      getFieldValue(fieldTypeOfInstallation, formFields) !== valueNew ||
      [monthToMonth, fiveYears].includes(valueContractTerm)
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== valueBravadVirtualInstallPromo
      );
    }
    if (
      !(
        isNewInstalation() &&
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
        [voicePlus, enhanced, complete, 'Complete +'].includes(valueEdition) &&
        [threeYears].includes(valueContractTerm) &&
        $100OutletIds.includes(outletId)
      ) || isThisOdysseyAIOrder
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== Online$100BillCredit
      );
    }

    const valueProvince = _.get(orderData, fieldProvinceOfTheOrder, '');
    const isNonQuebecProvince = !allowedProvinceQCBundle.includes(valueProvince);

    const checkEligibilitySiteComplete = (
      valueSegment,
      valueEdition,
      valueContractTerm,
      orderData,
      valueOtherTelusServices
    ) => {
      return (
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
        ['Complete'].includes(valueEdition) &&
        [threeYears].includes(valueContractTerm) &&
        valueOtherTelusServices === yes
      );
    };
    const checkEligibilitycomplete = (
      valueSegment,
      valueEdition,
      valueContractTerm,
      orderData,
      valueOtherTelusServices
    ) => {
      return (
        isNewInstalation() &&
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) &&
        ['Complete'].includes(valueEdition) &&
        [threeYears].includes(valueContractTerm) &&
        valueOtherTelusServices === yes
      );
    };
    const totalSeats = Number(valueOfficeSeat) + Number(valueStarterSeat);

    const isEligibleSiteComplete = checkEligibilitySiteComplete(
      valueSegment,
      valueEdition,
      valueContractTerm,
      orderData,
      valueOtherTelusServices
    );

    const isEligibleComplete = checkEligibilitycomplete(
      valueSegment,
      valueEdition,
      valueContractTerm,
      orderData,
      valueOtherTelusServices
    );

    // ---------------------------------------------------------------------
    // Eligibility for the new flat-rate BCON Bundled offers (no seat tier).
    // Delegated to the named visibility predicates defined alongside the
    // other promo helpers (matches the pattern used by every other promo).
    // ---------------------------------------------------------------------
    const isNewBconCompleteBundled25Eligible = isNewBconCompleteBundled25Available(
      fields
    );
    const isBusCon10OffFor36MonthsEligible = isBusCon10OffFor36MonthsAvailable(
      fields
    );
    const isBusCon10OffFor60MonthsEligible = isBusCon10OffFor60MonthsAvailable(
      fields
    );
    const isBusCon4DiscountOn36MonthsEligible = isBusCon4DiscountOn36MonthsAvailable(
      fields
    );
    const isBusCon4DiscountOn60MonthsEligible = isBusCon4DiscountOn60MonthsAvailable(
      fields
    );
    const isBusCon7OffFor36MonthsEligible = isBusCon7OffFor36MonthsAvailable(
      fields
    );
    const isBusCon7OffFor60MonthsEligible = isBusCon7OffFor60MonthsAvailable(
      fields
    );
    const isEnhanced3MFPromoEligible = isEnhanced3MFPromoAvailable(fields);
    const isComplete3MFPromoEligible = isComplete3MFPromoAvailable(fields);
    const isBusCon5OffFor36MonthsEligible = isBusCon5OffFor36MonthsAvailable(fields);
    const isBusCon5OffFor60MonthsEligible = isBusCon5OffFor60MonthsAvailable(fields);
    const isCompleteBundled30Eligible = isCompleteBundled30Available(fields);
    const isCommonNewBconBundledEligible = isCommonNewBconBundledOfferEligible(
      fields
    );
    const completeBundledSeats = [
      CompleteBundledSeat$36,
      CompleteBundleddSeat$34,
      CompleteBundleddSeat$32,
      CompleteBundleddSeat$30,
      CompleteBundleddSeat$29
    ];

    if (currentSite === 1) {
      if (!(isEligibleComplete && orderData.multisiteOrder === yes)) {
        promoList = promoList.filter(
          item => !completeBundledSeats.includes(item.fields.value)
        );
      }
    }
    if (currentSite !== 1) {
      const availablePromo = _.get(orderData, 'availableNewpromo', []);
      promoList = promoList.filter(item =>
        availablePromo.includes(item.fields.value)
      );
      if (!(isEligibleSiteComplete && orderData.multisiteOrder === yes)) {
        promoList = promoList.filter(
          item => !completeBundledSeats.includes(item.fields.value)
        );
      }
      promoList = promoList.filter(item =>
        availablePromo.includes(item.fields.value)
      );
    }

    // Getting the Enhanced Promo List
    if (isEnhancedSeatComboPromoAvailable(fields)) {
      const enhancedSeatPromoList = [
        ...ENHANCED_SEAT_PROMO_MULTI_SITE,
        ...ENHANCED_SEAT_PROMO_NON_MULTI_SITE
      ];
      const availableEnhancedSeatPromos = getEnhancedSeatComboPromoList(
        promoList
      );
      // First remove all Enhanced Seat Promos
      promoList = promoList.filter(
        item => !enhancedSeatPromoList.includes(item.fields.value)
      );
      // Add the ones that are avaialble
      promoList = [...promoList, ...availableEnhancedSeatPromos];
    } else {
      const enhancedSeatPromoList = [
        ...ENHANCED_SEAT_PROMO_MULTI_SITE,
        ...ENHANCED_SEAT_PROMO_NON_MULTI_SITE
      ];
      promoList = promoList.filter(
        item => !enhancedSeatPromoList.includes(item.fields.value)
      );
    }

    // Getting the Complete Promo List
    if (isCompleteSeatComboPromoAvailable(fields)) {
      const completeSeatPromoList = [
        ...COMPLETE_SEAT_PROMO_MULTI_SITE,
        ...COMPLETE_SEAT_PROMO_NON_MULTI_SITE
      ];
      const availableCompleteSeatPromos = getCompleteSeatComboPromoList(
        promoList
      );
      // First remove all Complete Seat Promos
      promoList = promoList.filter(
        item => !completeSeatPromoList.includes(item.fields.value)
      );
      // Add the ones that are avaialble
      promoList = [...promoList, ...availableCompleteSeatPromos];
    } else {
      const completeSeatPromoList = [
        ...COMPLETE_SEAT_PROMO_MULTI_SITE,
        ...COMPLETE_SEAT_PROMO_NON_MULTI_SITE
      ];
      promoList = promoList.filter(
        item => !completeSeatPromoList.includes(item.fields.value)
      );
    }

    if (isMultiUnitDiscountPromoAvailable(fields)) {
      const availableMultiUnitDiscounPromos = getMultiUnitDiscountPromoList(
        promoList
      );
      // First remove all MU Seat Promos
      promoList = promoList.filter(
        item => !multiUnitDiscountArray.includes(item.fields.value)
      );
      // Add the ones that are avaialble
      promoList = [...promoList, ...availableMultiUnitDiscounPromos];
    } else {
      promoList = promoList.filter(
        item => !multiUnitDiscountArray.includes(item.fields.value)
      );
    }

    // OdysseyAI Promotions
    if (isOdysseyAIPromoAvailable(fields)) {
      const availableOdysseyAIPromos = getOdysseyAIPromoList(promoList, fields);
      // First remove all OdysseyAI Promos
      promoList = promoList.filter(
        item => !allOdysseyAIPromos.includes(item.fields.value)
      );
      // Add the ones that are available
      promoList = [...promoList, ...availableOdysseyAIPromos];
    } else {
      // Remove all OdysseyAI promos if not an OdysseyAI order
      promoList = promoList.filter(
        item => !allOdysseyAIPromos.includes(item.fields.value)
      );
    }
    // $70 Bill Credit Promo - hide for OdysseyAI
    if (!is$70BillCreditPromoAvailable(fields) || isThisOdysseyAIOrder) {
      promoList = promoList.filter(
        item => item.fields.value !== BillCreditPromo$70
      );
    }
    // $140 Bill Credit Promo
    if (!is$140BillCreditPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => item.fields.value !== BillCreditPromo$140
      );
    }

    // $75 Bill Credit Promo
    if (!is$75BillCreditPromoAvailable(fields)) {
      promoList = promoList.filter(
        item => item.fields.value !== BillCreditPromo$75
      );
    }

    // Generic filter: Remove ALL bill credit promotions for OdysseyAI
    // EXCEPT for $75 and $140 Bill Credit which are allowed in OdysseyAI flow
    if (isThisOdysseyAIOrder) {
      const allowedBillCreditsForOdysseyAI = [
        BillCreditPromo$75,
        BillCreditPromo$140
      ];
      promoList = promoList.filter(
        item =>
          !item.fields.value.toLowerCase().includes('bill credit') ||
          allowedBillCreditsForOdysseyAI.includes(item.fields.value)
      );
    }

    // COMPLETE OFFER SEAT LOGIC
    if (
      !(
        isEligibleComplete &&
        totalSeats >= 1 &&
        totalSeats <= 14 &&
        orderData.multisiteOrder === no &&
        isNonQuebecProvince
      )
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled$36
      );
    }
    if (
      !(
        isEligibleComplete &&
        totalSeats >= 15 &&
        totalSeats <= 24 &&
        orderData.multisiteOrder === no &&
        isNonQuebecProvince
      )
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled$34
      );
    }
    if (
      !(
        isEligibleComplete &&
        totalSeats >= 25 &&
        totalSeats <= 49 &&
        orderData.multisiteOrder === no &&
        isNonQuebecProvince
      )
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled$32
      );
    }
    if (
      !(
        isEligibleComplete &&
        totalSeats >= 100 &&
        orderData.multisiteOrder === no &&
        isNonQuebecProvince
      )
    ) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled$29
      );
    }

    // ---------------------------------------------------------------------
    // NEW BCON Bundled offers (BCON-2620) — flat-rate, no seat tier
    //   * Complete Bundled $25  : Regular BCON, all provinces, 3 or 5 yr
    //   * Bus Con $10 off 36 mo : BCON AI flow, 3 yr term
    //   * Bus Con $10 off 60 mo : BCON AI flow, 5 yr term
    // Common eligibility: SMB 1-30 / 30-100, Complete edition,
    //   bundled customer, new acquisition, multi-site allowed.
    // ---------------------------------------------------------------------
    if (!isNewBconCompleteBundled25Eligible) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundledFlat$25
      );
    }
    if (!isBusCon10OffFor36MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$10OffFor36Months
      );
    }
    if (!isBusCon10OffFor60MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$10OffFor60Months
      );
    }
    // OdysseyAI edition-specific bundled discount promos ($4 off Enhanced, $7 off Complete).
    if (!isBusCon4DiscountOn36MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$4DiscountOn36Months
      );
    }
    if (!isBusCon4DiscountOn60MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$4DiscountOn60Months
      );
    }
    if (!isBusCon7OffFor36MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$7OffFor36Months
      );
    }
    if (!isBusCon7OffFor60MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$7OffFor60Months
      );
    }
    if (!isEnhanced3MFPromoEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== EnhancedBundled26_3MF
      );
    }
    if (!isComplete3MFPromoEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled26_3MF
      );
    }
    // BCON-2645 Scenario A: filter term-conditional $5 off checkboxes.
    if (!isBusCon5OffFor36MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$5OffFor36Months
      );
    }
    if (!isBusCon5OffFor60MonthsEligible) {
      promoList = promoList.filter(
        item => item.fields.value !== BusCon$5OffFor60Months
      );
    }
    // BCON-2645 Scenario B: filter Complete Bundled $30.
    if (!isCompleteBundled30Eligible) {
      promoList = promoList.filter(
        item => item.fields.value !== CompleteBundled$30
      );
    }

    // Mutual exclusion with "3 months free" (15+ seat promo).
    // Render the new BCON Bundled offers and 3MF as greyed-out
    // (disabledOption) when the other side is already selected. Drives
    // the existing FieldMultiCheckbox `nonStackableWithOptions` machinery.
    const newBconBundledOffers = [
      CompleteBundledFlat$25,
      BusCon$10OffFor36Months,
      BusCon$10OffFor60Months,
      BusCon$4DiscountOn36Months,
      BusCon$4DiscountOn60Months,
      BusCon$7OffFor36Months,
      BusCon$7OffFor60Months,
      BusCon$5OffFor36Months,
      BusCon$5OffFor60Months,
      CompleteBundled$30,
      EnhancedBundled26_3MF,
      CompleteBundled26_3MF
    ];
    promoList = promoList.map(item => {
      const itemValue = _.get(item, 'fields.value');
      const existing = _.get(item, 'fields.nonStackableWithOptions', []) || [];
      if (itemValue === valueThreeMonthsFree) {
        return {
          ...item,
          fields: {
            ...item.fields,
            nonStackableWithOptions: [
              ...existing,
              ...newBconBundledOffers.map(v => ({ fields: { value: v } }))
            ]
          }
        };
      }
      if (newBconBundledOffers.includes(itemValue)) {
        return {
          ...item,
          fields: {
            ...item.fields,
            nonStackableWithOptions: [
              ...existing,
              { fields: { value: valueThreeMonthsFree } }
            ]
          }
        };
      }
      return item;
    });

    return promoList;
  };

  let readonly = false;

  const editSite = siteData => {
    const { id, locale, categoryName } = siteData;
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=1`
    });
    setOrderData(siteData);
  };
  const renderMultiSiteSummary = (data, expandProps = {}) => {
    return multiSiteOrderSummaryData.map(siteOrderData => {
      const { id, currentSite: currentSiteNumber } = siteOrderData;
      return (
        <ExpandCollapse.Panel
          {...expandProps}
          key={id}
          id={id}
          control={<SectionHeaderTitle><Typography variant={{ bold: true }}>{`Site ${currentSiteNumber}`}</Typography></SectionHeaderTitle>}
        >
          <div style={{ float: 'right', marginTop: '2rem' }}>
            <Button
              onPress={() => {
                editSite(siteOrderData);
              }}
            >
              {editButtonLabel}
            </Button>
          </div>
          <div style={{ padding: '1rem' }}>
            <ExpandCollapse initialOpen={[]} tag="h2" topDivider={false}>
              {(innerExpandProps) => (
                data &&
                data.map(({ sys, fields }, index) => {
                  const { id: sysId } = sys;
                  const { name: fieldName, title } = fields;
                  const key = `FormField${fieldName}${index}${sysId}`;
                  const { note, formSummaryGroup } = fields;
                  readonly =
                    isAdminFlow &&
                    ![
                      fieldCustomerInformation,
                      fieldOfferConfiguration
                    ].includes(fieldName);
                  const result = sectionIsVisible(fieldName) && (
                    <ExpandCollapse.Panel
                      {...innerExpandProps}
                      key={key}
                      id={fieldName}
                      control={<SectionHeaderTitle><Typography variant={{ bold: true }}>{title}</Typography></SectionHeaderTitle>}
                    >
                      <>
                        {note && note.content && (
                          <Note data={note} type="richText" />
                        )}
                        {formSummaryGroup &&
                          renderFormSummary(formSummaryGroup, siteOrderData)}
                      </>
                    </ExpandCollapse.Panel>
                  );
                  return result;
                })
              )}
            </ExpandCollapse>
          </div>
        </ExpandCollapse.Panel>
      );
    });
  };

  useEffect(() => {
    if (isLastStep && isMultisiteOrder) {
      const { groupId } = orderData;
      request.get(`/orders/${groupId}/group`).then(resp => {
        setMultiSiteOrderSummaryData(_.get(resp, 'data.results', []));
      });
    }
  }, [step]);

  useEffect(() => {
    const footer = document.getElementById('footer');
    const introduction = document.getElementById('introduction');
    if (footer) footer.style.display = 'none';
    if (introduction) introduction.style.marginBottom = '7rem';

    return () => {
      const footer = document.getElementById('footer');
      const introduction = document.getElementById('introduction');
      if (footer) footer.style.display = '';
      if (introduction) introduction.style.marginBottom = '0';
    };
  }, []);

  const renderFormFields = data =>
    data &&
    data.map(({ sys, fields }, index) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title, expiredDate, type, note2 } = fields;
      let fieldValue = getFieldValue(fieldName, formFields);
      const fieldDateConfig = {};
      let selectOptions = _.get(fields, 'options', []);
      let isRequired = fields.required || false;
      let fieldNote = fields.note;
      let fieldNote2 = note2;
      let readonlyCheckbox = false;
      if (fieldName === fieldInstallationNote) {
        // Dealer TPI assignment is available to every channel and segment at
        // every seat count. C2F retains its separate installation workflow.
        if (!isRecontractFlow && isc2fMigrationFlow) return null;
      }

      // AI Install checkboxes (receptionistInstall / insightsInstall):
      // code-driven disable logic (FR-008b). The checkbox is rendered but
      // disabled/greyed (NOT hidden) until its AI component is selected and its
      // *_OdysseyAI value is present; enabled once isAiInstallFieldEnabled is
      // true. When disabled, reset any stale checked state so no selection
      // persists once the component is cleared (FR-008a).
      if (isAiInstallField(fieldName)) {
        if (!isAiInstallFieldEnabled(fieldName, formFields)) {
          readonlyCheckbox = true;
        }
      }

      const valueIsEContractCustomer = getFieldValue(
        fieldIsThisAnEContractCustomer,
        formFields
      );
      const valueNeedMoreThanSingleServiceAddress = getFieldValue(
        filedNeedMoreThanSingleServiceAddress,
        formFields
      );
      const valueNeedMediaAdvertisingBilling = getFieldValue(
        filedNeedMediaAdvertisingBilling,
        formFields
      );

      const valueInstallation = getFieldValue(
        fieldDoesTheCustomerRequireWhiteGlove,
        formFields
      );

      if (
        userChannelName !== CORP_STORE &&
        (fieldName === fieldStoreCodeBcon ||
          fieldName === fieldStoreCodeOutletBcon)
      ) {
        formFields[fieldStoreCodeBcon].isRequired = false;
        formFields[fieldStoreCodeOutletBcon].isRequired = false;
        return null;
      }

      if (fieldName === fieldStoreCodeBcon) {
        if (!formFields[fieldStoreCodeBcon].options) {
          formFields[fieldStoreCodeBcon].options = storeCodes.map(
            codeValue => ({
              fields: {
                label: codeValue,
                value: codeValue
              }
            })
          );
        }
        selectOptions = formFields[fieldStoreCodeBcon].options;
      }

      if (fieldName === fieldStoreCodeOutletBcon) {
        formFields[fieldStoreCodeOutletBcon].isDisabled = true;
      }

      if (
        fieldName === filedIsTheirAnyReasonToGoThroughMySOF ||
        fieldName === filedReasonForMySOFOrder
      ) {
        if (
          [
            valueIsEContractCustomer,
            valueNeedMoreThanSingleServiceAddress,
            valueNeedMediaAdvertisingBilling
          ].some(value => value === yes)
        ) {
          // formFields.isTheirAnyReasonToGoThroughMySOF.isRequired = false;
          formFields.reasonForMySOFOrder.isRequired = false;
          // formFields.isTheirAnyReasonToGoThroughMySOF.value = undefined;
          formFields.reasonForMySOFOrder.value = undefined;
          return null;
        }
        // eslint-disable-next-line no-else-return
        else {
          // formFields.isTheirAnyReasonToGoThroughMySOF.isRequired = true;
          formFields.reasonForMySOFOrder.isRequired = true;
        }
      }

      if (
        fieldName === fieldApprovalCodeWhiteGlove &&
        !isApprovalCodeFieldVisible()
      ) {
        formFields.approvalCodeWhiteGlove.value = undefined;
        return null;
      }
      if (
        fieldName === fieldApprovalCodeWhiteGlove &&
        isApprovalCodeFieldVisible()
      ) {
        isRequired = true;
      }

      // Business Connect Implementation page: mirror the Quote answer (read-only).
      if (
        fieldName === fieldHaveYouArrangedWhiteGloveTechnician &&
        isImplementationTechnicianLocked(formFields)
      ) {
        fieldValue = _.get(orderData, fieldHaveYouArrangedWhiteGloveTechnician);
        readonlyCheckbox = true;
      }

      // Match on the locale-independent key; `name` is translated in Contentful.
      if (
        id === repeatedFormKey &&
        fields.key === keyWhiteGloveLocations &&
        isAllValuesNoOdyssey
      ) {
        return false;
      }
      if (
        fieldName === groupDirectoryListing &&
        orderData[keyDirectoryListingType] &&
        orderData[keyDirectoryListingType].length === 0
      )
        return null;

      if (fieldName === fieldWhoIsTheExistingInternetProviderForOtherState)
        return null;

      if (
        fieldName === fieldeContractNumber &&
        (isc2fMigrationFlow || !_.get(orderData, 'assignedToSRT', 0))
      )
        return null;

      if (
        fieldName === fieldBAN &&
        !_.get(orderData, 'assignedToSRT', 0) &&
        !isOrderFulfillmentTeam
      )
        return null;

      if (
        fieldName === fieldBusinessConnectImplementationTollFreeNumber &&
        isc2fMigrationFlow &&
        !isOrderFulfillmentTeam
      )
        return null;    
      if (
        fieldName === fieldAdditionalRsiOptions &&
        !isAdditionalRsiOptionsAvailable()
      )
        return null;

      if (
        fieldName === fieldApprovalCodeWhiteGlove &&
        isc2fMigrationFlow &&
        valueInstallation === valueTelusProfessionalInstallation
      ) {
        formFields.approvalCodeWhiteGlove.isRequired = false;
        return null;
      }

      if (fieldName === fieldIsSrtTeamMember && (!isSalesRep || isThisOdysseyAIOrder)) {
        return null;
      }

      // For exempt outlets the Customer Readiness Checklist upload is optional:
      // de-require the field so the required indicator (asterisk) is not shown.
      if (
        fieldName === fieldUploadCustomerReadinessChecklist &&
        readinessChecklistExemptOutletIds.includes(String(outletId))
      ) {
        isRequired = false;
        fields.required = false;
        if (formFields[fieldUploadCustomerReadinessChecklist]) {
          formFields[fieldUploadCustomerReadinessChecklist].isRequired = false;
        }
      }

      const valueSegment = _.get(orderData, fieldCustomerSegment, '');
      const valueOtherTelusServices = getFieldValue(
        fieldOtherTelusServices,
        formFields
      );

      if (fieldName === fieldVbpRequired && userChannelName === CORP_STORE) {
        formFields[fieldVbpRequired].isRequired = false;
        return null;
      }
      if (
        fieldName === fieldVbpRequired &&
        (
          ([valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment) && valueOtherTelusServices === no) ||
          isThisOdysseyAIOrder
        )
      ) {
        formFields[fieldVbpRequired].value = undefined;
        formFields[fieldVbpRequired].isRequired = false;
        return null;
      }

      // Hide couponBasedDiscountOdysseyAI for non-OdysseyAI orders
      if (fieldName === fieldCouponBasedDiscountOdysseyAI && !isThisOdysseyAIOrder) {
        return null;
      }

      const profSvcAiChatOrContactSelected =
        isThisOdysseyAIOrder &&
        isOdysseyAiChatOrContactCentreLineSelected(formFields);

      if (
        fieldName === fieldProfessionalServicesFileCharges ||
        fieldName === fieldProfessionalServicesFileNote
      ) {
        if (!profSvcAiChatOrContactSelected) return null;
      }

      if (fieldName === fieldProfessionalServicesFile) {
        if (!profSvcAiChatOrContactSelected) {
          if (formFields[fieldProfessionalServicesFile]) {
            formFields[fieldProfessionalServicesFile].isRequired = false;
          }
          fields.required = false;
          return null;
        }
        if (formFields[fieldProfessionalServicesFile]) {
          formFields[fieldProfessionalServicesFile].isRequired = true;
        }
        fields.required = true;
        isRequired = true;
      }

      if (fieldName === fieldNumberOfSeatsThatRequireWhiteGloveAI) {
        const limitedExtQty =
          Number(
            getFieldValue(limitedExtensionOdysseyAIOdysseyAI, formFields) ||
              _.get(orderData, limitedExtensionOdysseyAIOdysseyAI, '')
          ) || 0;
        const isProfessionalInstall =
          getFieldValue(fieldDoesTheCustomerRequireWhiteGlove, formFields) ===
          valueTelusProfessionalInstallation;
        if (
          !isThisOdysseyAIOrder ||
          limitedExtQty <= 0 ||
          !isProfessionalInstall
        ) {
          return null;
        }
      }

     if (isThisOdysseyAIOrder) {
      // AI Insights + Contact Centre suite fields are only valid for Voice Plus,
      // Enhanced and Complete editions. Hide and de-require them for Mobile / Voice.
      if (
        [mobile, voice].includes(
          getFieldValue(fieldBusinessConnectEdition, formFields)
        ) &&
        isOdysseyAiVoicePlusOnlyFieldName(fieldName)
      ) {
        if (formFields[fieldName]) {
          formFields[fieldName].isRequired = false;
        }
        return null;
      }

      if (singleSelectChatFields.includes(fieldName)) {
        const checkValueIsTrue = singleSelectChatFields.some(
          field => formFields[field].checked
        );

        if (checkValueIsTrue) {
          readonlyCheckbox = !formFields[fieldName].checked;
        }
      }

      if (hideChatFieldsForOdysseyAI.includes(fieldName)) {
        const selectedField = singleSelectChatFields.find(
          field => formFields[field].checked
        );

        if (selectedField) {
          const isChatNameTypes = chatNameTypes.includes(selectedField);
          const isChatConcurrentTypes = chatConcurrentTypes.includes(
            selectedField
          );

          if (
            (isChatNameTypes &&
              hideChatFieldsForConcurrentOdysseyAI.includes(fieldName)) ||
            (isChatConcurrentTypes &&
              hideChatFieldsForNamedOdysseyAI.includes(fieldName))
          ) {
            readonlyCheckbox = true;
          }
        } else if (!selectedField) {
          readonlyCheckbox = true;
        }
      }

      // Hide the multiSide field for prequalification section in Odyssesy Ai flow
       if (fieldName === fieldMultisiteOrder) {
         formFields[fieldMultisiteOrder].isRequired = false;
         formFields[fieldMultisiteOrder].value = undefined;
         return null;
       }

       if (fieldName === fieldSigningEmailAuthority) {
         if (!isDealer || orderData.dueMonthlyOdysseyAI < 30000) {
           formFields[fieldSigningEmailAuthority].isRequired = false;
           return null;
         }
         formFields[fieldSigningEmailAuthority].isRequired = true;
       }

       if (
         [fieldAssistantAiOdysseyAI, fieldAssistantAiOdysseyAIOdysseyAI].includes(
           fieldName
         )
       ) {
         const isOdysseyAIEnhancedOrComplete =
           syncOdysseyAiAssistantFields(formFields);
         if (fieldName === fieldAssistantAiOdysseyAI && isOdysseyAIEnhancedOrComplete) {
           readonlyCheckbox = true;
         }
         if (!isOdysseyAIEnhancedOrComplete) {
           return null;
         }
       }

      if (odysseyAiSupervisorSyncTriggerFields.includes(fieldName)) {
        syncOdysseyAiSupervisorAssistFields(formFields);
      }

     }

      if (fieldName === fieldMultisiteOrder && !isThisOdysseyAIOrder) {
        formFields[fieldMultisiteOrder].isRequired = true;
      }

      if (fieldName === fieldVbpRequired) {
        const totalSeats =
          Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
          Number(getFieldValue(fieldOfficeSeats, formFields) || 0);

        const valueSegment = _.get(orderData, fieldCustomerSegment, '');

        if (
          totalSeats < 1 &&
          [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)
        ) {
          formFields[fieldVbpRequired].value = undefined;
          formFields[fieldVbpRequired].isRequired = false;
          return null;
        }
        formFields[fieldVbpRequired].isRequired = true;
      }

      if (
        fieldName === 'TransferBusinessOwnership' &&
        channelCode === 'DEALER'
      ) {
        formFields.TransferBusinessOwnership.isRequired = false;
        return null;
      }

      if (type === 'MultiCheckbox') {
        selectOptions = formFields[fieldName].options;
      }

      if (fieldName === fieldAvailableDiscountsAndPromotions) {
        if (
          !(formFields[fieldName].value && formFields[fieldName].value.length)
        ) {
          if (formFields[fieldName].options.length) {
            formFields[fieldName].options.forEach((item, i) => {
              formFields[fieldName].options[i].checked = false;
            });
          }
        }
        selectOptions = getPromotionList(
          formFields[fieldName].options,
          formFields
        );
      } else if (fieldName === fieldHowCustomerWantToPayForWhiteGlove) {
        // AI add-on TPI note: only while an AI Install box is checked (spec 034).
        if (isThisOdysseyAIOrder && isAnyAiInstallFieldChecked(formFields)) {
          const noteKey =
            valueSegment === valueSegmentCommercial
              ? 'aiTpiCommercialNote'
              : 'aiTpiSmbNote';
          const noteText = _.get(localizedStrings, `quoteForm.${noteKey}`, '');
          fieldNote = {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                data: {},
                content: [
                  { nodeType: 'text', value: noteText, marks: [], data: {} }
                ]
              }
            ]
          };
        }
        // Dealer Billed Direct is available to all channels and segments
        // unless the approval code (NBD technician) is required.
        selectOptions = filterTpiPaymentOptions(fields.options, {
          approvalRequired: isApprovalCodeFieldVisible(),
          valueDealerBilledDirect
        });
        /**
         * Add TELUS Prof. Installation CO Turndown Promo
         * to WG payment method when C2F migration flow is yes
         * or else hide it
         */
        if (!isc2fMigrationFlow) {
          selectOptions = selectOptions.filter(
            item => item.fields.value !== valueInstallationCoTurndownPromo
          );
        }
      } else if (fieldName === fieldContractStartDate) {
        fieldDateConfig.minDays = 0;
        if (!isRecontractFlow) fieldDateConfig.maxDays = 10;
      } else if (fieldName === fieldDriversLicenseExpiry) {
        fieldDateConfig.minDays = 0;
      } else if (fieldName === fieldDateOfBirth) {
        fieldDateConfig.maxDays = 0;
      }
      // else if (
      //   fieldName === fieldContractTerm &&
      //   getFieldValue(fieldBusinessConnectEdition, formFields) === mobile
      // ) {
      //   selectOptions = fields.options.filter(
      //     item => item.fields.value === monthToMonth
      //   );
      // }
      else if (
        fieldName === fieldContractTerm &&
        (_.get(orderData, fieldIsThisOrderAPartOfTELUSWorkplace, '') === yes ||
          isRecontractFlow)
      ) {
        selectOptions = fields.options.filter(
          item => item.fields.value !== monthToMonth
        );
      } else if (fieldName === fieldBusinessConnectEdition) {
        let editionList = fields.options.filter(
          item =>
            item.fields.value !== voice ||
            (item.fields.value === voice && isc2fMigrationFlow)
        );

        const valueRecontractChangeEdition = getFieldValue(
          fieldRecontractChangeEdition,
          formFields
        );
        const valueSegment = _.get(orderData, fieldCustomerSegment, '');
        const isThreeOrFiveYears = [fiveYears].includes(
          getFieldValue(fieldContractTerm, formFields)
        );

        const shouldNotFilterMobile =
          isRecontractFlow &&
          [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
            valueSegment
          ) &&
          valueRecontractChangeEdition === no &&
          isThreeOrFiveYears;

        /**
         * Filter mobile editions
         * when recontract flow, SMB(1-30, 30-100)
         * recontract change edition = no
         * terim either 3 or 5 years
         * show mobile edition
         * else for term 3 or 5 in other flows dont show mobile edition
         */
        if (isThreeOrFiveYears && !shouldNotFilterMobile) {
          editionList = editionList.filter(
            item => item.fields.value !== mobile
          );
        }

        /**
         * Filter editions to Voice & Voice +
         * when C2F migration flow is yes
         */
        if (isc2fMigrationFlow) {
          editionList = editionList.filter(item =>
            [voice, voicePlus].includes(item.fields.value)
          );
        } else if (isThisMobileEditionOrder) {
          editionList = editionList.filter(
            item => item.fields.value === mobile
          );
        }

        selectOptions = editionList;
      } else if (fieldName === fieldVbpRequired) {
        const valueAvailableDiscountsAndPromotions =
          getFieldValue(fieldAvailableDiscountsAndPromotions, formFields) || [];
        if (
          valueAvailableDiscountsAndPromotions.includes(valueThreeMonthsFree)
        ) {
          selectOptions = fields.options.filter(
            item => item.fields.value === no
          );
        }
      } else if (
        fieldName === fieldExistingBusinessConnectBANNumber &&
        isMultisiteOrder &&
        currentSite > 1 &&
        !isOrderFulfillmentTeam
      ) {
        isRequired = false;
        return null;
      } else if (
        fieldName === fieldNumberOfSitesThatRequireWhiteGlove &&
        isMultisiteOrder &&
        _.get(
          orderData,
          fieldDoesTheCustomerRequireWhiteGlove,
          valueTelusVirtualInstallation
        ) === valueTelusProfessionalInstallation
      )
        fieldValue = 1;
      else if (
        fieldName === fieldTypeOfInstallation &&
        isMultisiteOrder &&
        currentSite > 1
      )
        selectOptions = fields.options.filter(item =>
          [valueAddon].includes(item.fields.value)
        );
      else if (
        fieldName === fieldNumberOfSitesThatRequireWhiteGlove &&
        isMultisiteOrder &&
        _.get(
          orderData,
          fieldDoesTheCustomerRequireWhiteGlove,
          valueTelusVirtualInstallation
        ) === valueTelusProfessionalInstallation
      )
        fieldValue = 1;
      else if (fieldName === fieldDealerNote && !isDealer) return null;
      else if (
        fieldName === fieldUploadCustomerReadinessChecklist &&
        !isReadinessChecklistAvailable()
      )
        return null;
      if (
        fieldName === fieldExistingBusinessConnectBANNumber &&
        (isAllValuesNoOdyssey || isThisOdysseyAIOrder)
      ) {
        fields.label = existingBusinessConnectOdysseyBAN;
      }
      /**
       * Filter provinces to AB & BC
       * when C2F migration flow is yes
       */
      const valueVulcanOrderYes = getFieldValue(fieldVulcanOrder, formFields);
      if (valueVulcanOrderYes === yes || orderData.vulcanOrder === yes) {
        if (fieldName === fieldCustomerSegment) {
          selectOptions = fields.options.filter(item =>
            [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
              item.fields.value
            )
          );
        }
        if (fieldName === fieldOtherTelusServices) {
          formFields[fieldOtherTelusServices].value = yes;
        }
        if (fieldName === fieldEExistingTelusServices) {
          formFields[fieldEExistingTelusServices].value =
            'TELUS PureFibre Order';
        }
        if (fieldName === fieldContractTerm) {
          selectOptions = fields.options.filter(item =>
            [threeYears].includes(item.fields.value)
          );
        }
        if (fieldName === fieldCustomerAdvisoriesCurrentSpeedNotSupportUsers) {
          return null;
        }
        if (fieldName === fieldTypeOfInstallation) {
          selectOptions = fields.options.filter(item =>
            [valueNew].includes(item.fields.value)
          );
        }
        if (fieldName === fieldProvinceOfTheOrder) {
          selectOptions = fields.options.filter(item =>
            [valueOntario, valueQuebec].includes(item.fields.value)
          );
        }
      }

      /**
         * Filter custom pricing
         * when commercial
         * edition = voice plus
         */
      const editionValue = getFieldValue(fieldBusinessConnectEdition, formFields);

        if (    
            fieldName === 'vpbOfficeSeatRate_voicePlus' &&
            valueSegment !== valueSegmentCommercial &&
            editionValue === voicePlus
        ) {
          selectOptions = fields.options.filter(item =>
             item.fields.value !== '14');
        }

      if (fieldName === fieldRecontractCustomer) {
        if (isUserProfileChannelDealer) {
          // eslint-disable-next-line no-param-reassign
          formFields[fieldRecontractCustomer].value = no;
          fields.required = false;
          formFields[fieldRecontractCustomer].isRequired = false;
          return null;
        }
        // eslint-disable-next-line no-param-reassign
        fields.required = true;
        formFields[fieldRecontractCustomer].isRequired = true;
      }

      if (fieldName === fieldCoperToFibreMigration) {
        if (
          formFields[fieldRecontractCustomer].value.includes(yes) ||
          formFields['vulcanOrder'].value.includes(yes)
        ) {
          formFields[fieldCoperToFibreMigration].value = undefined;
          formFields[fieldCoperToFibreMigration].isRequired = false;
          fields.required = false;
        } else {
          formFields[fieldCoperToFibreMigration].isRequired = true;
          fields.required = true;
        }
      }

      if (
      fieldName === fieldRCIDOdyssey &&
      isThisOdysseyAIOrder
    ) {
      formFields[fieldRCIDOdyssey].isRequired = false;
      fields.required = false;
    }

      if (fieldName === 'coperToFibreMigration') {
        const valueRecontractCustomer = getFieldValue(
          fieldRecontractCustomer,
          formFields
        );
        if (
          (valueRecontractCustomer !== no && !isUserProfileChannelDealer) ||
          formFields['vulcanOrder'].value.includes(yes)
        ) {
          return null;
        }
      }

      if (
        (fieldName === fieldVbpNumberFreePromotions ||
        fieldName === fieldVbpApprovedCustomOffer ||
        fieldName === fieldVbpApprovalEmailAttachment) &&
        valueSegment === valueSegmentCommercial
      ) {
        formFields[fieldVbpNumberFreePromotions].isRequired = false;
        formFields[fieldVbpApprovedCustomOffer].isRequired = false;
        formFields[fieldVbpApprovalEmailAttachment].isRequired = false;
        fields.required = false;
        return null;
      }

      if (
        fieldName === fieldVbpNumberFreePromotionsCommercial &&
        [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(valueSegment)
      ) {
        formFields[fieldVbpNumberFreePromotionsCommercial].isRequired = false;
        fields.required = false;
        return null;
      }

      if (fieldName === fieldProvinceOfTheOrder) {
        const valueRecontractCustomer = getFieldValue(
          fieldRecontractCustomer,
          formFields
        );
        const valueCoperToFibreMigration = getFieldValue(
          fieldCoperToFibreMigration,
          formFields
        );
        if (valueCoperToFibreMigration === yes) {
          selectOptions = fields.options.filter(item =>
            [valueAlberta, valueBritishColumbia].includes(item.fields.value)
          );
        }
        if (valueRecontractCustomer === yes) {
          selectOptions = fields.options.filter(
            item =>
              ![valueNorthwestTerritories, valueYukon, valueNunavut].includes(
                item.fields.value
              )
          );
        }
      }

      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${index}${sysId}`;
      let result;

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields)) return null;

      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(itemFields, formFields)
          );
        });

        /** Logic for prequalification. If C2F flow then hide rest of the non C2F Fields */
        if (fields.name === fieldGroupNonC2FFlow) {
          const valueCoperToFibreMigration = getFieldValue(
            fieldCoperToFibreMigration,
            formFields
          );

          if (valueCoperToFibreMigration !== no) {
            return null;
          }
        }

        if (typeof groupIsVisible !== 'undefined') {
          const groupFields = renderFormFields(fields.fields);
          if (fieldName === 'advisory') {
            result = groupFields.filter(item => item).length > 0 && (
              <GroupWrapperStyled key={key}>{groupFields}</GroupWrapperStyled>
            );
          } else {
            let reContractSeatHead;
            if (fieldName === 'groupSeats' && isRecontractFlow) {
              const valueRecontractAddSubtractSeats = getFieldValue(
                fieldRecontractAddSubtractSeats,
                formFields
              );
              if (valueRecontractAddSubtractSeats === valueYesLookingToAddSeats)
                reContractSeatHead = labelUpdatedTotalNumberOfSeats;
              if (
                valueRecontractAddSubtractSeats ===
                valueYesLookingToSubrtactSeats
              )
                reContractSeatHead = labelUpdatedTotalNumberOfSeats;
              if (valueRecontractAddSubtractSeats === no)
                reContractSeatHead = labelCurrentNumberOfSeats;
              result = valueRecontractAddSubtractSeats &&
                groupFields.filter(item => item).length > 0 && (
                  <GroupWrapper key={key}>
                    {title && <GroupTitle>{reContractSeatHead}</GroupTitle>}
                    {groupFields}
                  </GroupWrapper>
                );
            } else {
              result = groupFields.filter(item => item).length > 0 && (
                <GroupWrapper key={key}>
                  {title && <GroupTitle>{title}</GroupTitle>}
                  {groupFields}
                </GroupWrapper>
              );
            }
          }
        }
      } else if (id === formSection) {
        const { note, formSummaryGroup, isPanelInitiallyOpen } = fields;

        readonly =
          !isMultisiteOrder &&
          isOrderFulfillmentTeam &&
          ![fieldCustomerInformation, fieldOfferConfiguration].includes(
            fieldName
          );

        result = sectionIsVisible(fieldName) && (
          <ExpandCollapse
            initialOpen={isPanelInitiallyOpen ? [fieldName] : []}
            topDivider={false}
          >
            {(expandProps) => (
              <ExpandCollapse.Panel {...expandProps} key={key} panelId={fieldName} control={<SectionHeaderTitle><Typography variant={{ bold: true }}>{title}</Typography></SectionHeaderTitle>}>
            <>
              <Divider space={1} variant={{ inverse: true }} />
              {note && note.content && <Note data={note} type="richText" />}
              {formSummaryGroup
                ? renderFormSummary(formSummaryGroup)
                : renderFormFields(fields.formFields)}
            </>
              </ExpandCollapse.Panel>
            )}
          </ExpandCollapse>
        );
      } else if (id === userDetailsKey) {
        if (isRecontractFlow && fields.backendKey === fieldServiceAddress) {
          // eslint-disable-next-line no-param-reassign
          fields.name = 'Billing Address';
        }
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            resetSelectedFields={resetSelectedFields}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            isAllValuesNoOdyssey={isAllValuesNoOdyssey}
            formFields={formFields}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            isMultisiteOrder={isMultisiteOrder}
          />
        );
      } else if (id === seatDetailsFormKey) {
        result = (
          <SeatDetailsForm
            key={key}
            data={fields}
            orderData={orderData}
            updateStep={updateStep}
            step={step}
            setOrderData={setOrderData}
            onSaveAndExit={onSaveAndExit}
            isOrderFulfillmentTeam={isOrderFulfillmentTeam}
            prevStep={prevStep}
          />
        );
      } else {
        const fieldButtonProps =
          fields.type === 'Button'
            ? {
                modalForms,
                formFields,
                setFormFields,
                dueNow,
                setDueNow,
                dueMonthly,
                setDueMonthly,
                setIsFormTouched,
                setIsFormValidated,
                isOrderFulfillmentTeam,
                isDevicesPromo: isDevicesPromo(formFields),
                isHardwareCreditPromo: isHardwareCreditPromo(formFields)
              }
            : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }

        /**
         * If MSFT Directing routing is selected then display
         * a warning message AND if total seats are less then 25
         * then display another warning message
         */
        if (fieldName === fieldMsftDirectRouting) {
          if (!getFieldChecked(fieldMsftDirectRouting, formFields)) {
            fieldNote = '';
            fieldNote2 = '';
          } else {
            const valueStarterSeat = getFieldValue(
              fieldStarterSeat,
              formFields
            );
            const valueOfficeSeat = getFieldValue(fieldOfficeSeats, formFields);
            if (+valueStarterSeat + +valueOfficeSeat > 25) fieldNote2 = '';
          }
        }

        /**
         * if C2F Automated Action is required then
         * default installation type to New and disable Add On option
         */
        if (
          fieldName === fieldTypeOfInstallation &&
          _.get(orderData, fieldC2fAutomatedActivation, '') === yes
        ) {
          fieldValue = valueNew;
          selectOptions = fields.options.map(option => {
            const optionCopy = { ...option };
            if (_.get(option, 'fields.value', '') === valueAddon) {
              optionCopy.fields.disabled = true;
            }
            return optionCopy;
          });
        }

        if (fieldName === fieldNumberOfSeatsThatRequireWhiteGlove)
          isDisabled = true;

        if (fieldName === fieldNumberOfSeatsThatRequireWhiteGloveAI)
          isDisabled = true;

        // Spec 034 item 4: one site per order (current system limitation).
        if (fieldName === fieldNumberOfSitesThatRequireWhiteGlove) {
          fieldValue = 1;
          isDisabled = true;
        }

        if (
          isc2fMigrationFlow &&
          fieldName === fieldDoesTheCustomerRequireWhiteGlove
        ) {
          selectOptions = fields.options.filter(
            option => option.fields.value !== valueTelusVirtualInstallation
          );
        }

        if (
          fieldName === fieldDoesTheCustomerRequireWhiteGlove &&
          getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon
        ) {
          selectOptions = fields.options.filter(
            option => option.fields.value !== valueTelusVirtualInstallation
          );
        }

        if (
          fieldName === fieldDoesTheCustomerRequireWhiteGlove &&
          getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon
        ) {
          selectOptions = fields.options.filter(
            option => option.fields.value !== valueTelusVirtualInstallation
          );
        }

        if (
          fieldName === fieldDoesTheCustomerRequireWhiteGlove &&
          (isThisMobileEditionOrder ||
            getFieldValue(fieldBusinessConnectEdition, formFields) === mobile)
        ) {
          const optionsToRemove = [
            valueTelusVirtualInstallation,
            valueTelusProfessionalInstallation
          ];
          selectOptions = fields.options.filter(
            option => !optionsToRemove.includes(option.fields.value)
          );
        }
        const totalSeats =
          Number(getFieldValue(fieldStarterSeat, formFields) || 0) +
          Number(getFieldValue(fieldOfficeSeats, formFields) || 0);
        const valueBusinessConnectEdition = getFieldValue(
          fieldBusinessConnectEdition,
          formFields
        );
        const isVirtualInstallationVisible =
          [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
            valueSegment
          ) &&
          getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon &&
          totalSeats <= 99 &&
          fieldName === fieldDoesTheCustomerRequireWhiteGlove &&
          (isThisMobileEditionOrder || valueBusinessConnectEdition === mobile);

        if (isVirtualInstallationVisible) {
          const optionsToRemove = [valueTelusProfessionalInstallation];
          selectOptions = fields.options.filter(
            option => !optionsToRemove.includes(option.fields.value)
          );
        }
        const isVirtualInstallation =
          [valueSegmentSmb1To30, valueSegmentSmb30To100].includes(
            valueSegment
          ) &&
          getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon &&
          totalSeats <= 99 &&
          fieldName === fieldDoesTheCustomerRequireWhiteGlove &&
          [complete, completePlus, voicePlus, enhanced].includes(
            valueBusinessConnectEdition
          );

        if (isVirtualInstallation) {
          const optionsToShow = [valueTelusProfessionalInstallation, valueTelusVirtualInstallation, valueNoInstall];
          selectOptions = fields.options.filter(
            option => optionsToShow.includes(option.fields.value)
          );
        }

        if (
          fieldName === fieldPreferredInstallationDate &&
          _.get(orderData, fieldDoesTheCustomerRequireWhiteGlove, '') ===
            valueNoInstall
        ) {
          return null;
        }

        if (
          isMultisiteOrder &&
          currentSite > 1 &&
          fieldName === fieldDoesTheCustomerRequireWhiteGlove
        ) {
          selectOptions = fields.options.filter(
            item => ![valueTelusVirtualInstallation].includes(item.fields.value)
          );
        }

        const fieldData = {
          ...fields,
          options: selectOptions || fields.options,
          ...fieldButtonProps,
          ref,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          required: isRequired,
          note: fieldNote,
          note2: fieldNote2,
          sysId,
          onChange: (e, isFieldModified = true, fileUploded) =>
            handleFormField(e.target, isFieldModified, fileUploded),
          fieldDateConfig,
          readonly: readonly || readonlyCheckbox,
          formFields,
          setFormFields,
          setOrderData,
          resetSelectedFields,
          orderData,
        };

        if (fields.type === 'Checkbox') {
          fieldData.checked = formFields[fieldName].checked;
          // The Self/Virtual/Professional Installation acknowledgment checkboxes
          // act as section headers for the advisory bullet notes that follow
          // them, so bold their label even though Contentful's isLabelBold
          // flag isn't set on these entries.
          if (
            fieldName.startsWith('customerAdvisories_') &&
            /install/i.test(fieldName)
          ) {
            fieldData.isLabelBold = true;
          }
        }

        if (
          fieldName === fieldInsightsOdysseyAIOdysseyAI &&
          isInsightsZeroSeatWarningActive()
        ) {
          fieldData.note = buildPlainTextNote(insightsZeroSeatsWarning);
          fieldData.noteType = 'error';
          fieldData.noteAppearsBelowField = true;
        }

        if (fieldName === fieldContractTerm && isRecontractFlow) {
          fieldData.label = labelNewContractTerm;
        }
        if (fieldName === fieldContractStartDate && isRecontractFlow) {
          fieldData.label = labelRecontractStartDate;
        }

        if (fieldName === fieldBusinessConnectEdition) {
          const valueRecontractChangeEdition = getFieldValue(
            fieldRecontractChangeEdition,
            formFields
          );
          if (valueRecontractChangeEdition === yes)
            fieldData.label = labelNewBusinessConnectEdition;
          if (valueRecontractChangeEdition === no)
            fieldData.label = labelCurrentBusinessConnectEdition;
        }

        if (isThisOdysseyAIOrder) {
          if (fieldName === fieldBusinessConnectEdition) {
            fieldData.options = fieldData.options.filter(
              item => item.fields.value !== completePlus
            );
          }
        }

        result = (
          <>
            {fieldName === fieldOptOutFromGSuiteBusinessLicenses && (
              <div style={{ marginTop: '1em', marginBottom: '1em' }}>
                {stringInterpolation(
                  gSuiteNote,
                  gSuiteBusinessLicences(formFields)
                ).concat(` ${gSuiteNote2}`)}
              </div>
            )}
            {fieldName === fieldAvailableDiscountsAndPromotions && (orderData.coperToFibreMigration !== yes || !orderData.coperToFibreMigration) && (
              <CouponButton
                formFields={formFields}
                orderData={orderData}
                onChange={(e) => {
                  if (e.target.isOrderDataUpdate) {
                    setOrderData(prevOrderData => ({
                      ...prevOrderData,
                      [e.target.name]: e.target.value
                    }));
                  } else {
                    handleFormField(e.target, true);
                  }
                }}
                readonly={readonly}
                appliedCoupons={appliedCoupons}
                setAppliedCoupons={setAppliedCoupons}
                setIsFormTouched={setIsFormTouched}
                isFormValidated={isFormValidated}
                setIsFormValidated={setIsFormValidated}
                isCouponButtonVisible = {(!isMultisiteOrder || currentSite === 1) && !isThisOdysseyAIOrder}
                currentSite={currentSite}
                isMultisiteOrder={isMultisiteOrder}
              />
            )}
            <FormField
              key={key}
              orderData={orderData}
              data={fieldData}
              error={error && error.text}
            />
          </>
        );
      }

      return result;
    });

  const getSummary = () => {
    if (formSummary) {
      const {
        fields: { formSummaryGroup }
      } = formSummary;

      return formSummaryGroup.map((summaryGroup, index) => {
        const {
          fields: { name, formFields: summaryGroupFields }
        } = summaryGroup;
        const key = `formSummaryGroup${index}`;

        return (
          <Fragment key={key}>
            <h1>{name}</h1>
            <SummaryGroupWrapper>
              {summaryGroupFields.map((summaryGroupField, idx) => {
                const {
                  fields: { name: fieldName, label: fieldLabel }
                } = summaryGroupField;
                const summaryGroupFieldKey = `summaryGroupField${idx}`;

                return (
                  <div key={summaryGroupFieldKey}>
                    <span style={{ fontWeight: '400' }}>{fieldLabel}</span>:{' '}
                    {formFields[fieldName].value}
                  </div>
                );
              })}
            </SummaryGroupWrapper>
          </Fragment>
        );
      });
    }

    return Object.keys(formFields).map((item, index) => {
      const key = `summary${index}`;

      return (
        formFields[item].isVisible && (
          <div key={key}>
            <span style={{ fontWeight: '400' }}>{item}</span>:{' '}
            {formFields[item].value}
          </div>
        )
      );
    });
  };
    
  useEffect(() => {
    if (dueNow < 0) setDueNow(0);
  }, [dueNow]);

  if (isLoading) return null;

  return (
    <div ref={formStepRef} style={{ width: '100%' }}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          formName={formName}
        />
      )}
      {formErrorSummary && (
        <div style={{ padding: '1rem 1.5rem' }}>
          <Notification
            variant={{ validation: 'error' }}
            dismissible
            onExit={() => setFormErrorSummary('')}
          >
            {formErrorSummary}
          </Notification>
        </div>
      )}
      {isMultisiteOrder && (
        <div style={{ padding: '0.5rem 1.5rem', backgroundColor: '#4b286d' }}>
          <Typography heading="h3" variant={{ size: 'h3' }}>
            <span style={{ fontSize: '1.75rem', fontWeight: '500', color: '#fff' }}>
              {isLastStep ? multisiteSummaryLabel : `${siteLabel} ${currentSite}`}
            </span>
          </Typography>
        </div>
      )}
      <div style={{ backgroundColor: '#fff' }}>
        <form
          name={formStepName}
          onSubmit={e => e.preventDefault()}
          encType="multipart/form-data"
        >
          <Box
            style={{
              border: '1px solid #e3e3e3',
              boxShadow: '1px 1px 9px 4px #e3e3e3',
              padding: '2rem',
              marginBottom: '1rem'
            }}
          >
            {sections.length ? (
              <div className="expand">
                <ExpandCollapse initialOpen={[]} tag="h2" topDivider={false}>
                  {(expandProps) =>
                    isMultisiteOrder && isLastStep
                      ? multiSiteOrderSummaryData &&
                        renderMultiSiteSummary(formStepFields, expandProps)
                      : renderFormFields(formStepFields)
                  }
                </ExpandCollapse>
              </div>
            ) : (
              <div style={{ width: '100%' }}>
                {formStepFields ? (
                  renderFormFields(formStepFields)
                ) : (
                  <>
                    <Typography heading="h3" variant={{ size: 'h3' }} block>{summaryLabel}</Typography>
                    {getSummary()}
                  </>
                )}
              </div>
            )}
          </Box>
        </form>
        {(![1, 2, 3].includes(step) || showFormButtons) && (
          <>
            {isMultisiteOrder ? (
              <FormButtonsMultisite
                isFormTouched={isFormTouched}
                showSave={!isOrderFulfillmentTeam && onSaveAndExit}
                orderData={orderData}
                isSalesSupport={isSalesSupport}
                isLastStep={isLastStep}
                isSecondLastStep={isSecondLastStep}
                nextStep={nextStep}
                prevStep={prevStep}
                saveAndExit={saveAndExit}
                currentSite={currentSite}
                totalNumberOfMultisites={totalNumberOfMultisites}
                isSubmitting={isSubmitting}
              />
            ) : (
              <FormButtons
                isFormTouched={isFormTouched}
                showSave={!isOrderFulfillmentTeam && onSaveAndExit}
                orderData={orderData}
                isSalesSupport={isSalesSupport}
                isLastStep={isLastStep}
                isSecondLastStep={isSecondLastStep}
                nextStep={nextStep}
                prevStep={prevStep}
                saveAndExit={saveAndExit}
                formName={formName}
                isSubmitting={isSubmitting}
              />
            )}
          </>
        )}
      </div>
      {formName === businessConnectQuoteToolForm && (
        <div
          className="container 85%"
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {/* SOF-3356 R-006 / FR-006: SMs with `canSubmitOrders === true` MUST
              see the New Order CTA. Other pre-existing exclusions (OFT,
              Proposal House, SMs without order access) are preserved. */}
          {!isOrderFulfillmentTeam && !isProposalHouse && (!isSalesManager || canSubmitOrders()) && (
            <Button
              type="button"
              onPress={nextStep}
              variant={{ priority: 'high' }}
              disabled={isSubmitting || !prequalEligibility.isEligible}
              style={{ marginBottom: '1em' }}
            >
              {isSubmitting ? submittingButtonLabel : newOrderButtonLabel}
            </Button>
          )}
        </div>
      )}
      {formName === orderDetailsForm && step === 1 && (
        <StatusBar
          isSendToSRT={isSendToSRT}
          isVBP={isVBP}
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          isOrderFulfillmentTeam={isOrderFulfillmentTeam}
          isSalesSupport={isSalesSupport}
          dueMonthly={dueMonthly}
          dueNow={dueNow}
          onSaveAndExit={saveAndExit}
          onDownloadClick={onViewPdf}
          onProceedClick={nextStep}
          onValidateForm={validateForm}
          onSendToSRT={onSendToSRT}
          onSubmitForApproval={onSubmitForApproval}
          hidePricing={
            getFieldValue(fieldTypeOfInstallation, formFields) === valueAddon
          }
          statusQuote={_.get(orderData, 'quoteStatus', '')}
          isFieldReset={isFieldReset}
          isSubmitting={isSubmitting}
        />
      )}
      {
        <Modal
          isOpen={modalData.open}
          onClose={() => setModalData({ ...modalData, open: false })}
        >
          {modalData.title && (
            <>
              <Typography variant={{ size: 'h2' }}>{modalData.title}</Typography>
              <Spacer space={1} />
            </>
          )}
          <p>{modalData.body}</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <Button
              type="button"
              variant={{ priority: 'low' }}
              onPress={() => setModalData({ ...modalData, open: false })}
            >
              {modalData.cancelText}
            </Button>
            <Button
              type="button"
              variant={{ priority: 'high' }}
              onPress={() =>
                history.push({
                  pathname: '/'
                })
              }
            >
              {modalData.confirmText}
            </Button>
          </div>
        </Modal>
      }
    </div>
  );
};

FormStep.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.objectOf(PropTypes.object).isRequired
  }).isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setEligible: PropTypes.func,
  eligible: PropTypes.objectOf(PropTypes.any).isRequired,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.objectOf(PropTypes.any),
  hideProgressBar: PropTypes.bool,
  setOrderData: PropTypes.func,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  onSave: PropTypes.func,
  onViewPdf: PropTypes.func,
  sendToSRT: PropTypes.func,
  submitForApproval: PropTypes.func,
  prevStep: PropTypes.func.isRequired,
  showFormButtons: PropTypes.bool,
  currentSite: PropTypes.number.isRequired,
  isMultisiteOrder: PropTypes.bool.isRequired,
  totalNumberOfMultisites: PropTypes.number.isRequired
};

FormStep.defaultProps = {
  updateStep: () => {},
  setEligible: null,
  onFormSubmit: null,
  orderData: {},
  onSaveAndExit: null,
  hideProgressBar: false,
  setOrderData: () => {},
  onSave: null,
  onViewPdf: null,
  sendToSRT: null,
  submitForApproval: null,
  showFormButtons: null
};

export default FormStep;
